/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  contact_type: { input: any; output: any; }
  float8: { input: any; output: any; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AddressPatch = {
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type ApplyResponse = {
  __typename?: 'ApplyResponse';
  applied: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type ClientPatch = {
  fullname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ClientPhoneResponse = {
  __typename?: 'ClientPhoneResponse';
  phone: Scalars['String']['output'];
};

export type DartApiResponse = {
  __typename?: 'DartAPIResponse';
  user?: Maybe<User>;
  userKey: Scalars['String']['output'];
};

export type FcmInput = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrderItemInput = {
  productId: Scalars['String']['input'];
  qty: Scalars['Int']['input'];
};

export type OrderItemOutput = {
  __typename?: 'OrderItemOutput';
  deliveryPrice?: Maybe<Scalars['Int']['output']>;
  orderItems?: Maybe<Scalars['jsonb']['output']>;
};

export type OrderPatch = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  plannedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  plannedDateDuration?: InputMaybe<Scalars['Int']['input']>;
  refuseReason?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleInput = {
  departmentId: Scalars['Int']['input'];
  disabledExpressReason?: InputMaybe<Scalars['String']['input']>;
  isExpressEnabled: Scalars['Boolean']['input'];
};

export type ToggleResponse = {
  __typename?: 'ToggleResponse';
  departmentId: Scalars['Int']['output'];
  disabledExpressReason?: Maybe<Scalars['String']['output']>;
  isExpressEnabled: Scalars['Boolean']['output'];
};

export type UserCreateInput = {
  departmentId: Scalars['Int']['input'];
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email: Scalars['String']['input'];
  metadata: Scalars['jsonb']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
  telegramName: Scalars['String']['input'];
};

export type UserEditInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  telegramName?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  city: Scalars['String']['output'];
  /** An array relationship */
  client: Array<Client>;
  comments?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "address" */
export type AddressClientArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  client?: InputMaybe<Client_Bool_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Client_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  city?: InputMaybe<Order_By>;
  client_aggregate?: InputMaybe<Client_Aggregate_Order_By>;
  comments?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "client" */
export type Client = {
  __typename?: 'client';
  /** An object relationship */
  address?: Maybe<Address>;
  addressID?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['String']['output']>;
  fullname: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  phone: Scalars['String']['output'];
};


/** columns and relationships of "client" */
export type ClientOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "client" */
export type ClientOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** order by aggregate values of table "client" */
export type Client_Aggregate_Order_By = {
  avg?: InputMaybe<Client_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Client_Max_Order_By>;
  min?: InputMaybe<Client_Min_Order_By>;
  stddev?: InputMaybe<Client_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Client_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Client_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Client_Sum_Order_By>;
  var_pop?: InputMaybe<Client_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Client_Var_Samp_Order_By>;
  variance?: InputMaybe<Client_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "client" */
export type Client_Arr_Rel_Insert_Input = {
  data: Array<Client_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Client_On_Conflict>;
};

/** order by avg() on columns of table "client" */
export type Client_Avg_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "client". All fields are combined with a logical 'AND'. */
export type Client_Bool_Exp = {
  _and?: InputMaybe<Array<Client_Bool_Exp>>;
  _not?: InputMaybe<Client_Bool_Exp>;
  _or?: InputMaybe<Array<Client_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  addressID?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  fullname?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "client" */
export enum Client_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientPkey = 'client_pkey'
}

/** input type for incrementing numeric columns in table "client" */
export type Client_Inc_Input = {
  addressID?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "client" */
export type Client_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  addressID?: InputMaybe<Scalars['Int']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "client" */
export type Client_Max_Order_By = {
  addressID?: InputMaybe<Order_By>;
  districtId?: InputMaybe<Order_By>;
  fullname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "client" */
export type Client_Min_Order_By = {
  addressID?: InputMaybe<Order_By>;
  districtId?: InputMaybe<Order_By>;
  fullname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "client" */
export type Client_Mutation_Response = {
  __typename?: 'client_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Client>;
};

/** on_conflict condition type for table "client" */
export type Client_On_Conflict = {
  constraint: Client_Constraint;
  update_columns?: Array<Client_Update_Column>;
  where?: InputMaybe<Client_Bool_Exp>;
};

/** Ordering options when selecting data from "client". */
export type Client_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  addressID?: InputMaybe<Order_By>;
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  fullname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client */
export type Client_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "client" */
export enum Client_Select_Column {
  /** column name */
  AddressId = 'addressID',
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone'
}

/** input type for updating data in table "client" */
export type Client_Set_Input = {
  addressID?: InputMaybe<Scalars['Int']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "client" */
export type Client_Stddev_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "client" */
export type Client_Stddev_Pop_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "client" */
export type Client_Stddev_Samp_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "client" */
export type Client_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Client_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Client_Stream_Cursor_Value_Input = {
  addressID?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "client" */
export type Client_Sum_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "client" */
export enum Client_Update_Column {
  /** column name */
  AddressId = 'addressID',
  /** column name */
  Fullname = 'fullname',
  /** column name */
  Id = 'id',
  /** column name */
  Phone = 'phone'
}

export type Client_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Client_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Client_Set_Input>;
  /** filter the rows which have to be updated */
  where: Client_Bool_Exp;
};

/** order by var_pop() on columns of table "client" */
export type Client_Var_Pop_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "client" */
export type Client_Var_Samp_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "client" */
export type Client_Variance_Order_By = {
  addressID?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "contact_type". All fields are combined with logical 'AND'. */
export type Contact_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['contact_type']['input']>;
  _gt?: InputMaybe<Scalars['contact_type']['input']>;
  _gte?: InputMaybe<Scalars['contact_type']['input']>;
  _in?: InputMaybe<Array<Scalars['contact_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['contact_type']['input']>;
  _lte?: InputMaybe<Scalars['contact_type']['input']>;
  _neq?: InputMaybe<Scalars['contact_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['contact_type']['input']>>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  /** An array relationship */
  country_holidays: Array<Country_Holiday>;
  /** An array relationship */
  departments: Array<Department>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  products: Array<Product>;
  /** An array relationship */
  provinces: Array<Province>;
};


/** columns and relationships of "country" */
export type CountryCountry_HolidaysArgs = {
  distinct_on?: InputMaybe<Array<Country_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Holiday_Order_By>>;
  where?: InputMaybe<Country_Holiday_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryDepartmentsArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "country" */
export type CountryProvincesArgs = {
  distinct_on?: InputMaybe<Array<Province_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Province_Order_By>>;
  where?: InputMaybe<Province_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  country_holidays?: InputMaybe<Country_Holiday_Bool_Exp>;
  departments?: InputMaybe<Department_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  provinces?: InputMaybe<Province_Bool_Exp>;
};

/** columns and relationships of "country_holiday" */
export type Country_Holiday = {
  __typename?: 'country_holiday';
  /** An object relationship */
  country: Country;
  countryId: Scalars['String']['output'];
  date: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
};

/** order by aggregate values of table "country_holiday" */
export type Country_Holiday_Aggregate_Order_By = {
  avg?: InputMaybe<Country_Holiday_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Country_Holiday_Max_Order_By>;
  min?: InputMaybe<Country_Holiday_Min_Order_By>;
  stddev?: InputMaybe<Country_Holiday_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Country_Holiday_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Country_Holiday_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Country_Holiday_Sum_Order_By>;
  var_pop?: InputMaybe<Country_Holiday_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Country_Holiday_Var_Samp_Order_By>;
  variance?: InputMaybe<Country_Holiday_Variance_Order_By>;
};

/** order by avg() on columns of table "country_holiday" */
export type Country_Holiday_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "country_holiday". All fields are combined with a logical 'AND'. */
export type Country_Holiday_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Holiday_Bool_Exp>>;
  _not?: InputMaybe<Country_Holiday_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Holiday_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  countryId?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "country_holiday" */
export enum Country_Holiday_Constraint {
  /** unique or primary key constraint on columns "id" */
  CountryHolidaysPkey = 'country_holidays_pkey'
}

/** input type for inserting data into table "country_holiday" */
export type Country_Holiday_Insert_Input = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "country_holiday" */
export type Country_Holiday_Max_Order_By = {
  countryId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "country_holiday" */
export type Country_Holiday_Min_Order_By = {
  countryId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "country_holiday" */
export type Country_Holiday_Mutation_Response = {
  __typename?: 'country_holiday_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Country_Holiday>;
};

/** on_conflict condition type for table "country_holiday" */
export type Country_Holiday_On_Conflict = {
  constraint: Country_Holiday_Constraint;
  update_columns?: Array<Country_Holiday_Update_Column>;
  where?: InputMaybe<Country_Holiday_Bool_Exp>;
};

/** Ordering options when selecting data from "country_holiday". */
export type Country_Holiday_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  countryId?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "country_holiday" */
export enum Country_Holiday_Select_Column {
  /** column name */
  CountryId = 'countryId',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id'
}

/** order by stddev() on columns of table "country_holiday" */
export type Country_Holiday_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "country_holiday" */
export type Country_Holiday_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "country_holiday" */
export type Country_Holiday_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "country_holiday" */
export type Country_Holiday_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Holiday_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Holiday_Stream_Cursor_Value_Input = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "country_holiday" */
export type Country_Holiday_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "country_holiday" (current role has no relevant permissions) */
export enum Country_Holiday_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "country_holiday" */
export type Country_Holiday_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "country_holiday" */
export type Country_Holiday_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "country_holiday" */
export type Country_Holiday_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  country_holidays_aggregate?: InputMaybe<Country_Holiday_Aggregate_Order_By>;
  departments_aggregate?: InputMaybe<Department_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  provinces_aggregate?: InputMaybe<Province_Aggregate_Order_By>;
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

export type DeliveredOrdersCount_User_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']['input']>;
  date_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "delivery_provider" */
export type Delivery_Provider = {
  __typename?: 'delivery_provider';
  country_code: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  /** An array relationship */
  district_delivery_providers: Array<District_Delivery_Providers>;
  /** An aggregate relationship */
  district_delivery_providers_aggregate: District_Delivery_Providers_Aggregate;
  id: Scalars['uuid']['output'];
  is_external: Scalars['Boolean']['output'];
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  short_name: Scalars['String']['output'];
  /** An array relationship */
  window_delivery_providers: Array<Window_Delivery_Providers>;
  /** An aggregate relationship */
  window_delivery_providers_aggregate: Window_Delivery_Providers_Aggregate;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderDistrict_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderDistrict_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderWindow_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "delivery_provider" */
export type Delivery_ProviderWindow_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};

/** aggregated selection of "delivery_provider" */
export type Delivery_Provider_Aggregate = {
  __typename?: 'delivery_provider_aggregate';
  aggregate?: Maybe<Delivery_Provider_Aggregate_Fields>;
  nodes: Array<Delivery_Provider>;
};

/** aggregate fields of "delivery_provider" */
export type Delivery_Provider_Aggregate_Fields = {
  __typename?: 'delivery_provider_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Delivery_Provider_Max_Fields>;
  min?: Maybe<Delivery_Provider_Min_Fields>;
};


/** aggregate fields of "delivery_provider" */
export type Delivery_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "delivery_provider". All fields are combined with a logical 'AND'. */
export type Delivery_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Provider_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Provider_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  district_delivery_providers?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
  district_delivery_providers_aggregate?: InputMaybe<District_Delivery_Providers_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_external?: InputMaybe<Boolean_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  window_delivery_providers?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
  window_delivery_providers_aggregate?: InputMaybe<Window_Delivery_Providers_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Delivery_Provider_Max_Fields = {
  __typename?: 'delivery_provider_max_fields';
  country_code?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Delivery_Provider_Min_Fields = {
  __typename?: 'delivery_provider_min_fields';
  country_code?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "delivery_provider". */
export type Delivery_Provider_Order_By = {
  country_code?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  district_delivery_providers_aggregate?: InputMaybe<District_Delivery_Providers_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_external?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  short_name?: InputMaybe<Order_By>;
  window_delivery_providers_aggregate?: InputMaybe<Window_Delivery_Providers_Aggregate_Order_By>;
};

/** select columns of table "delivery_provider" */
export enum Delivery_Provider_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsExternal = 'is_external',
  /** column name */
  ShortName = 'short_name'
}

/** Streaming cursor of the table "delivery_provider" */
export type Delivery_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Provider_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "department" */
export type Department = {
  __typename?: 'department';
  centerLat?: Maybe<Scalars['numeric']['output']>;
  centerLng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  /** An array relationship */
  departments_districts: Array<Departments_Districts>;
  /** An array relationship */
  departments_users: Array<Departments_Users>;
  disabled_express_reason?: Maybe<Scalars['String']['output']>;
  enableTaskCreating: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_express_enabled: Scalars['Boolean']['output'];
  /** https://developers.google.com/maps/faq#languagesupport */
  language: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  timeZone: Scalars['Int']['output'];
  timeZoneLocation?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  warehouses: Array<Warehouse>;
};


/** columns and relationships of "department" */
export type DepartmentDepartments_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Departments_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Districts_Order_By>>;
  where?: InputMaybe<Departments_Districts_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentDepartments_UsersArgs = {
  distinct_on?: InputMaybe<Array<Departments_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Users_Order_By>>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "department" */
export type DepartmentWarehousesArgs = {
  distinct_on?: InputMaybe<Array<Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warehouse_Order_By>>;
  where?: InputMaybe<Warehouse_Bool_Exp>;
};

/** order by aggregate values of table "department" */
export type Department_Aggregate_Order_By = {
  avg?: InputMaybe<Department_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Department_Max_Order_By>;
  min?: InputMaybe<Department_Min_Order_By>;
  stddev?: InputMaybe<Department_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Department_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Department_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Department_Sum_Order_By>;
  var_pop?: InputMaybe<Department_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Department_Var_Samp_Order_By>;
  variance?: InputMaybe<Department_Variance_Order_By>;
};

/** order by avg() on columns of table "department" */
export type Department_Avg_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type Department_Bool_Exp = {
  _and?: InputMaybe<Array<Department_Bool_Exp>>;
  _not?: InputMaybe<Department_Bool_Exp>;
  _or?: InputMaybe<Array<Department_Bool_Exp>>;
  centerLat?: InputMaybe<Numeric_Comparison_Exp>;
  centerLng?: InputMaybe<Numeric_Comparison_Exp>;
  country?: InputMaybe<Country_Bool_Exp>;
  countryId?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  departments_districts?: InputMaybe<Departments_Districts_Bool_Exp>;
  departments_users?: InputMaybe<Departments_Users_Bool_Exp>;
  disabled_express_reason?: InputMaybe<String_Comparison_Exp>;
  enableTaskCreating?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_express_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  timeZone?: InputMaybe<Int_Comparison_Exp>;
  timeZoneLocation?: InputMaybe<String_Comparison_Exp>;
  warehouses?: InputMaybe<Warehouse_Bool_Exp>;
};

/** order by max() on columns of table "department" */
export type Department_Max_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  countryId?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  disabled_express_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** https://developers.google.com/maps/faq#languagesupport */
  language?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeZoneLocation?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "department" */
export type Department_Min_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  countryId?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  disabled_express_reason?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** https://developers.google.com/maps/faq#languagesupport */
  language?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeZoneLocation?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "department" */
export type Department_Mutation_Response = {
  __typename?: 'department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Department>;
};

/** Ordering options when selecting data from "department". */
export type Department_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  country?: InputMaybe<Country_Order_By>;
  countryId?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  departments_districts_aggregate?: InputMaybe<Departments_Districts_Aggregate_Order_By>;
  departments_users_aggregate?: InputMaybe<Departments_Users_Aggregate_Order_By>;
  disabled_express_reason?: InputMaybe<Order_By>;
  enableTaskCreating?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_express_enabled?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeZoneLocation?: InputMaybe<Order_By>;
  warehouses_aggregate?: InputMaybe<Warehouse_Aggregate_Order_By>;
};

/** primary key columns input for table: department */
export type Department_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "department" */
export enum Department_Select_Column {
  /** column name */
  CenterLat = 'centerLat',
  /** column name */
  CenterLng = 'centerLng',
  /** column name */
  CountryId = 'countryId',
  /** column name */
  Currency = 'currency',
  /** column name */
  DisabledExpressReason = 'disabled_express_reason',
  /** column name */
  EnableTaskCreating = 'enableTaskCreating',
  /** column name */
  Id = 'id',
  /** column name */
  IsExpressEnabled = 'is_express_enabled',
  /** column name */
  Language = 'language',
  /** column name */
  Name = 'name',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  TimeZoneLocation = 'timeZoneLocation'
}

/** input type for updating data in table "department" */
export type Department_Set_Input = {
  disabled_express_reason?: InputMaybe<Scalars['String']['input']>;
  enableTaskCreating?: InputMaybe<Scalars['Boolean']['input']>;
  is_express_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "department" */
export type Department_Stddev_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "department" */
export type Department_Stddev_Pop_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "department" */
export type Department_Stddev_Samp_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "department" */
export type Department_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Department_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Department_Stream_Cursor_Value_Input = {
  centerLat?: InputMaybe<Scalars['numeric']['input']>;
  centerLng?: InputMaybe<Scalars['numeric']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  disabled_express_reason?: InputMaybe<Scalars['String']['input']>;
  enableTaskCreating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_express_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** https://developers.google.com/maps/faq#languagesupport */
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['Int']['input']>;
  timeZoneLocation?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "department" */
export type Department_Sum_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

export type Department_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Department_Set_Input>;
  /** filter the rows which have to be updated */
  where: Department_Bool_Exp;
};

/** order by var_pop() on columns of table "department" */
export type Department_Var_Pop_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "department" */
export type Department_Var_Samp_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "department" */
export type Department_Variance_Order_By = {
  centerLat?: InputMaybe<Order_By>;
  centerLng?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
};

/** columns and relationships of "departments_districts" */
export type Departments_Districts = {
  __typename?: 'departments_districts';
  /** An object relationship */
  department: Department;
  departmentId: Scalars['Int']['output'];
  /** An object relationship */
  district: District;
  districtId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  splitBetweenDepartments: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "departments_districts" */
export type Departments_Districts_Aggregate_Order_By = {
  avg?: InputMaybe<Departments_Districts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Departments_Districts_Max_Order_By>;
  min?: InputMaybe<Departments_Districts_Min_Order_By>;
  stddev?: InputMaybe<Departments_Districts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Departments_Districts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Departments_Districts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Departments_Districts_Sum_Order_By>;
  var_pop?: InputMaybe<Departments_Districts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Departments_Districts_Var_Samp_Order_By>;
  variance?: InputMaybe<Departments_Districts_Variance_Order_By>;
};

/** order by avg() on columns of table "departments_districts" */
export type Departments_Districts_Avg_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "departments_districts". All fields are combined with a logical 'AND'. */
export type Departments_Districts_Bool_Exp = {
  _and?: InputMaybe<Array<Departments_Districts_Bool_Exp>>;
  _not?: InputMaybe<Departments_Districts_Bool_Exp>;
  _or?: InputMaybe<Array<Departments_Districts_Bool_Exp>>;
  department?: InputMaybe<Department_Bool_Exp>;
  departmentId?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  splitBetweenDepartments?: InputMaybe<Boolean_Comparison_Exp>;
};

/** order by max() on columns of table "departments_districts" */
export type Departments_Districts_Max_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "departments_districts" */
export type Departments_Districts_Min_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "departments_districts". */
export type Departments_Districts_Order_By = {
  department?: InputMaybe<Department_Order_By>;
  departmentId?: InputMaybe<Order_By>;
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  splitBetweenDepartments?: InputMaybe<Order_By>;
};

/** select columns of table "departments_districts" */
export enum Departments_Districts_Select_Column {
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  Id = 'id',
  /** column name */
  SplitBetweenDepartments = 'splitBetweenDepartments'
}

/** order by stddev() on columns of table "departments_districts" */
export type Departments_Districts_Stddev_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "departments_districts" */
export type Departments_Districts_Stddev_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "departments_districts" */
export type Departments_Districts_Stddev_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "departments_districts" */
export type Departments_Districts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Departments_Districts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Departments_Districts_Stream_Cursor_Value_Input = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  splitBetweenDepartments?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "departments_districts" */
export type Departments_Districts_Sum_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "departments_districts" */
export type Departments_Districts_Var_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "departments_districts" */
export type Departments_Districts_Var_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "departments_districts" */
export type Departments_Districts_Variance_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "departments_users" */
export type Departments_Users = {
  __typename?: 'departments_users';
  /** An object relationship */
  department: Department;
  departmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  splitBetweenDepartments: Scalars['Boolean']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['String']['output'];
};

/** order by aggregate values of table "departments_users" */
export type Departments_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Departments_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Departments_Users_Max_Order_By>;
  min?: InputMaybe<Departments_Users_Min_Order_By>;
  stddev?: InputMaybe<Departments_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Departments_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Departments_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Departments_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Departments_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Departments_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Departments_Users_Variance_Order_By>;
};

/** order by avg() on columns of table "departments_users" */
export type Departments_Users_Avg_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "departments_users". All fields are combined with a logical 'AND'. */
export type Departments_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Departments_Users_Bool_Exp>>;
  _not?: InputMaybe<Departments_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Departments_Users_Bool_Exp>>;
  department?: InputMaybe<Department_Bool_Exp>;
  departmentId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  splitBetweenDepartments?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "departments_users" */
export enum Departments_Users_Constraint {
  /** unique or primary key constraint on columns "userId", "departmentId" */
  DepartmentsUsersDepartmentUserUnique = 'departments_users_department_user_unique',
  /** unique or primary key constraint on columns "id" */
  DepartmentsUsersPkey = 'departments_users_pkey'
}

/** input type for inserting data into table "departments_users" */
export type Departments_Users_Insert_Input = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  splitBetweenDepartments?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "departments_users" */
export type Departments_Users_Max_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "departments_users" */
export type Departments_Users_Min_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "departments_users" */
export type Departments_Users_Mutation_Response = {
  __typename?: 'departments_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Departments_Users>;
};

/** on_conflict condition type for table "departments_users" */
export type Departments_Users_On_Conflict = {
  constraint: Departments_Users_Constraint;
  update_columns?: Array<Departments_Users_Update_Column>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "departments_users". */
export type Departments_Users_Order_By = {
  department?: InputMaybe<Department_Order_By>;
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  splitBetweenDepartments?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "departments_users" */
export enum Departments_Users_Select_Column {
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  SplitBetweenDepartments = 'splitBetweenDepartments',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "departments_users" */
export type Departments_Users_Stddev_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "departments_users" */
export type Departments_Users_Stddev_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "departments_users" */
export type Departments_Users_Stddev_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "departments_users" */
export type Departments_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Departments_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Departments_Users_Stream_Cursor_Value_Input = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  splitBetweenDepartments?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "departments_users" */
export type Departments_Users_Sum_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "departments_users" (current role has no relevant permissions) */
export enum Departments_Users_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "departments_users" */
export type Departments_Users_Var_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "departments_users" */
export type Departments_Users_Var_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "departments_users" */
export type Departments_Users_Variance_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "district" */
export type District = {
  __typename?: 'district';
  city?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  clients: Array<Client>;
  cutoffHours?: Maybe<Scalars['Int']['output']>;
  deliveryDays?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  departments_districts: Array<Departments_Districts>;
  /** An array relationship */
  district_delivery_providers: Array<District_Delivery_Providers>;
  /** An aggregate relationship */
  district_delivery_providers_aggregate: District_Delivery_Providers_Aggregate;
  /** An array relationship */
  districts_coordinates: Array<Districts_Coordinates>;
  /** An array relationship */
  driver_districts: Array<Driver_District>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isPolygone?: Maybe<Scalars['Boolean']['output']>;
  loadFactor?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offDays?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  province?: Maybe<Province>;
  /** country-region-province */
  provinceId?: Maybe<Scalars['String']['output']>;
  successRate?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  weekday_window_districts: Array<Weekday_Window_District>;
  /** An array relationship */
  workload: Array<District_Workload>;
};


/** columns and relationships of "district" */
export type DistrictClientsArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictDepartments_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Departments_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Districts_Order_By>>;
  where?: InputMaybe<Departments_Districts_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictDistrict_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictDistrict_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictDistricts_CoordinatesArgs = {
  distinct_on?: InputMaybe<Array<Districts_Coordinates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Districts_Coordinates_Order_By>>;
  where?: InputMaybe<Districts_Coordinates_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictDriver_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Driver_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_District_Order_By>>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictOffDaysArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "district" */
export type DistrictOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictWeekday_Window_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_District_Order_By>>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};


/** columns and relationships of "district" */
export type DistrictWorkloadArgs = {
  distinct_on?: InputMaybe<Array<District_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Workload_Order_By>>;
  where?: InputMaybe<District_Workload_Bool_Exp>;
};

/** order by aggregate values of table "district" */
export type District_Aggregate_Order_By = {
  avg?: InputMaybe<District_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<District_Max_Order_By>;
  min?: InputMaybe<District_Min_Order_By>;
  stddev?: InputMaybe<District_Stddev_Order_By>;
  stddev_pop?: InputMaybe<District_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<District_Stddev_Samp_Order_By>;
  sum?: InputMaybe<District_Sum_Order_By>;
  var_pop?: InputMaybe<District_Var_Pop_Order_By>;
  var_samp?: InputMaybe<District_Var_Samp_Order_By>;
  variance?: InputMaybe<District_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type District_Append_Input = {
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by avg() on columns of table "district" */
export type District_Avg_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "district". All fields are combined with a logical 'AND'. */
export type District_Bool_Exp = {
  _and?: InputMaybe<Array<District_Bool_Exp>>;
  _not?: InputMaybe<District_Bool_Exp>;
  _or?: InputMaybe<Array<District_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  clients?: InputMaybe<Client_Bool_Exp>;
  cutoffHours?: InputMaybe<Int_Comparison_Exp>;
  deliveryDays?: InputMaybe<Int_Comparison_Exp>;
  departments_districts?: InputMaybe<Departments_Districts_Bool_Exp>;
  district_delivery_providers?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
  district_delivery_providers_aggregate?: InputMaybe<District_Delivery_Providers_Aggregate_Bool_Exp>;
  districts_coordinates?: InputMaybe<Districts_Coordinates_Bool_Exp>;
  driver_districts?: InputMaybe<Driver_District_Bool_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isPolygone?: InputMaybe<Boolean_Comparison_Exp>;
  loadFactor?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  offDays?: InputMaybe<Jsonb_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  province?: InputMaybe<Province_Bool_Exp>;
  provinceId?: InputMaybe<String_Comparison_Exp>;
  successRate?: InputMaybe<Numeric_Comparison_Exp>;
  weekday_window_districts?: InputMaybe<Weekday_Window_District_Bool_Exp>;
  workload?: InputMaybe<District_Workload_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type District_Delete_At_Path_Input = {
  offDays?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type District_Delete_Elem_Input = {
  offDays?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type District_Delete_Key_Input = {
  offDays?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "district_delivery_providers" */
export type District_Delivery_Providers = {
  __typename?: 'district_delivery_providers';
  /** An object relationship */
  delivery_provider: Delivery_Provider;
  delivery_provider_id: Scalars['uuid']['output'];
  /** An object relationship */
  district: District;
  district_id: Scalars['String']['output'];
};

/** aggregated selection of "district_delivery_providers" */
export type District_Delivery_Providers_Aggregate = {
  __typename?: 'district_delivery_providers_aggregate';
  aggregate?: Maybe<District_Delivery_Providers_Aggregate_Fields>;
  nodes: Array<District_Delivery_Providers>;
};

export type District_Delivery_Providers_Aggregate_Bool_Exp = {
  count?: InputMaybe<District_Delivery_Providers_Aggregate_Bool_Exp_Count>;
};

export type District_Delivery_Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "district_delivery_providers" */
export type District_Delivery_Providers_Aggregate_Fields = {
  __typename?: 'district_delivery_providers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<District_Delivery_Providers_Max_Fields>;
  min?: Maybe<District_Delivery_Providers_Min_Fields>;
};


/** aggregate fields of "district_delivery_providers" */
export type District_Delivery_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "district_delivery_providers" */
export type District_Delivery_Providers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<District_Delivery_Providers_Max_Order_By>;
  min?: InputMaybe<District_Delivery_Providers_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "district_delivery_providers". All fields are combined with a logical 'AND'. */
export type District_Delivery_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<District_Delivery_Providers_Bool_Exp>>;
  _not?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<District_Delivery_Providers_Bool_Exp>>;
  delivery_provider?: InputMaybe<Delivery_Provider_Bool_Exp>;
  delivery_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  district?: InputMaybe<District_Bool_Exp>;
  district_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "district_delivery_providers" */
export enum District_Delivery_Providers_Constraint {
  /** unique or primary key constraint on columns "district_id", "delivery_provider_id" */
  DistrictDeliveryProvidersPkey = 'district_delivery_providers_pkey'
}

/** input type for inserting data into table "district_delivery_providers" */
export type District_Delivery_Providers_Insert_Input = {
  delivery_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  district_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type District_Delivery_Providers_Max_Fields = {
  __typename?: 'district_delivery_providers_max_fields';
  delivery_provider_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "district_delivery_providers" */
export type District_Delivery_Providers_Max_Order_By = {
  delivery_provider_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type District_Delivery_Providers_Min_Fields = {
  __typename?: 'district_delivery_providers_min_fields';
  delivery_provider_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "district_delivery_providers" */
export type District_Delivery_Providers_Min_Order_By = {
  delivery_provider_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "district_delivery_providers" */
export type District_Delivery_Providers_Mutation_Response = {
  __typename?: 'district_delivery_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<District_Delivery_Providers>;
};

/** on_conflict condition type for table "district_delivery_providers" */
export type District_Delivery_Providers_On_Conflict = {
  constraint: District_Delivery_Providers_Constraint;
  update_columns?: Array<District_Delivery_Providers_Update_Column>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "district_delivery_providers". */
export type District_Delivery_Providers_Order_By = {
  delivery_provider?: InputMaybe<Delivery_Provider_Order_By>;
  delivery_provider_id?: InputMaybe<Order_By>;
  district?: InputMaybe<District_Order_By>;
  district_id?: InputMaybe<Order_By>;
};

/** select columns of table "district_delivery_providers" */
export enum District_Delivery_Providers_Select_Column {
  /** column name */
  DeliveryProviderId = 'delivery_provider_id',
  /** column name */
  DistrictId = 'district_id'
}

/** Streaming cursor of the table "district_delivery_providers" */
export type District_Delivery_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: District_Delivery_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type District_Delivery_Providers_Stream_Cursor_Value_Input = {
  delivery_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  district_id?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "district_delivery_providers" (current role has no relevant permissions) */
export enum District_Delivery_Providers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for incrementing numeric columns in table "district" */
export type District_Inc_Input = {
  cutoffHours?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<Scalars['Int']['input']>;
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "district" */
export type District_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  /** country-region-province */
  provinceId?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "district" */
export type District_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  /** country-region-province */
  provinceId?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "district" */
export type District_Mutation_Response = {
  __typename?: 'district_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<District>;
};

/** Ordering options when selecting data from "district". */
export type District_Order_By = {
  city?: InputMaybe<Order_By>;
  clients_aggregate?: InputMaybe<Client_Aggregate_Order_By>;
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  departments_districts_aggregate?: InputMaybe<Departments_Districts_Aggregate_Order_By>;
  district_delivery_providers_aggregate?: InputMaybe<District_Delivery_Providers_Aggregate_Order_By>;
  districts_coordinates_aggregate?: InputMaybe<Districts_Coordinates_Aggregate_Order_By>;
  driver_districts_aggregate?: InputMaybe<Driver_District_Aggregate_Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isPolygone?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  offDays?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  postalCode?: InputMaybe<Order_By>;
  province?: InputMaybe<Province_Order_By>;
  provinceId?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
  weekday_window_districts_aggregate?: InputMaybe<Weekday_Window_District_Aggregate_Order_By>;
  workload_aggregate?: InputMaybe<District_Workload_Aggregate_Order_By>;
};

/** primary key columns input for table: district */
export type District_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type District_Prepend_Input = {
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "district" */
export enum District_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  CutoffHours = 'cutoffHours',
  /** column name */
  DeliveryDays = 'deliveryDays',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  IsPolygone = 'isPolygone',
  /** column name */
  LoadFactor = 'loadFactor',
  /** column name */
  Name = 'name',
  /** column name */
  OffDays = 'offDays',
  /** column name */
  PostalCode = 'postalCode',
  /** column name */
  ProvinceId = 'provinceId',
  /** column name */
  SuccessRate = 'successRate'
}

/** input type for updating data in table "district" */
export type District_Set_Input = {
  cutoffHours?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<Scalars['Int']['input']>;
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by stddev() on columns of table "district" */
export type District_Stddev_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "district" */
export type District_Stddev_Pop_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "district" */
export type District_Stddev_Samp_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "district" */
export type District_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: District_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type District_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  cutoffHours?: InputMaybe<Scalars['Int']['input']>;
  deliveryDays?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isPolygone?: InputMaybe<Scalars['Boolean']['input']>;
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** country-region-province */
  provinceId?: InputMaybe<Scalars['String']['input']>;
  successRate?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "district" */
export type District_Sum_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

export type District_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<District_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<District_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<District_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<District_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<District_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<District_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<District_Set_Input>;
  /** filter the rows which have to be updated */
  where: District_Bool_Exp;
};

/** order by var_pop() on columns of table "district" */
export type District_Var_Pop_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "district" */
export type District_Var_Samp_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "district" */
export type District_Variance_Order_By = {
  cutoffHours?: InputMaybe<Order_By>;
  deliveryDays?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  successRate?: InputMaybe<Order_By>;
};

/** columns and relationships of "district_workload" */
export type District_Workload = {
  __typename?: 'district_workload';
  /** An object relationship */
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['String']['output']>;
  loadFactor?: Maybe<Scalars['Int']['output']>;
  timeperiod?: Maybe<Scalars['timestamptz']['output']>;
  workload?: Maybe<Scalars['float8']['output']>;
};

/** order by aggregate values of table "district_workload" */
export type District_Workload_Aggregate_Order_By = {
  avg?: InputMaybe<District_Workload_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<District_Workload_Max_Order_By>;
  min?: InputMaybe<District_Workload_Min_Order_By>;
  stddev?: InputMaybe<District_Workload_Stddev_Order_By>;
  stddev_pop?: InputMaybe<District_Workload_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<District_Workload_Stddev_Samp_Order_By>;
  sum?: InputMaybe<District_Workload_Sum_Order_By>;
  var_pop?: InputMaybe<District_Workload_Var_Pop_Order_By>;
  var_samp?: InputMaybe<District_Workload_Var_Samp_Order_By>;
  variance?: InputMaybe<District_Workload_Variance_Order_By>;
};

/** order by avg() on columns of table "district_workload" */
export type District_Workload_Avg_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "district_workload". All fields are combined with a logical 'AND'. */
export type District_Workload_Bool_Exp = {
  _and?: InputMaybe<Array<District_Workload_Bool_Exp>>;
  _not?: InputMaybe<District_Workload_Bool_Exp>;
  _or?: InputMaybe<Array<District_Workload_Bool_Exp>>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  loadFactor?: InputMaybe<Int_Comparison_Exp>;
  timeperiod?: InputMaybe<Timestamptz_Comparison_Exp>;
  workload?: InputMaybe<Float8_Comparison_Exp>;
};

/** order by max() on columns of table "district_workload" */
export type District_Workload_Max_Order_By = {
  districtId?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "district_workload" */
export type District_Workload_Min_Order_By = {
  districtId?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "district_workload". */
export type District_Workload_Order_By = {
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  loadFactor?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** select columns of table "district_workload" */
export enum District_Workload_Select_Column {
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  LoadFactor = 'loadFactor',
  /** column name */
  Timeperiod = 'timeperiod',
  /** column name */
  Workload = 'workload'
}

/** order by stddev() on columns of table "district_workload" */
export type District_Workload_Stddev_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "district_workload" */
export type District_Workload_Stddev_Pop_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "district_workload" */
export type District_Workload_Stddev_Samp_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "district_workload" */
export type District_Workload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: District_Workload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type District_Workload_Stream_Cursor_Value_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
  timeperiod?: InputMaybe<Scalars['timestamptz']['input']>;
  workload?: InputMaybe<Scalars['float8']['input']>;
};

/** order by sum() on columns of table "district_workload" */
export type District_Workload_Sum_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "district_workload" */
export type District_Workload_Var_Pop_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "district_workload" */
export type District_Workload_Var_Samp_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "district_workload" */
export type District_Workload_Variance_Order_By = {
  loadFactor?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** columns and relationships of "districts_coordinates" */
export type Districts_Coordinates = {
  __typename?: 'districts_coordinates';
  /** An object relationship */
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['numeric']['output']>;
  longitude?: Maybe<Scalars['numeric']['output']>;
};

/** order by aggregate values of table "districts_coordinates" */
export type Districts_Coordinates_Aggregate_Order_By = {
  avg?: InputMaybe<Districts_Coordinates_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Districts_Coordinates_Max_Order_By>;
  min?: InputMaybe<Districts_Coordinates_Min_Order_By>;
  stddev?: InputMaybe<Districts_Coordinates_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Districts_Coordinates_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Districts_Coordinates_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Districts_Coordinates_Sum_Order_By>;
  var_pop?: InputMaybe<Districts_Coordinates_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Districts_Coordinates_Var_Samp_Order_By>;
  variance?: InputMaybe<Districts_Coordinates_Variance_Order_By>;
};

/** order by avg() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "districts_coordinates". All fields are combined with a logical 'AND'. */
export type Districts_Coordinates_Bool_Exp = {
  _and?: InputMaybe<Array<Districts_Coordinates_Bool_Exp>>;
  _not?: InputMaybe<Districts_Coordinates_Bool_Exp>;
  _or?: InputMaybe<Array<Districts_Coordinates_Bool_Exp>>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  latitude?: InputMaybe<Numeric_Comparison_Exp>;
  longitude?: InputMaybe<Numeric_Comparison_Exp>;
};

/** order by max() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Max_Order_By = {
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Min_Order_By = {
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "districts_coordinates". */
export type Districts_Coordinates_Order_By = {
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** select columns of table "districts_coordinates" */
export enum Districts_Coordinates_Select_Column {
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  Id = 'id',
  /** column name */
  Latitude = 'latitude',
  /** column name */
  Longitude = 'longitude'
}

/** order by stddev() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "districts_coordinates" */
export type Districts_Coordinates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Districts_Coordinates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Districts_Coordinates_Stream_Cursor_Value_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['numeric']['input']>;
  longitude?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "districts_coordinates" */
export type Districts_Coordinates_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  latitude?: InputMaybe<Order_By>;
  longitude?: InputMaybe<Order_By>;
};

/** columns and relationships of "driver_district" */
export type Driver_District = {
  __typename?: 'driver_district';
  /** An object relationship */
  district: District;
  districtId: Scalars['String']['output'];
  /** An object relationship */
  driver: User;
  driverId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** order by aggregate values of table "driver_district" */
export type Driver_District_Aggregate_Order_By = {
  avg?: InputMaybe<Driver_District_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_District_Max_Order_By>;
  min?: InputMaybe<Driver_District_Min_Order_By>;
  stddev?: InputMaybe<Driver_District_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Driver_District_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Driver_District_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Driver_District_Sum_Order_By>;
  var_pop?: InputMaybe<Driver_District_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Driver_District_Var_Samp_Order_By>;
  variance?: InputMaybe<Driver_District_Variance_Order_By>;
};

/** order by avg() on columns of table "driver_district" */
export type Driver_District_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "driver_district". All fields are combined with a logical 'AND'. */
export type Driver_District_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_District_Bool_Exp>>;
  _not?: InputMaybe<Driver_District_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_District_Bool_Exp>>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driverId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "driver_district" */
export enum Driver_District_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverDistrictPkey = 'driver_district_pkey'
}

/** input type for inserting data into table "driver_district" */
export type Driver_District_Insert_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "driver_district" */
export type Driver_District_Max_Order_By = {
  districtId?: InputMaybe<Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "driver_district" */
export type Driver_District_Min_Order_By = {
  districtId?: InputMaybe<Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_district" */
export type Driver_District_Mutation_Response = {
  __typename?: 'driver_district_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_District>;
};

/** on_conflict condition type for table "driver_district" */
export type Driver_District_On_Conflict = {
  constraint: Driver_District_Constraint;
  update_columns?: Array<Driver_District_Update_Column>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_district". */
export type Driver_District_Order_By = {
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "driver_district" */
export enum Driver_District_Select_Column {
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  DriverId = 'driverId',
  /** column name */
  Id = 'id'
}

/** order by stddev() on columns of table "driver_district" */
export type Driver_District_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "driver_district" */
export type Driver_District_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "driver_district" */
export type Driver_District_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "driver_district" */
export type Driver_District_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_District_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_District_Stream_Cursor_Value_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "driver_district" */
export type Driver_District_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "driver_district" (current role has no relevant permissions) */
export enum Driver_District_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "driver_district" */
export type Driver_District_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "driver_district" */
export type Driver_District_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "driver_district" */
export type Driver_District_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "driver_holiday" */
export type Driver_Holiday = {
  __typename?: 'driver_holiday';
  date: Scalars['timestamptz']['output'];
  driverId: Scalars['String']['output'];
  /** Если водитель хочет работать в праздничный день */
  forced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  user: User;
};

/** order by aggregate values of table "driver_holiday" */
export type Driver_Holiday_Aggregate_Order_By = {
  avg?: InputMaybe<Driver_Holiday_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Holiday_Max_Order_By>;
  min?: InputMaybe<Driver_Holiday_Min_Order_By>;
  stddev?: InputMaybe<Driver_Holiday_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Driver_Holiday_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Driver_Holiday_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Driver_Holiday_Sum_Order_By>;
  var_pop?: InputMaybe<Driver_Holiday_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Driver_Holiday_Var_Samp_Order_By>;
  variance?: InputMaybe<Driver_Holiday_Variance_Order_By>;
};

/** order by avg() on columns of table "driver_holiday" */
export type Driver_Holiday_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "driver_holiday". All fields are combined with a logical 'AND'. */
export type Driver_Holiday_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Holiday_Bool_Exp>>;
  _not?: InputMaybe<Driver_Holiday_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Holiday_Bool_Exp>>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  driverId?: InputMaybe<String_Comparison_Exp>;
  forced?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "driver_holiday" */
export enum Driver_Holiday_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverHolidayPkey = 'driver_holiday_pkey'
}

/** input type for inserting data into table "driver_holiday" */
export type Driver_Holiday_Insert_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  /** Если водитель хочет работать в праздничный день */
  forced?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "driver_holiday" */
export type Driver_Holiday_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "driver_holiday" */
export type Driver_Holiday_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_holiday" */
export type Driver_Holiday_Mutation_Response = {
  __typename?: 'driver_holiday_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Holiday>;
};

/** on_conflict condition type for table "driver_holiday" */
export type Driver_Holiday_On_Conflict = {
  constraint: Driver_Holiday_Constraint;
  update_columns?: Array<Driver_Holiday_Update_Column>;
  where?: InputMaybe<Driver_Holiday_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_holiday". */
export type Driver_Holiday_Order_By = {
  date?: InputMaybe<Order_By>;
  driverId?: InputMaybe<Order_By>;
  forced?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "driver_holiday" */
export enum Driver_Holiday_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  DriverId = 'driverId',
  /** column name */
  Forced = 'forced',
  /** column name */
  Id = 'id'
}

/** order by stddev() on columns of table "driver_holiday" */
export type Driver_Holiday_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "driver_holiday" */
export type Driver_Holiday_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "driver_holiday" */
export type Driver_Holiday_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "driver_holiday" */
export type Driver_Holiday_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Holiday_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Holiday_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  /** Если водитель хочет работать в праздничный день */
  forced?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "driver_holiday" */
export type Driver_Holiday_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "driver_holiday" (current role has no relevant permissions) */
export enum Driver_Holiday_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "driver_holiday" */
export type Driver_Holiday_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "driver_holiday" */
export type Driver_Holiday_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "driver_holiday" */
export type Driver_Holiday_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "driver_order_interaction" */
export type Driver_Order_Interaction = {
  __typename?: 'driver_order_interaction';
  contact_type: Scalars['contact_type']['output'];
  created_at: Scalars['timestamptz']['output'];
  driver_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An object relationship */
  order: Order;
  order_id: Scalars['Int']['output'];
  /** An object relationship */
  user?: Maybe<User>;
};

/** Boolean expression to filter rows from the table "driver_order_interaction". All fields are combined with a logical 'AND'. */
export type Driver_Order_Interaction_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Order_Interaction_Bool_Exp>>;
  _not?: InputMaybe<Driver_Order_Interaction_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Order_Interaction_Bool_Exp>>;
  contact_type?: InputMaybe<Contact_Type_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  driver_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_order_interaction". */
export type Driver_Order_Interaction_Order_By = {
  contact_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  driver_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "driver_order_interaction" */
export enum Driver_Order_Interaction_Select_Column {
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DriverId = 'driver_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'order_id'
}

/** Streaming cursor of the table "driver_order_interaction" */
export type Driver_Order_Interaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Order_Interaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Order_Interaction_Stream_Cursor_Value_Input = {
  contact_type?: InputMaybe<Scalars['contact_type']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  driver_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order_id?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "driver_window" */
export type Driver_Window = {
  __typename?: 'driver_window';
  driverId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  timeDuration?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  /** An array relationship */
  weekday_windows: Array<Weekday_Window>;
};


/** columns and relationships of "driver_window" */
export type Driver_WindowWeekday_WindowsArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_Order_By>>;
  where?: InputMaybe<Weekday_Window_Bool_Exp>;
};

/** order by aggregate values of table "driver_window" */
export type Driver_Window_Aggregate_Order_By = {
  avg?: InputMaybe<Driver_Window_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Window_Max_Order_By>;
  min?: InputMaybe<Driver_Window_Min_Order_By>;
  stddev?: InputMaybe<Driver_Window_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Driver_Window_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Driver_Window_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Driver_Window_Sum_Order_By>;
  var_pop?: InputMaybe<Driver_Window_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Driver_Window_Var_Samp_Order_By>;
  variance?: InputMaybe<Driver_Window_Variance_Order_By>;
};

/** order by avg() on columns of table "driver_window" */
export type Driver_Window_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "driver_window". All fields are combined with a logical 'AND'. */
export type Driver_Window_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Window_Bool_Exp>>;
  _not?: InputMaybe<Driver_Window_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Window_Bool_Exp>>;
  driverId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  timeDuration?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  weekday_windows?: InputMaybe<Weekday_Window_Bool_Exp>;
};

/** unique or primary key constraints on table "driver_window" */
export enum Driver_Window_Constraint {
  /** unique or primary key constraint on columns "id" */
  DriverWindowPkey = 'driver_window_pkey',
  /** unique or primary key constraint on columns "timeDuration", "driverId" */
  DriverWindowTimeDurationDriverIdKey = 'driver_window_timeDuration_driverId_key'
}

/** input type for inserting data into table "driver_window" */
export type Driver_Window_Insert_Input = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  timeDuration?: InputMaybe<Scalars['String']['input']>;
  weekday_windows?: InputMaybe<Weekday_Window_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "driver_window" */
export type Driver_Window_Max_Order_By = {
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeDuration?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "driver_window" */
export type Driver_Window_Min_Order_By = {
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeDuration?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "driver_window" */
export type Driver_Window_Mutation_Response = {
  __typename?: 'driver_window_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Driver_Window>;
};

/** input type for inserting object relation for remote table "driver_window" */
export type Driver_Window_Obj_Rel_Insert_Input = {
  data: Driver_Window_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Driver_Window_On_Conflict>;
};

/** on_conflict condition type for table "driver_window" */
export type Driver_Window_On_Conflict = {
  constraint: Driver_Window_Constraint;
  update_columns?: Array<Driver_Window_Update_Column>;
  where?: InputMaybe<Driver_Window_Bool_Exp>;
};

/** Ordering options when selecting data from "driver_window". */
export type Driver_Window_Order_By = {
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeDuration?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  weekday_windows_aggregate?: InputMaybe<Weekday_Window_Aggregate_Order_By>;
};

/** primary key columns input for table: driver_window */
export type Driver_Window_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "driver_window" */
export enum Driver_Window_Select_Column {
  /** column name */
  DriverId = 'driverId',
  /** column name */
  Id = 'id',
  /** column name */
  TimeDuration = 'timeDuration'
}

/** input type for updating data in table "driver_window" */
export type Driver_Window_Set_Input = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  timeDuration?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "driver_window" */
export type Driver_Window_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "driver_window" */
export type Driver_Window_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "driver_window" */
export type Driver_Window_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "driver_window" */
export type Driver_Window_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Window_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Window_Stream_Cursor_Value_Input = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  timeDuration?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "driver_window" */
export type Driver_Window_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "driver_window" */
export enum Driver_Window_Update_Column {
  /** column name */
  DriverId = 'driverId',
  /** column name */
  TimeDuration = 'timeDuration'
}

export type Driver_Window_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Driver_Window_Set_Input>;
  /** filter the rows which have to be updated */
  where: Driver_Window_Bool_Exp;
};

/** order by var_pop() on columns of table "driver_window" */
export type Driver_Window_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "driver_window" */
export type Driver_Window_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "driver_window" */
export type Driver_Window_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "driver_workload" */
export type Driver_Workload = {
  __typename?: 'driver_workload';
  /** An object relationship */
  driver: User;
  driverId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  timeZone?: Maybe<Scalars['Int']['output']>;
  timeperiod?: Maybe<Scalars['timestamptz']['output']>;
  workload?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "driver_workload" */
export type Driver_Workload_Aggregate = {
  __typename?: 'driver_workload_aggregate';
  aggregate?: Maybe<Driver_Workload_Aggregate_Fields>;
  nodes: Array<Driver_Workload>;
};

export type Driver_Workload_Aggregate_Bool_Exp = {
  count?: InputMaybe<Driver_Workload_Aggregate_Bool_Exp_Count>;
};

export type Driver_Workload_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Driver_Workload_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "driver_workload" */
export type Driver_Workload_Aggregate_Fields = {
  __typename?: 'driver_workload_aggregate_fields';
  avg?: Maybe<Driver_Workload_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Driver_Workload_Max_Fields>;
  min?: Maybe<Driver_Workload_Min_Fields>;
  stddev?: Maybe<Driver_Workload_Stddev_Fields>;
  stddev_pop?: Maybe<Driver_Workload_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Driver_Workload_Stddev_Samp_Fields>;
  sum?: Maybe<Driver_Workload_Sum_Fields>;
  var_pop?: Maybe<Driver_Workload_Var_Pop_Fields>;
  var_samp?: Maybe<Driver_Workload_Var_Samp_Fields>;
  variance?: Maybe<Driver_Workload_Variance_Fields>;
};


/** aggregate fields of "driver_workload" */
export type Driver_Workload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "driver_workload" */
export type Driver_Workload_Aggregate_Order_By = {
  avg?: InputMaybe<Driver_Workload_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Driver_Workload_Max_Order_By>;
  min?: InputMaybe<Driver_Workload_Min_Order_By>;
  stddev?: InputMaybe<Driver_Workload_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Driver_Workload_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Driver_Workload_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Driver_Workload_Sum_Order_By>;
  var_pop?: InputMaybe<Driver_Workload_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Driver_Workload_Var_Samp_Order_By>;
  variance?: InputMaybe<Driver_Workload_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Driver_Workload_Avg_Fields = {
  __typename?: 'driver_workload_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "driver_workload" */
export type Driver_Workload_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "driver_workload". All fields are combined with a logical 'AND'. */
export type Driver_Workload_Bool_Exp = {
  _and?: InputMaybe<Array<Driver_Workload_Bool_Exp>>;
  _not?: InputMaybe<Driver_Workload_Bool_Exp>;
  _or?: InputMaybe<Array<Driver_Workload_Bool_Exp>>;
  driver?: InputMaybe<User_Bool_Exp>;
  driverId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  timeZone?: InputMaybe<Int_Comparison_Exp>;
  timeperiod?: InputMaybe<Timestamptz_Comparison_Exp>;
  workload?: InputMaybe<Numeric_Comparison_Exp>;
};

export type Driver_Workload_For_Args = {
  district_id?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Driver_Workload_Max_Fields = {
  __typename?: 'driver_workload_max_fields';
  driverId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['Int']['output']>;
  timeperiod?: Maybe<Scalars['timestamptz']['output']>;
  workload?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "driver_workload" */
export type Driver_Workload_Max_Order_By = {
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Driver_Workload_Min_Fields = {
  __typename?: 'driver_workload_min_fields';
  driverId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['Int']['output']>;
  timeperiod?: Maybe<Scalars['timestamptz']['output']>;
  workload?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "driver_workload" */
export type Driver_Workload_Min_Order_By = {
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "driver_workload". */
export type Driver_Workload_Order_By = {
  driver?: InputMaybe<User_Order_By>;
  driverId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  timeperiod?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** select columns of table "driver_workload" */
export enum Driver_Workload_Select_Column {
  /** column name */
  DriverId = 'driverId',
  /** column name */
  Id = 'id',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  Timeperiod = 'timeperiod',
  /** column name */
  Workload = 'workload'
}

/** aggregate stddev on columns */
export type Driver_Workload_Stddev_Fields = {
  __typename?: 'driver_workload_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "driver_workload" */
export type Driver_Workload_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Driver_Workload_Stddev_Pop_Fields = {
  __typename?: 'driver_workload_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "driver_workload" */
export type Driver_Workload_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Driver_Workload_Stddev_Samp_Fields = {
  __typename?: 'driver_workload_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "driver_workload" */
export type Driver_Workload_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "driver_workload" */
export type Driver_Workload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Driver_Workload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Driver_Workload_Stream_Cursor_Value_Input = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  timeZone?: InputMaybe<Scalars['Int']['input']>;
  timeperiod?: InputMaybe<Scalars['timestamptz']['input']>;
  workload?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Driver_Workload_Sum_Fields = {
  __typename?: 'driver_workload_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['Int']['output']>;
  workload?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "driver_workload" */
export type Driver_Workload_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Driver_Workload_Var_Pop_Fields = {
  __typename?: 'driver_workload_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "driver_workload" */
export type Driver_Workload_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Driver_Workload_Var_Samp_Fields = {
  __typename?: 'driver_workload_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "driver_workload" */
export type Driver_Workload_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Driver_Workload_Variance_Fields = {
  __typename?: 'driver_workload_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  timeZone?: Maybe<Scalars['Float']['output']>;
  workload?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "driver_workload" */
export type Driver_Workload_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  workload?: InputMaybe<Order_By>;
};

/** columns and relationships of "firebase_message_token" */
export type Firebase_Message_Token = {
  __typename?: 'firebase_message_token';
  createdAt: Scalars['timestamp']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['String']['output'];
};

/** order by aggregate values of table "firebase_message_token" */
export type Firebase_Message_Token_Aggregate_Order_By = {
  avg?: InputMaybe<Firebase_Message_Token_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Firebase_Message_Token_Max_Order_By>;
  min?: InputMaybe<Firebase_Message_Token_Min_Order_By>;
  stddev?: InputMaybe<Firebase_Message_Token_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Firebase_Message_Token_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Firebase_Message_Token_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Firebase_Message_Token_Sum_Order_By>;
  var_pop?: InputMaybe<Firebase_Message_Token_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Firebase_Message_Token_Var_Samp_Order_By>;
  variance?: InputMaybe<Firebase_Message_Token_Variance_Order_By>;
};

/** order by avg() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "firebase_message_token". All fields are combined with a logical 'AND'. */
export type Firebase_Message_Token_Bool_Exp = {
  _and?: InputMaybe<Array<Firebase_Message_Token_Bool_Exp>>;
  _not?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
  _or?: InputMaybe<Array<Firebase_Message_Token_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  deviceId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "firebase_message_token" */
export enum Firebase_Message_Token_Constraint {
  /** unique or primary key constraint on columns "userId", "platform", "deviceId" */
  FirebaseMessageTokenDeviceUserPlatformUnique = 'firebase_message_token_device_user_platform_unique',
  /** unique or primary key constraint on columns "id" */
  FirebaseMessageTokenPkey = 'firebase_message_token_pkey'
}

/** input type for inserting data into table "firebase_message_token" */
export type Firebase_Message_Token_Insert_Input = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "firebase_message_token" */
export type Firebase_Message_Token_Mutation_Response = {
  __typename?: 'firebase_message_token_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Firebase_Message_Token>;
};

/** on_conflict condition type for table "firebase_message_token" */
export type Firebase_Message_Token_On_Conflict = {
  constraint: Firebase_Message_Token_Constraint;
  update_columns?: Array<Firebase_Message_Token_Update_Column>;
  where?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
};

/** Ordering options when selecting data from "firebase_message_token". */
export type Firebase_Message_Token_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  deviceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: firebase_message_token */
export type Firebase_Message_Token_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "firebase_message_token" */
export enum Firebase_Message_Token_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceId = 'deviceId',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "firebase_message_token" */
export type Firebase_Message_Token_Set_Input = {
  token?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "firebase_message_token" */
export type Firebase_Message_Token_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Firebase_Message_Token_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Firebase_Message_Token_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "firebase_message_token" */
export enum Firebase_Message_Token_Update_Column {
  /** column name */
  Token = 'token'
}

export type Firebase_Message_Token_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Firebase_Message_Token_Set_Input>;
  /** filter the rows which have to be updated */
  where: Firebase_Message_Token_Bool_Exp;
};

/** order by var_pop() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "firebase_message_token" */
export type Firebase_Message_Token_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "geo_event" */
export type Geo_Event = {
  __typename?: 'geo_event';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  lat: Scalars['numeric']['output'];
  lng: Scalars['numeric']['output'];
  orderChangeId: Scalars['Int']['output'];
  /** An object relationship */
  order_change: Order_Change;
};

/** Boolean expression to filter rows from the table "geo_event". All fields are combined with a logical 'AND'. */
export type Geo_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Geo_Event_Bool_Exp>>;
  _not?: InputMaybe<Geo_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Geo_Event_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  orderChangeId?: InputMaybe<Int_Comparison_Exp>;
  order_change?: InputMaybe<Order_Change_Bool_Exp>;
};

/** Ordering options when selecting data from "geo_event". */
export type Geo_Event_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  orderChangeId?: InputMaybe<Order_By>;
  order_change?: InputMaybe<Order_Change_Order_By>;
};

/** select columns of table "geo_event" */
export enum Geo_Event_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  OrderChangeId = 'orderChangeId'
}

/** Streaming cursor of the table "geo_event" */
export type Geo_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Geo_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Geo_Event_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  orderChangeId?: InputMaybe<Scalars['Int']['input']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "login_log" */
export type Login_Log = {
  __typename?: 'login_log';
  appVersion: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  device: Scalars['String']['output'];
  fingerprint: Scalars['String']['output'];
  hasBgPermissions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastSeenAt: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: User;
  userId: Scalars['String']['output'];
};

/** order by aggregate values of table "login_log" */
export type Login_Log_Aggregate_Order_By = {
  avg?: InputMaybe<Login_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Login_Log_Max_Order_By>;
  min?: InputMaybe<Login_Log_Min_Order_By>;
  stddev?: InputMaybe<Login_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Login_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Login_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Login_Log_Sum_Order_By>;
  var_pop?: InputMaybe<Login_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Login_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<Login_Log_Variance_Order_By>;
};

/** order by avg() on columns of table "login_log" */
export type Login_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "login_log". All fields are combined with a logical 'AND'. */
export type Login_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Login_Log_Bool_Exp>>;
  _not?: InputMaybe<Login_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Login_Log_Bool_Exp>>;
  appVersion?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  device?: InputMaybe<String_Comparison_Exp>;
  fingerprint?: InputMaybe<String_Comparison_Exp>;
  hasBgPermissions?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lastSeenAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "login_log" */
export type Login_Log_Max_Order_By = {
  appVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "login_log" */
export type Login_Log_Min_Order_By = {
  appVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "login_log". */
export type Login_Log_Order_By = {
  appVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  device?: InputMaybe<Order_By>;
  fingerprint?: InputMaybe<Order_By>;
  hasBgPermissions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeenAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "login_log" */
export enum Login_Log_Select_Column {
  /** column name */
  AppVersion = 'appVersion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Device = 'device',
  /** column name */
  Fingerprint = 'fingerprint',
  /** column name */
  HasBgPermissions = 'hasBgPermissions',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeenAt = 'lastSeenAt',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "login_log" */
export type Login_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "login_log" */
export type Login_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "login_log" */
export type Login_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "login_log" */
export type Login_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Login_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Login_Log_Stream_Cursor_Value_Input = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<Scalars['String']['input']>;
  hasBgPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastSeenAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "login_log" */
export type Login_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "login_log" */
export type Login_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "login_log" */
export type Login_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "login_log" */
export type Login_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  blockUser?: Maybe<ApplyResponse>;
  changeDistrictProviders?: Maybe<ApplyResponse>;
  createUser?: Maybe<DartApiResponse>;
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** delete data from the table: "client" */
  delete_client?: Maybe<Client_Mutation_Response>;
  /** delete single row from the table: "client" */
  delete_client_by_pk?: Maybe<Client>;
  /** delete data from the table: "country_holiday" */
  delete_country_holiday?: Maybe<Country_Holiday_Mutation_Response>;
  /** delete single row from the table: "country_holiday" */
  delete_country_holiday_by_pk?: Maybe<Country_Holiday>;
  /** delete data from the table: "departments_users" */
  delete_departments_users?: Maybe<Departments_Users_Mutation_Response>;
  /** delete single row from the table: "departments_users" */
  delete_departments_users_by_pk?: Maybe<Departments_Users>;
  /** delete data from the table: "district_delivery_providers" */
  delete_district_delivery_providers?: Maybe<District_Delivery_Providers_Mutation_Response>;
  /** delete single row from the table: "district_delivery_providers" */
  delete_district_delivery_providers_by_pk?: Maybe<District_Delivery_Providers>;
  /** delete data from the table: "driver_district" */
  delete_driver_district?: Maybe<Driver_District_Mutation_Response>;
  /** delete single row from the table: "driver_district" */
  delete_driver_district_by_pk?: Maybe<Driver_District>;
  /** delete data from the table: "driver_holiday" */
  delete_driver_holiday?: Maybe<Driver_Holiday_Mutation_Response>;
  /** delete single row from the table: "driver_holiday" */
  delete_driver_holiday_by_pk?: Maybe<Driver_Holiday>;
  /** delete data from the table: "driver_window" */
  delete_driver_window?: Maybe<Driver_Window_Mutation_Response>;
  /** delete single row from the table: "driver_window" */
  delete_driver_window_by_pk?: Maybe<Driver_Window>;
  /** delete data from the table: "firebase_message_token" */
  delete_firebase_message_token?: Maybe<Firebase_Message_Token_Mutation_Response>;
  /** delete single row from the table: "firebase_message_token" */
  delete_firebase_message_token_by_pk?: Maybe<Firebase_Message_Token>;
  /** delete data from the table: "order_position" */
  delete_order_position?: Maybe<Order_Position_Mutation_Response>;
  /** delete single row from the table: "order_position" */
  delete_order_position_by_pk?: Maybe<Order_Position>;
  /** delete data from the table: "weekday_window" */
  delete_weekday_window?: Maybe<Weekday_Window_Mutation_Response>;
  /** delete single row from the table: "weekday_window" */
  delete_weekday_window_by_pk?: Maybe<Weekday_Window>;
  /** delete data from the table: "weekday_window_district" */
  delete_weekday_window_district?: Maybe<Weekday_Window_District_Mutation_Response>;
  /** delete single row from the table: "weekday_window_district" */
  delete_weekday_window_district_by_pk?: Maybe<Weekday_Window_District>;
  /** delete data from the table: "window_delivery_providers" */
  delete_window_delivery_providers?: Maybe<Window_Delivery_Providers_Mutation_Response>;
  /** delete single row from the table: "window_delivery_providers" */
  delete_window_delivery_providers_by_pk?: Maybe<Window_Delivery_Providers>;
  editOrder?: Maybe<OrderItemOutput>;
  editUser?: Maybe<ApplyResponse>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "client" */
  insert_client?: Maybe<Client_Mutation_Response>;
  /** insert a single row into the table: "client" */
  insert_client_one?: Maybe<Client>;
  /** insert data into the table: "country_holiday" */
  insert_country_holiday?: Maybe<Country_Holiday_Mutation_Response>;
  /** insert a single row into the table: "country_holiday" */
  insert_country_holiday_one?: Maybe<Country_Holiday>;
  /** insert data into the table: "departments_users" */
  insert_departments_users?: Maybe<Departments_Users_Mutation_Response>;
  /** insert a single row into the table: "departments_users" */
  insert_departments_users_one?: Maybe<Departments_Users>;
  /** insert data into the table: "district_delivery_providers" */
  insert_district_delivery_providers?: Maybe<District_Delivery_Providers_Mutation_Response>;
  /** insert a single row into the table: "district_delivery_providers" */
  insert_district_delivery_providers_one?: Maybe<District_Delivery_Providers>;
  /** insert data into the table: "driver_district" */
  insert_driver_district?: Maybe<Driver_District_Mutation_Response>;
  /** insert a single row into the table: "driver_district" */
  insert_driver_district_one?: Maybe<Driver_District>;
  /** insert data into the table: "driver_holiday" */
  insert_driver_holiday?: Maybe<Driver_Holiday_Mutation_Response>;
  /** insert a single row into the table: "driver_holiday" */
  insert_driver_holiday_one?: Maybe<Driver_Holiday>;
  /** insert data into the table: "driver_window" */
  insert_driver_window?: Maybe<Driver_Window_Mutation_Response>;
  /** insert a single row into the table: "driver_window" */
  insert_driver_window_one?: Maybe<Driver_Window>;
  /** insert data into the table: "firebase_message_token" */
  insert_firebase_message_token?: Maybe<Firebase_Message_Token_Mutation_Response>;
  /** insert a single row into the table: "firebase_message_token" */
  insert_firebase_message_token_one?: Maybe<Firebase_Message_Token>;
  /** insert data into the table: "order_comments" */
  insert_order_comments?: Maybe<Order_Comments_Mutation_Response>;
  /** insert a single row into the table: "order_comments" */
  insert_order_comments_one?: Maybe<Order_Comments>;
  /** insert data into the table: "order_photo" */
  insert_order_photo?: Maybe<Order_Photo_Mutation_Response>;
  /** insert a single row into the table: "order_photo" */
  insert_order_photo_one?: Maybe<Order_Photo>;
  /** insert data into the table: "order_position" */
  insert_order_position?: Maybe<Order_Position_Mutation_Response>;
  /** insert a single row into the table: "order_position" */
  insert_order_position_one?: Maybe<Order_Position>;
  /** insert data into the table: "user_views_log" */
  insert_user_views_log?: Maybe<User_Views_Log_Mutation_Response>;
  /** insert a single row into the table: "user_views_log" */
  insert_user_views_log_one?: Maybe<User_Views_Log>;
  /** insert data into the table: "weekday_window" */
  insert_weekday_window?: Maybe<Weekday_Window_Mutation_Response>;
  /** insert data into the table: "weekday_window_district" */
  insert_weekday_window_district?: Maybe<Weekday_Window_District_Mutation_Response>;
  /** insert a single row into the table: "weekday_window_district" */
  insert_weekday_window_district_one?: Maybe<Weekday_Window_District>;
  /** insert a single row into the table: "weekday_window" */
  insert_weekday_window_one?: Maybe<Weekday_Window>;
  /** insert data into the table: "window_delivery_providers" */
  insert_window_delivery_providers?: Maybe<Window_Delivery_Providers_Mutation_Response>;
  /** insert a single row into the table: "window_delivery_providers" */
  insert_window_delivery_providers_one?: Maybe<Window_Delivery_Providers>;
  removeUserFcmToken?: Maybe<ApplyResponse>;
  replaceUserFCMToken?: Maybe<ApplyResponse>;
  toggleDepartmentExpress: ToggleResponse;
  updateDeliveryAreasFromGeo?: Maybe<ApplyResponse>;
  updateOrder?: Maybe<ApplyResponse>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "client" */
  update_client?: Maybe<Client_Mutation_Response>;
  /** update single row of the table: "client" */
  update_client_by_pk?: Maybe<Client>;
  /** update multiples rows of table: "client" */
  update_client_many?: Maybe<Array<Maybe<Client_Mutation_Response>>>;
  /** update data of the table: "department" */
  update_department?: Maybe<Department_Mutation_Response>;
  /** update single row of the table: "department" */
  update_department_by_pk?: Maybe<Department>;
  /** update multiples rows of table: "department" */
  update_department_many?: Maybe<Array<Maybe<Department_Mutation_Response>>>;
  /** update data of the table: "district" */
  update_district?: Maybe<District_Mutation_Response>;
  /** update single row of the table: "district" */
  update_district_by_pk?: Maybe<District>;
  /** update multiples rows of table: "district" */
  update_district_many?: Maybe<Array<Maybe<District_Mutation_Response>>>;
  /** update data of the table: "driver_window" */
  update_driver_window?: Maybe<Driver_Window_Mutation_Response>;
  /** update single row of the table: "driver_window" */
  update_driver_window_by_pk?: Maybe<Driver_Window>;
  /** update multiples rows of table: "driver_window" */
  update_driver_window_many?: Maybe<Array<Maybe<Driver_Window_Mutation_Response>>>;
  /** update data of the table: "firebase_message_token" */
  update_firebase_message_token?: Maybe<Firebase_Message_Token_Mutation_Response>;
  /** update single row of the table: "firebase_message_token" */
  update_firebase_message_token_by_pk?: Maybe<Firebase_Message_Token>;
  /** update multiples rows of table: "firebase_message_token" */
  update_firebase_message_token_many?: Maybe<Array<Maybe<Firebase_Message_Token_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update data of the table: "order_comments" */
  update_order_comments?: Maybe<Order_Comments_Mutation_Response>;
  /** update single row of the table: "order_comments" */
  update_order_comments_by_pk?: Maybe<Order_Comments>;
  /** update multiples rows of table: "order_comments" */
  update_order_comments_many?: Maybe<Array<Maybe<Order_Comments_Mutation_Response>>>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "order_photo" */
  update_order_photo?: Maybe<Order_Photo_Mutation_Response>;
  /** update single row of the table: "order_photo" */
  update_order_photo_by_pk?: Maybe<Order_Photo>;
  /** update multiples rows of table: "order_photo" */
  update_order_photo_many?: Maybe<Array<Maybe<Order_Photo_Mutation_Response>>>;
  /** update data of the table: "order_position" */
  update_order_position?: Maybe<Order_Position_Mutation_Response>;
  /** update single row of the table: "order_position" */
  update_order_position_by_pk?: Maybe<Order_Position>;
  /** update multiples rows of table: "order_position" */
  update_order_position_many?: Maybe<Array<Maybe<Order_Position_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "weekday_window" */
  update_weekday_window?: Maybe<Weekday_Window_Mutation_Response>;
  /** update single row of the table: "weekday_window" */
  update_weekday_window_by_pk?: Maybe<Weekday_Window>;
  /** update data of the table: "weekday_window_district" */
  update_weekday_window_district?: Maybe<Weekday_Window_District_Mutation_Response>;
  /** update single row of the table: "weekday_window_district" */
  update_weekday_window_district_by_pk?: Maybe<Weekday_Window_District>;
  /** update multiples rows of table: "weekday_window_district" */
  update_weekday_window_district_many?: Maybe<Array<Maybe<Weekday_Window_District_Mutation_Response>>>;
  /** update multiples rows of table: "weekday_window" */
  update_weekday_window_many?: Maybe<Array<Maybe<Weekday_Window_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootBlockUserArgs = {
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootChangeDistrictProvidersArgs = {
  districtId: Scalars['String']['input'];
  providers: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  user: UserCreateInput;
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ClientArgs = {
  where: Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Client_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Country_HolidayArgs = {
  where: Country_Holiday_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Departments_UsersArgs = {
  where: Departments_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Departments_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_District_Delivery_ProvidersArgs = {
  where: District_Delivery_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_District_Delivery_Providers_By_PkArgs = {
  delivery_provider_id: Scalars['uuid']['input'];
  district_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_DistrictArgs = {
  where: Driver_District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_HolidayArgs = {
  where: Driver_Holiday_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Driver_WindowArgs = {
  where: Driver_Window_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Driver_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Firebase_Message_TokenArgs = {
  where: Firebase_Message_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Firebase_Message_Token_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_PositionArgs = {
  where: Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Position_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weekday_WindowArgs = {
  where: Weekday_Window_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weekday_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Weekday_Window_DistrictArgs = {
  where: Weekday_Window_District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Weekday_Window_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Window_Delivery_ProvidersArgs = {
  where: Window_Delivery_Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Window_Delivery_Providers_By_PkArgs = {
  provider_id: Scalars['uuid']['input'];
  window_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootEditOrderArgs = {
  orderID: Scalars['Int']['input'];
  orderItems: Array<InputMaybe<OrderItemInput>>;
  umbrellaID: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootEditUserArgs = {
  user: UserEditInput;
  userId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClientArgs = {
  objects: Array<Client_Insert_Input>;
  on_conflict?: InputMaybe<Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Client_OneArgs = {
  object: Client_Insert_Input;
  on_conflict?: InputMaybe<Client_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_HolidayArgs = {
  objects: Array<Country_Holiday_Insert_Input>;
  on_conflict?: InputMaybe<Country_Holiday_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_Holiday_OneArgs = {
  object: Country_Holiday_Insert_Input;
  on_conflict?: InputMaybe<Country_Holiday_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Departments_UsersArgs = {
  objects: Array<Departments_Users_Insert_Input>;
  on_conflict?: InputMaybe<Departments_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Departments_Users_OneArgs = {
  object: Departments_Users_Insert_Input;
  on_conflict?: InputMaybe<Departments_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_District_Delivery_ProvidersArgs = {
  objects: Array<District_Delivery_Providers_Insert_Input>;
  on_conflict?: InputMaybe<District_Delivery_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_District_Delivery_Providers_OneArgs = {
  object: District_Delivery_Providers_Insert_Input;
  on_conflict?: InputMaybe<District_Delivery_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_DistrictArgs = {
  objects: Array<Driver_District_Insert_Input>;
  on_conflict?: InputMaybe<Driver_District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_District_OneArgs = {
  object: Driver_District_Insert_Input;
  on_conflict?: InputMaybe<Driver_District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_HolidayArgs = {
  objects: Array<Driver_Holiday_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Holiday_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Holiday_OneArgs = {
  object: Driver_Holiday_Insert_Input;
  on_conflict?: InputMaybe<Driver_Holiday_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_WindowArgs = {
  objects: Array<Driver_Window_Insert_Input>;
  on_conflict?: InputMaybe<Driver_Window_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Driver_Window_OneArgs = {
  object: Driver_Window_Insert_Input;
  on_conflict?: InputMaybe<Driver_Window_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Firebase_Message_TokenArgs = {
  objects: Array<Firebase_Message_Token_Insert_Input>;
  on_conflict?: InputMaybe<Firebase_Message_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Firebase_Message_Token_OneArgs = {
  object: Firebase_Message_Token_Insert_Input;
  on_conflict?: InputMaybe<Firebase_Message_Token_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_CommentsArgs = {
  objects: Array<Order_Comments_Insert_Input>;
  on_conflict?: InputMaybe<Order_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Comments_OneArgs = {
  object: Order_Comments_Insert_Input;
  on_conflict?: InputMaybe<Order_Comments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_PhotoArgs = {
  objects: Array<Order_Photo_Insert_Input>;
  on_conflict?: InputMaybe<Order_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Photo_OneArgs = {
  object: Order_Photo_Insert_Input;
  on_conflict?: InputMaybe<Order_Photo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_PositionArgs = {
  objects: Array<Order_Position_Insert_Input>;
  on_conflict?: InputMaybe<Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Position_OneArgs = {
  object: Order_Position_Insert_Input;
  on_conflict?: InputMaybe<Order_Position_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Views_LogArgs = {
  objects: Array<User_Views_Log_Insert_Input>;
  on_conflict?: InputMaybe<User_Views_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Views_Log_OneArgs = {
  object: User_Views_Log_Insert_Input;
  on_conflict?: InputMaybe<User_Views_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weekday_WindowArgs = {
  objects: Array<Weekday_Window_Insert_Input>;
  on_conflict?: InputMaybe<Weekday_Window_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weekday_Window_DistrictArgs = {
  objects: Array<Weekday_Window_District_Insert_Input>;
  on_conflict?: InputMaybe<Weekday_Window_District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weekday_Window_District_OneArgs = {
  object: Weekday_Window_District_Insert_Input;
  on_conflict?: InputMaybe<Weekday_Window_District_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Weekday_Window_OneArgs = {
  object: Weekday_Window_Insert_Input;
  on_conflict?: InputMaybe<Weekday_Window_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Window_Delivery_ProvidersArgs = {
  objects: Array<Window_Delivery_Providers_Insert_Input>;
  on_conflict?: InputMaybe<Window_Delivery_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Window_Delivery_Providers_OneArgs = {
  object: Window_Delivery_Providers_Insert_Input;
  on_conflict?: InputMaybe<Window_Delivery_Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootRemoveUserFcmTokenArgs = {
  token: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootReplaceUserFcmTokenArgs = {
  data: FcmInput;
};


/** mutation root */
export type Mutation_RootToggleDepartmentExpressArgs = {
  data: ToggleInput;
};


/** mutation root */
export type Mutation_RootUpdateDeliveryAreasFromGeoArgs = {
  countryCode: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdateOrderArgs = {
  address?: InputMaybe<AddressPatch>;
  client?: InputMaybe<ClientPatch>;
  order?: InputMaybe<OrderPatch>;
  orderId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClientArgs = {
  _inc?: InputMaybe<Client_Inc_Input>;
  _set?: InputMaybe<Client_Set_Input>;
  where: Client_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Client_By_PkArgs = {
  _inc?: InputMaybe<Client_Inc_Input>;
  _set?: InputMaybe<Client_Set_Input>;
  pk_columns: Client_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Client_ManyArgs = {
  updates: Array<Client_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DepartmentArgs = {
  _set?: InputMaybe<Department_Set_Input>;
  where: Department_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Department_By_PkArgs = {
  _set?: InputMaybe<Department_Set_Input>;
  pk_columns: Department_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Department_ManyArgs = {
  updates: Array<Department_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DistrictArgs = {
  _append?: InputMaybe<District_Append_Input>;
  _delete_at_path?: InputMaybe<District_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<District_Delete_Elem_Input>;
  _delete_key?: InputMaybe<District_Delete_Key_Input>;
  _inc?: InputMaybe<District_Inc_Input>;
  _prepend?: InputMaybe<District_Prepend_Input>;
  _set?: InputMaybe<District_Set_Input>;
  where: District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_District_By_PkArgs = {
  _append?: InputMaybe<District_Append_Input>;
  _delete_at_path?: InputMaybe<District_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<District_Delete_Elem_Input>;
  _delete_key?: InputMaybe<District_Delete_Key_Input>;
  _inc?: InputMaybe<District_Inc_Input>;
  _prepend?: InputMaybe<District_Prepend_Input>;
  _set?: InputMaybe<District_Set_Input>;
  pk_columns: District_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_District_ManyArgs = {
  updates: Array<District_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_WindowArgs = {
  _set?: InputMaybe<Driver_Window_Set_Input>;
  where: Driver_Window_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Window_By_PkArgs = {
  _set?: InputMaybe<Driver_Window_Set_Input>;
  pk_columns: Driver_Window_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Driver_Window_ManyArgs = {
  updates: Array<Driver_Window_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_Message_TokenArgs = {
  _set?: InputMaybe<Firebase_Message_Token_Set_Input>;
  where: Firebase_Message_Token_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_Message_Token_By_PkArgs = {
  _set?: InputMaybe<Firebase_Message_Token_Set_Input>;
  pk_columns: Firebase_Message_Token_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Firebase_Message_Token_ManyArgs = {
  updates: Array<Firebase_Message_Token_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _inc?: InputMaybe<Order_Inc_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_CommentsArgs = {
  _set?: InputMaybe<Order_Comments_Set_Input>;
  where: Order_Comments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Comments_By_PkArgs = {
  _set?: InputMaybe<Order_Comments_Set_Input>;
  pk_columns: Order_Comments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Comments_ManyArgs = {
  updates: Array<Order_Comments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_PhotoArgs = {
  _inc?: InputMaybe<Order_Photo_Inc_Input>;
  _set?: InputMaybe<Order_Photo_Set_Input>;
  where: Order_Photo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Photo_By_PkArgs = {
  _inc?: InputMaybe<Order_Photo_Inc_Input>;
  _set?: InputMaybe<Order_Photo_Set_Input>;
  pk_columns: Order_Photo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Photo_ManyArgs = {
  updates: Array<Order_Photo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_PositionArgs = {
  _inc?: InputMaybe<Order_Position_Inc_Input>;
  _set?: InputMaybe<Order_Position_Set_Input>;
  where: Order_Position_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Position_By_PkArgs = {
  _inc?: InputMaybe<Order_Position_Inc_Input>;
  _set?: InputMaybe<Order_Position_Set_Input>;
  pk_columns: Order_Position_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Position_ManyArgs = {
  updates: Array<Order_Position_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_WindowArgs = {
  _set?: InputMaybe<Weekday_Window_Set_Input>;
  where: Weekday_Window_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_Window_By_PkArgs = {
  _set?: InputMaybe<Weekday_Window_Set_Input>;
  pk_columns: Weekday_Window_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_Window_DistrictArgs = {
  _inc?: InputMaybe<Weekday_Window_District_Inc_Input>;
  _set?: InputMaybe<Weekday_Window_District_Set_Input>;
  where: Weekday_Window_District_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_Window_District_By_PkArgs = {
  _inc?: InputMaybe<Weekday_Window_District_Inc_Input>;
  _set?: InputMaybe<Weekday_Window_District_Set_Input>;
  pk_columns: Weekday_Window_District_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_Window_District_ManyArgs = {
  updates: Array<Weekday_Window_District_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Weekday_Window_ManyArgs = {
  updates: Array<Weekday_Window_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  /** An object relationship */
  client: Client;
  clientID: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deliveredDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  delivery_provider?: Maybe<Delivery_Provider>;
  delivery_provider_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  department: Department;
  departmentId: Scalars['Int']['output'];
  /** An object relationship */
  district?: Maybe<District>;
  /** An object relationship */
  driver?: Maybe<User>;
  driverID?: Maybe<Scalars['String']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  important?: Maybe<Scalars['Boolean']['output']>;
  isRescheduled: Scalars['Boolean']['output'];
  isReturned: Scalars['Boolean']['output'];
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  order_changes: Array<Order_Change>;
  /** An aggregate relationship */
  order_changes_aggregate: Order_Change_Aggregate;
  /** An array relationship */
  order_comments: Array<Order_Comments>;
  /** An array relationship */
  order_photos: Array<Order_Photo>;
  paymentExpirationDate?: Maybe<Scalars['timestamptz']['output']>;
  paymentType?: Maybe<Payment_Type_Enum>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['timestamptz']['output']>;
  plannedDateDuration?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  positions: Array<Order_Position>;
  reasonRefusal?: Maybe<Scalars['String']['output']>;
  resale?: Maybe<Scalars['Boolean']['output']>;
  rescheduleCount?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  status: Status;
  statusName: Scalars['String']['output'];
  telegramUserEmail?: Maybe<Scalars['String']['output']>;
  totalCents: Scalars['Int']['output'];
  umbrellaID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  user_views_logs: Array<User_Views_Log>;
  vendorDatalinkId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  warehouse?: Maybe<Warehouse>;
};


/** columns and relationships of "order" */
export type OrderOrder_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Comments_Order_By>>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_PhotosArgs = {
  distinct_on?: InputMaybe<Array<Order_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photo_Order_By>>;
  where?: InputMaybe<Order_Photo_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderPositionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Position_Order_By>>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderUser_Views_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Views_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Views_Log_Order_By>>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
};

export type Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
  stddev?: InputMaybe<Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order" */
export type Order_Avg_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  client?: InputMaybe<Client_Bool_Exp>;
  clientID?: InputMaybe<Int_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveredDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_provider?: InputMaybe<Delivery_Provider_Bool_Exp>;
  delivery_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  department?: InputMaybe<Department_Bool_Exp>;
  departmentId?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<District_Bool_Exp>;
  driver?: InputMaybe<User_Bool_Exp>;
  driverID?: InputMaybe<String_Comparison_Exp>;
  driverRefuseReasonId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  important?: InputMaybe<Boolean_Comparison_Exp>;
  isRescheduled?: InputMaybe<Boolean_Comparison_Exp>;
  isReturned?: InputMaybe<Boolean_Comparison_Exp>;
  isSaved?: InputMaybe<Boolean_Comparison_Exp>;
  operatorRefuseReasonId?: InputMaybe<Int_Comparison_Exp>;
  order_changes?: InputMaybe<Order_Change_Bool_Exp>;
  order_changes_aggregate?: InputMaybe<Order_Change_Aggregate_Bool_Exp>;
  order_comments?: InputMaybe<Order_Comments_Bool_Exp>;
  order_photos?: InputMaybe<Order_Photo_Bool_Exp>;
  paymentExpirationDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  paymentType?: InputMaybe<Payment_Type_Enum_Comparison_Exp>;
  paymentUrl?: InputMaybe<String_Comparison_Exp>;
  plannedDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  plannedDateDuration?: InputMaybe<Int_Comparison_Exp>;
  positions?: InputMaybe<Order_Position_Bool_Exp>;
  reasonRefusal?: InputMaybe<String_Comparison_Exp>;
  resale?: InputMaybe<Boolean_Comparison_Exp>;
  rescheduleCount?: InputMaybe<Int_Comparison_Exp>;
  shipmentId?: InputMaybe<Int_Comparison_Exp>;
  shortCode?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Status_Bool_Exp>;
  statusName?: InputMaybe<String_Comparison_Exp>;
  telegramUserEmail?: InputMaybe<String_Comparison_Exp>;
  totalCents?: InputMaybe<Int_Comparison_Exp>;
  umbrellaID?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_views_logs?: InputMaybe<User_Views_Log_Bool_Exp>;
  vendorDatalinkId?: InputMaybe<Int_Comparison_Exp>;
  warehouse?: InputMaybe<Warehouse_Bool_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_change" */
export type Order_Change = {
  __typename?: 'order_change';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  editor?: Maybe<User>;
  editorId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  geo_event?: Maybe<Geo_Event>;
  id: Scalars['bigint']['output'];
  new: Scalars['jsonb']['output'];
  old: Scalars['jsonb']['output'];
  /** An object relationship */
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "order_change" */
export type Order_ChangeNewArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "order_change" */
export type Order_ChangeOldArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "order_change" */
export type Order_Change_Aggregate = {
  __typename?: 'order_change_aggregate';
  aggregate?: Maybe<Order_Change_Aggregate_Fields>;
  nodes: Array<Order_Change>;
};

export type Order_Change_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Change_Aggregate_Bool_Exp_Count>;
};

export type Order_Change_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Change_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Change_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_change" */
export type Order_Change_Aggregate_Fields = {
  __typename?: 'order_change_aggregate_fields';
  avg?: Maybe<Order_Change_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Change_Max_Fields>;
  min?: Maybe<Order_Change_Min_Fields>;
  stddev?: Maybe<Order_Change_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Change_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Change_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Change_Sum_Fields>;
  var_pop?: Maybe<Order_Change_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Change_Var_Samp_Fields>;
  variance?: Maybe<Order_Change_Variance_Fields>;
};


/** aggregate fields of "order_change" */
export type Order_Change_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Change_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_change" */
export type Order_Change_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Change_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Change_Max_Order_By>;
  min?: InputMaybe<Order_Change_Min_Order_By>;
  stddev?: InputMaybe<Order_Change_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Change_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Change_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Change_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Change_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Change_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Change_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Change_Avg_Fields = {
  __typename?: 'order_change_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "order_change" */
export type Order_Change_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_change". All fields are combined with a logical 'AND'. */
export type Order_Change_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Change_Bool_Exp>>;
  _not?: InputMaybe<Order_Change_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Change_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  editor?: InputMaybe<User_Bool_Exp>;
  editorId?: InputMaybe<String_Comparison_Exp>;
  geo_event?: InputMaybe<Geo_Event_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  new?: InputMaybe<Jsonb_Comparison_Exp>;
  old?: InputMaybe<Jsonb_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Change_Max_Fields = {
  __typename?: 'order_change_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  editorId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "order_change" */
export type Order_Change_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  editorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Change_Min_Fields = {
  __typename?: 'order_change_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  editorId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "order_change" */
export type Order_Change_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  editorId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_change". */
export type Order_Change_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  editor?: InputMaybe<User_Order_By>;
  editorId?: InputMaybe<Order_By>;
  geo_event?: InputMaybe<Geo_Event_Order_By>;
  id?: InputMaybe<Order_By>;
  new?: InputMaybe<Order_By>;
  old?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** select columns of table "order_change" */
export enum Order_Change_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EditorId = 'editorId',
  /** column name */
  Id = 'id',
  /** column name */
  New = 'new',
  /** column name */
  Old = 'old',
  /** column name */
  OrderId = 'orderId'
}

/** aggregate stddev on columns */
export type Order_Change_Stddev_Fields = {
  __typename?: 'order_change_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order_change" */
export type Order_Change_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Change_Stddev_Pop_Fields = {
  __typename?: 'order_change_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order_change" */
export type Order_Change_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Change_Stddev_Samp_Fields = {
  __typename?: 'order_change_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order_change" */
export type Order_Change_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_change" */
export type Order_Change_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Change_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Change_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  editorId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  new?: InputMaybe<Scalars['jsonb']['input']>;
  old?: InputMaybe<Scalars['jsonb']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Order_Change_Sum_Fields = {
  __typename?: 'order_change_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "order_change" */
export type Order_Change_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Change_Var_Pop_Fields = {
  __typename?: 'order_change_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order_change" */
export type Order_Change_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Change_Var_Samp_Fields = {
  __typename?: 'order_change_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order_change" */
export type Order_Change_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Change_Variance_Fields = {
  __typename?: 'order_change_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  orderId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order_change" */
export type Order_Change_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Stores all order's comments */
export type Order_Comments = {
  __typename?: 'order_comments';
  authorId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  externalAuthor?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isRefuseReason?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  order: Order;
  orderId: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
};

/** order by aggregate values of table "order_comments" */
export type Order_Comments_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Comments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Comments_Max_Order_By>;
  min?: InputMaybe<Order_Comments_Min_Order_By>;
  stddev?: InputMaybe<Order_Comments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Comments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Comments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Comments_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Comments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Comments_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Comments_Variance_Order_By>;
};

/** order by avg() on columns of table "order_comments" */
export type Order_Comments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_comments". All fields are combined with a logical 'AND'. */
export type Order_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Comments_Bool_Exp>>;
  _not?: InputMaybe<Order_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Comments_Bool_Exp>>;
  authorId?: InputMaybe<String_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalAuthor?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isRefuseReason?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "order_comments" */
export enum Order_Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderCommentsPkey = 'order_comments_pkey'
}

/** input type for inserting data into table "order_comments" */
export type Order_Comments_Insert_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalAuthor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isRefuseReason?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "order_comments" */
export type Order_Comments_Max_Order_By = {
  authorId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalAuthor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_comments" */
export type Order_Comments_Min_Order_By = {
  authorId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalAuthor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_comments" */
export type Order_Comments_Mutation_Response = {
  __typename?: 'order_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Comments>;
};

/** on_conflict condition type for table "order_comments" */
export type Order_Comments_On_Conflict = {
  constraint: Order_Comments_Constraint;
  update_columns?: Array<Order_Comments_Update_Column>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "order_comments". */
export type Order_Comments_Order_By = {
  authorId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  externalAuthor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isRefuseReason?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: order_comments */
export type Order_Comments_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "order_comments" */
export enum Order_Comments_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExternalAuthor = 'externalAuthor',
  /** column name */
  Id = 'id',
  /** column name */
  IsRefuseReason = 'isRefuseReason',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "order_comments" */
export type Order_Comments_Set_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalAuthor?: InputMaybe<Scalars['String']['input']>;
  isRefuseReason?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "order_comments" */
export type Order_Comments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_comments" */
export type Order_Comments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_comments" */
export type Order_Comments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_comments" */
export type Order_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Comments_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalAuthor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isRefuseReason?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "order_comments" */
export type Order_Comments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** update columns of table "order_comments" */
export enum Order_Comments_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExternalAuthor = 'externalAuthor',
  /** column name */
  IsRefuseReason = 'isRefuseReason',
  /** column name */
  Source = 'source'
}

export type Order_Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Comments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Comments_Bool_Exp;
};

/** order by var_pop() on columns of table "order_comments" */
export type Order_Comments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_comments" */
export type Order_Comments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_comments" */
export type Order_Comments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "order" */
export type Order_Inc_Input = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  driverRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  plannedDateDuration?: InputMaybe<Scalars['Int']['input']>;
  totalCents?: InputMaybe<Scalars['Int']['input']>;
  vendorDatalinkId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  clientID?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveredDate?: Maybe<Scalars['timestamptz']['output']>;
  delivery_provider_id?: Maybe<Scalars['uuid']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  driverID?: Maybe<Scalars['String']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  paymentExpirationDate?: Maybe<Scalars['timestamptz']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['timestamptz']['output']>;
  plannedDateDuration?: Maybe<Scalars['Int']['output']>;
  reasonRefusal?: Maybe<Scalars['String']['output']>;
  rescheduleCount?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<Scalars['String']['output']>;
  telegramUserEmail?: Maybe<Scalars['String']['output']>;
  totalCents?: Maybe<Scalars['Int']['output']>;
  umbrellaID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  clientID?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredDate?: InputMaybe<Order_By>;
  delivery_provider_id?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverID?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  paymentExpirationDate?: InputMaybe<Order_By>;
  paymentUrl?: InputMaybe<Order_By>;
  plannedDate?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  reasonRefusal?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  shortCode?: InputMaybe<Order_By>;
  statusName?: InputMaybe<Order_By>;
  telegramUserEmail?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  umbrellaID?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  clientID?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveredDate?: Maybe<Scalars['timestamptz']['output']>;
  delivery_provider_id?: Maybe<Scalars['uuid']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  driverID?: Maybe<Scalars['String']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  paymentExpirationDate?: Maybe<Scalars['timestamptz']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  plannedDate?: Maybe<Scalars['timestamptz']['output']>;
  plannedDateDuration?: Maybe<Scalars['Int']['output']>;
  reasonRefusal?: Maybe<Scalars['String']['output']>;
  rescheduleCount?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  statusName?: Maybe<Scalars['String']['output']>;
  telegramUserEmail?: Maybe<Scalars['String']['output']>;
  totalCents?: Maybe<Scalars['Int']['output']>;
  umbrellaID?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  clientID?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredDate?: InputMaybe<Order_By>;
  delivery_provider_id?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverID?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  paymentExpirationDate?: InputMaybe<Order_By>;
  paymentUrl?: InputMaybe<Order_By>;
  plannedDate?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  reasonRefusal?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  shortCode?: InputMaybe<Order_By>;
  statusName?: InputMaybe<Order_By>;
  telegramUserEmail?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  umbrellaID?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  client?: InputMaybe<Client_Order_By>;
  clientID?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  deliveredDate?: InputMaybe<Order_By>;
  delivery_provider?: InputMaybe<Delivery_Provider_Order_By>;
  delivery_provider_id?: InputMaybe<Order_By>;
  department?: InputMaybe<Department_Order_By>;
  departmentId?: InputMaybe<Order_By>;
  district?: InputMaybe<District_Order_By>;
  driver?: InputMaybe<User_Order_By>;
  driverID?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  important?: InputMaybe<Order_By>;
  isRescheduled?: InputMaybe<Order_By>;
  isReturned?: InputMaybe<Order_By>;
  isSaved?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  order_changes_aggregate?: InputMaybe<Order_Change_Aggregate_Order_By>;
  order_comments_aggregate?: InputMaybe<Order_Comments_Aggregate_Order_By>;
  order_photos_aggregate?: InputMaybe<Order_Photo_Aggregate_Order_By>;
  paymentExpirationDate?: InputMaybe<Order_By>;
  paymentType?: InputMaybe<Order_By>;
  paymentUrl?: InputMaybe<Order_By>;
  plannedDate?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  positions_aggregate?: InputMaybe<Order_Position_Aggregate_Order_By>;
  reasonRefusal?: InputMaybe<Order_By>;
  resale?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  shortCode?: InputMaybe<Order_By>;
  status?: InputMaybe<Status_Order_By>;
  statusName?: InputMaybe<Order_By>;
  telegramUserEmail?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  umbrellaID?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user_views_logs_aggregate?: InputMaybe<User_Views_Log_Aggregate_Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
  warehouse?: InputMaybe<Warehouse_Order_By>;
};

/** columns and relationships of "order_photo" */
export type Order_Photo = {
  __typename?: 'order_photo';
  downloadURL: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isSignature: Scalars['Boolean']['output'];
  /** An object relationship */
  order: Order;
  orderID: Scalars['Int']['output'];
};

/** order by aggregate values of table "order_photo" */
export type Order_Photo_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Photo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Photo_Max_Order_By>;
  min?: InputMaybe<Order_Photo_Min_Order_By>;
  stddev?: InputMaybe<Order_Photo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Photo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Photo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Photo_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Photo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Photo_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Photo_Variance_Order_By>;
};

/** order by avg() on columns of table "order_photo" */
export type Order_Photo_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_photo". All fields are combined with a logical 'AND'. */
export type Order_Photo_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Photo_Bool_Exp>>;
  _not?: InputMaybe<Order_Photo_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Photo_Bool_Exp>>;
  downloadURL?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isSignature?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderID?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_photo" */
export enum Order_Photo_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPhotoPkey = 'order_photo_pkey'
}

/** input type for incrementing numeric columns in table "order_photo" */
export type Order_Photo_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "order_photo" */
export type Order_Photo_Insert_Input = {
  downloadURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSignature?: InputMaybe<Scalars['Boolean']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "order_photo" */
export type Order_Photo_Max_Order_By = {
  downloadURL?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_photo" */
export type Order_Photo_Min_Order_By = {
  downloadURL?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_photo" */
export type Order_Photo_Mutation_Response = {
  __typename?: 'order_photo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Photo>;
};

/** on_conflict condition type for table "order_photo" */
export type Order_Photo_On_Conflict = {
  constraint: Order_Photo_Constraint;
  update_columns?: Array<Order_Photo_Update_Column>;
  where?: InputMaybe<Order_Photo_Bool_Exp>;
};

/** Ordering options when selecting data from "order_photo". */
export type Order_Photo_Order_By = {
  downloadURL?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isSignature?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_photo */
export type Order_Photo_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "order_photo" */
export enum Order_Photo_Select_Column {
  /** column name */
  DownloadUrl = 'downloadURL',
  /** column name */
  Id = 'id',
  /** column name */
  IsSignature = 'isSignature',
  /** column name */
  OrderId = 'orderID'
}

/** input type for updating data in table "order_photo" */
export type Order_Photo_Set_Input = {
  downloadURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSignature?: InputMaybe<Scalars['Boolean']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "order_photo" */
export type Order_Photo_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_photo" */
export type Order_Photo_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_photo" */
export type Order_Photo_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_photo" */
export type Order_Photo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Photo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Photo_Stream_Cursor_Value_Input = {
  downloadURL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSignature?: InputMaybe<Scalars['Boolean']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "order_photo" */
export type Order_Photo_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** update columns of table "order_photo" */
export enum Order_Photo_Update_Column {
  /** column name */
  DownloadUrl = 'downloadURL',
  /** column name */
  Id = 'id',
  /** column name */
  IsSignature = 'isSignature',
  /** column name */
  OrderId = 'orderID'
}

export type Order_Photo_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Photo_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Photo_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Photo_Bool_Exp;
};

/** order by var_pop() on columns of table "order_photo" */
export type Order_Photo_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_photo" */
export type Order_Photo_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_photo" */
export type Order_Photo_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** columns and relationships of "order_position" */
export type Order_Position = {
  __typename?: 'order_position';
  id: Scalars['Int']['output'];
  /** An object relationship */
  order: Order;
  orderID: Scalars['Int']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  product: Product;
  productID: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalPrice?: Maybe<Scalars['Int']['output']>;
};

/** order by aggregate values of table "order_position" */
export type Order_Position_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Position_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Position_Max_Order_By>;
  min?: InputMaybe<Order_Position_Min_Order_By>;
  stddev?: InputMaybe<Order_Position_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Position_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Position_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Position_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Position_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Position_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Position_Variance_Order_By>;
};

/** order by avg() on columns of table "order_position" */
export type Order_Position_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_position". All fields are combined with a logical 'AND'. */
export type Order_Position_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Position_Bool_Exp>>;
  _not?: InputMaybe<Order_Position_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Position_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderID?: InputMaybe<Int_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productID?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  totalPrice?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_position" */
export enum Order_Position_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPositionPkey = 'order_position_pkey'
}

/** input type for incrementing numeric columns in table "order_position" */
export type Order_Position_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "order_position" */
export type Order_Position_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productID?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "order_position" */
export type Order_Position_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  productID?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "order_position" */
export type Order_Position_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  productID?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_position" */
export type Order_Position_Mutation_Response = {
  __typename?: 'order_position_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Position>;
};

/** on_conflict condition type for table "order_position" */
export type Order_Position_On_Conflict = {
  constraint: Order_Position_Constraint;
  update_columns?: Array<Order_Position_Update_Column>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};

/** Ordering options when selecting data from "order_position". */
export type Order_Position_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productID?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_position */
export type Order_Position_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "order_position" */
export enum Order_Position_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderID',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productID',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalPrice = 'totalPrice'
}

/** input type for updating data in table "order_position" */
export type Order_Position_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productID?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "order_position" */
export type Order_Position_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "order_position" */
export type Order_Position_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "order_position" */
export type Order_Position_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_position" */
export type Order_Position_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Position_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Position_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  orderID?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  productID?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  totalPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "order_position" */
export type Order_Position_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** update columns of table "order_position" */
export enum Order_Position_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderID',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'productID',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalPrice = 'totalPrice'
}

export type Order_Position_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Position_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Position_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Position_Bool_Exp;
};

/** order by var_pop() on columns of table "order_position" */
export type Order_Position_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "order_position" */
export type Order_Position_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "order_position" */
export type Order_Position_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderID?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  totalPrice?: InputMaybe<Order_By>;
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  ClientId = 'clientID',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeliveredDate = 'deliveredDate',
  /** column name */
  DeliveryProviderId = 'delivery_provider_id',
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  DriverId = 'driverID',
  /** column name */
  DriverRefuseReasonId = 'driverRefuseReasonId',
  /** column name */
  Id = 'id',
  /** column name */
  Important = 'important',
  /** column name */
  IsRescheduled = 'isRescheduled',
  /** column name */
  IsReturned = 'isReturned',
  /** column name */
  IsSaved = 'isSaved',
  /** column name */
  OperatorRefuseReasonId = 'operatorRefuseReasonId',
  /** column name */
  PaymentExpirationDate = 'paymentExpirationDate',
  /** column name */
  PaymentType = 'paymentType',
  /** column name */
  PaymentUrl = 'paymentUrl',
  /** column name */
  PlannedDate = 'plannedDate',
  /** column name */
  PlannedDateDuration = 'plannedDateDuration',
  /** column name */
  ReasonRefusal = 'reasonRefusal',
  /** column name */
  Resale = 'resale',
  /** column name */
  RescheduleCount = 'rescheduleCount',
  /** column name */
  ShipmentId = 'shipmentId',
  /** column name */
  ShortCode = 'shortCode',
  /** column name */
  StatusName = 'statusName',
  /** column name */
  TelegramUserEmail = 'telegramUserEmail',
  /** column name */
  TotalCents = 'totalCents',
  /** column name */
  UmbrellaId = 'umbrellaID',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VendorDatalinkId = 'vendorDatalinkId'
}

/** select "order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Important = 'important',
  /** column name */
  IsRescheduled = 'isRescheduled',
  /** column name */
  IsReturned = 'isReturned',
  /** column name */
  IsSaved = 'isSaved',
  /** column name */
  Resale = 'resale'
}

/** select "order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Important = 'important',
  /** column name */
  IsRescheduled = 'isRescheduled',
  /** column name */
  IsReturned = 'isReturned',
  /** column name */
  IsSaved = 'isSaved',
  /** column name */
  Resale = 'resale'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  deliveredDate?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  driverID?: InputMaybe<Scalars['String']['input']>;
  driverRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  operatorRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<Payment_Type_Enum>;
  plannedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  plannedDateDuration?: InputMaybe<Scalars['Int']['input']>;
  reasonRefusal?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<Scalars['String']['input']>;
  telegramUserEmail?: InputMaybe<Scalars['String']['input']>;
  totalCents?: InputMaybe<Scalars['Int']['input']>;
  umbrellaID?: InputMaybe<Scalars['String']['input']>;
  vendorDatalinkId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "order" */
export type Order_Stddev_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "order" */
export type Order_Stddev_Pop_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "order" */
export type Order_Stddev_Samp_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  clientID?: InputMaybe<Scalars['Int']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deliveredDate?: InputMaybe<Scalars['timestamptz']['input']>;
  delivery_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  driverID?: InputMaybe<Scalars['String']['input']>;
  driverRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  important?: InputMaybe<Scalars['Boolean']['input']>;
  isRescheduled?: InputMaybe<Scalars['Boolean']['input']>;
  isReturned?: InputMaybe<Scalars['Boolean']['input']>;
  isSaved?: InputMaybe<Scalars['Boolean']['input']>;
  operatorRefuseReasonId?: InputMaybe<Scalars['Int']['input']>;
  paymentExpirationDate?: InputMaybe<Scalars['timestamptz']['input']>;
  paymentType?: InputMaybe<Payment_Type_Enum>;
  paymentUrl?: InputMaybe<Scalars['String']['input']>;
  plannedDate?: InputMaybe<Scalars['timestamptz']['input']>;
  plannedDateDuration?: InputMaybe<Scalars['Int']['input']>;
  reasonRefusal?: InputMaybe<Scalars['String']['input']>;
  resale?: InputMaybe<Scalars['Boolean']['input']>;
  rescheduleCount?: InputMaybe<Scalars['Int']['input']>;
  shipmentId?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  statusName?: InputMaybe<Scalars['String']['input']>;
  telegramUserEmail?: InputMaybe<Scalars['String']['input']>;
  totalCents?: InputMaybe<Scalars['Int']['input']>;
  umbrellaID?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  vendorDatalinkId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  clientID?: Maybe<Scalars['Int']['output']>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Int']['output']>;
  plannedDateDuration?: Maybe<Scalars['Int']['output']>;
  rescheduleCount?: Maybe<Scalars['Int']['output']>;
  shipmentId?: Maybe<Scalars['Int']['output']>;
  totalCents?: Maybe<Scalars['Int']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "order" */
export type Order_Sum_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

export type Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "order" */
export type Order_Var_Pop_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "order" */
export type Order_Var_Samp_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  clientID?: Maybe<Scalars['Float']['output']>;
  departmentId?: Maybe<Scalars['Float']['output']>;
  driverRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  operatorRefuseReasonId?: Maybe<Scalars['Float']['output']>;
  plannedDateDuration?: Maybe<Scalars['Float']['output']>;
  rescheduleCount?: Maybe<Scalars['Float']['output']>;
  shipmentId?: Maybe<Scalars['Float']['output']>;
  totalCents?: Maybe<Scalars['Float']['output']>;
  vendorDatalinkId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "order" */
export type Order_Variance_Order_By = {
  clientID?: InputMaybe<Order_By>;
  departmentId?: InputMaybe<Order_By>;
  driverRefuseReasonId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operatorRefuseReasonId?: InputMaybe<Order_By>;
  plannedDateDuration?: InputMaybe<Order_By>;
  rescheduleCount?: InputMaybe<Order_By>;
  shipmentId?: InputMaybe<Order_By>;
  totalCents?: InputMaybe<Order_By>;
  vendorDatalinkId?: InputMaybe<Order_By>;
};

/** columns and relationships of "payment_type" */
export type Payment_Type = {
  __typename?: 'payment_type';
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "payment_type". All fields are combined with a logical 'AND'. */
export type Payment_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Type_Bool_Exp>>;
  _not?: InputMaybe<Payment_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Type_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Payment_Type_Enum {
  AplicacionesDePago = 'aplicaciones_de_pago',
  Bancario = 'bancario',
  Efectivo = 'efectivo',
  Tarjeta = 'tarjeta'
}

/** Boolean expression to compare columns of type "payment_type_enum". All fields are combined with logical 'AND'. */
export type Payment_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Payment_Type_Enum>;
  _in?: InputMaybe<Array<Payment_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Payment_Type_Enum>;
  _nin?: InputMaybe<Array<Payment_Type_Enum>>;
};

/** Ordering options when selecting data from "payment_type". */
export type Payment_Type_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "payment_type" */
export enum Payment_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "payment_type" */
export type Payment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  /** An object relationship */
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  order_positions: Array<Order_Position>;
};


/** columns and relationships of "product" */
export type ProductOrder_PositionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Position_Order_By>>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Max_Order_By>;
  min?: InputMaybe<Product_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_positions?: InputMaybe<Order_Position_Bool_Exp>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_positions_aggregate?: InputMaybe<Order_Position_Aggregate_Order_By>;
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "province" */
export type Province = {
  __typename?: 'province';
  /** An object relationship */
  country: Country;
  countryId: Scalars['String']['output'];
  /** An array relationship */
  districts: Array<District>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  regionId: Scalars['String']['output'];
};


/** columns and relationships of "province" */
export type ProvinceDistrictsArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};

/** order by aggregate values of table "province" */
export type Province_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Province_Max_Order_By>;
  min?: InputMaybe<Province_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "province". All fields are combined with a logical 'AND'. */
export type Province_Bool_Exp = {
  _and?: InputMaybe<Array<Province_Bool_Exp>>;
  _not?: InputMaybe<Province_Bool_Exp>;
  _or?: InputMaybe<Array<Province_Bool_Exp>>;
  country?: InputMaybe<Country_Bool_Exp>;
  countryId?: InputMaybe<String_Comparison_Exp>;
  districts?: InputMaybe<District_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  regionId?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "province" */
export type Province_Max_Order_By = {
  countryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  regionId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "province" */
export type Province_Min_Order_By = {
  countryId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  regionId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "province". */
export type Province_Order_By = {
  country?: InputMaybe<Country_Order_By>;
  countryId?: InputMaybe<Order_By>;
  districts_aggregate?: InputMaybe<District_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  regionId?: InputMaybe<Order_By>;
};

/** select columns of table "province" */
export enum Province_Select_Column {
  /** column name */
  CountryId = 'countryId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RegionId = 'regionId'
}

/** Streaming cursor of the table "province" */
export type Province_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Province_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Province_Stream_Cursor_Value_Input = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['String']['input']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** An array relationship */
  client: Array<Client>;
  /** fetch data from the table: "client" using primary key columns */
  client_by_pk?: Maybe<Client>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_holiday" */
  country_holiday: Array<Country_Holiday>;
  /** fetch data from the table: "country_holiday" using primary key columns */
  country_holiday_by_pk?: Maybe<Country_Holiday>;
  /** fetch data from the table: "delivery_provider" */
  delivery_provider: Array<Delivery_Provider>;
  /** fetch aggregated fields from the table: "delivery_provider" */
  delivery_provider_aggregate: Delivery_Provider_Aggregate;
  /** fetch data from the table: "delivery_provider" using primary key columns */
  delivery_provider_by_pk?: Maybe<Delivery_Provider>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** An array relationship */
  departments_districts: Array<Departments_Districts>;
  /** fetch data from the table: "departments_districts" using primary key columns */
  departments_districts_by_pk?: Maybe<Departments_Districts>;
  /** An array relationship */
  departments_users: Array<Departments_Users>;
  /** fetch data from the table: "departments_users" using primary key columns */
  departments_users_by_pk?: Maybe<Departments_Users>;
  /** fetch data from the table: "district" */
  district: Array<District>;
  /** fetch data from the table: "district" using primary key columns */
  district_by_pk?: Maybe<District>;
  /** An array relationship */
  district_delivery_providers: Array<District_Delivery_Providers>;
  /** An aggregate relationship */
  district_delivery_providers_aggregate: District_Delivery_Providers_Aggregate;
  /** fetch data from the table: "district_delivery_providers" using primary key columns */
  district_delivery_providers_by_pk?: Maybe<District_Delivery_Providers>;
  /** fetch data from the table: "district_workload" */
  district_workload: Array<District_Workload>;
  /** An array relationship */
  districts_coordinates: Array<Districts_Coordinates>;
  /** fetch data from the table: "districts_coordinates" using primary key columns */
  districts_coordinates_by_pk?: Maybe<Districts_Coordinates>;
  /** fetch data from the table: "driver_district" */
  driver_district: Array<Driver_District>;
  /** fetch data from the table: "driver_district" using primary key columns */
  driver_district_by_pk?: Maybe<Driver_District>;
  /** fetch data from the table: "driver_holiday" */
  driver_holiday: Array<Driver_Holiday>;
  /** fetch data from the table: "driver_holiday" using primary key columns */
  driver_holiday_by_pk?: Maybe<Driver_Holiday>;
  /** fetch data from the table: "driver_order_interaction" */
  driver_order_interaction: Array<Driver_Order_Interaction>;
  /** fetch data from the table: "driver_order_interaction" using primary key columns */
  driver_order_interaction_by_pk?: Maybe<Driver_Order_Interaction>;
  /** fetch data from the table: "driver_window" */
  driver_window: Array<Driver_Window>;
  /** fetch data from the table: "driver_window" using primary key columns */
  driver_window_by_pk?: Maybe<Driver_Window>;
  /** fetch data from the table: "driver_workload" */
  driver_workload: Array<Driver_Workload>;
  /** fetch aggregated fields from the table: "driver_workload" */
  driver_workload_aggregate: Driver_Workload_Aggregate;
  /** fetch data from the table: "driver_workload" using primary key columns */
  driver_workload_by_pk?: Maybe<Driver_Workload>;
  /** execute function "driver_workload_for" which returns "driver_workload" */
  driver_workload_for: Array<Driver_Workload>;
  /** execute function "driver_workload_for" and query aggregates on result of table type "driver_workload" */
  driver_workload_for_aggregate: Driver_Workload_Aggregate;
  /** fetch data from the table: "firebase_message_token" */
  firebase_message_token: Array<Firebase_Message_Token>;
  /** fetch data from the table: "firebase_message_token" using primary key columns */
  firebase_message_token_by_pk?: Maybe<Firebase_Message_Token>;
  /** fetch data from the table: "geo_event" */
  geo_event: Array<Geo_Event>;
  /** fetch data from the table: "geo_event" using primary key columns */
  geo_event_by_pk?: Maybe<Geo_Event>;
  getClientPhone?: Maybe<ClientPhoneResponse>;
  /** fetch data from the table: "login_log" */
  login_log: Array<Login_Log>;
  /** fetch data from the table: "login_log" using primary key columns */
  login_log_by_pk?: Maybe<Login_Log>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_change" */
  order_change: Array<Order_Change>;
  /** fetch aggregated fields from the table: "order_change" */
  order_change_aggregate: Order_Change_Aggregate;
  /** fetch data from the table: "order_change" using primary key columns */
  order_change_by_pk?: Maybe<Order_Change>;
  /** An array relationship */
  order_comments: Array<Order_Comments>;
  /** fetch data from the table: "order_comments" using primary key columns */
  order_comments_by_pk?: Maybe<Order_Comments>;
  /** fetch data from the table: "order_photo" */
  order_photo: Array<Order_Photo>;
  /** fetch data from the table: "order_photo" using primary key columns */
  order_photo_by_pk?: Maybe<Order_Photo>;
  /** fetch data from the table: "order_position" */
  order_position: Array<Order_Position>;
  /** fetch data from the table: "order_position" using primary key columns */
  order_position_by_pk?: Maybe<Order_Position>;
  /** fetch data from the table: "payment_type" */
  payment_type: Array<Payment_Type>;
  /** fetch data from the table: "payment_type" using primary key columns */
  payment_type_by_pk?: Maybe<Payment_Type>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "province" */
  province: Array<Province>;
  /** fetch data from the table: "province" using primary key columns */
  province_by_pk?: Maybe<Province>;
  recalcOrder?: Maybe<OrderItemOutput>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch data from the table: "status" using primary key columns */
  status_by_pk?: Maybe<Status>;
  /** fetch data from the table: "status_transition" */
  status_transition: Array<Status_Transition>;
  /** fetch data from the table: "status_transition" using primary key columns */
  status_transition_by_pk?: Maybe<Status_Transition>;
  /** fetch data from the table: "track_point" */
  track_point: Array<Track_Point>;
  /** fetch data from the table: "track_point" using primary key columns */
  track_point_by_pk?: Maybe<Track_Point>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_views_log" */
  user_views_log: Array<User_Views_Log>;
  /** fetch data from the table: "user_views_log" using primary key columns */
  user_views_log_by_pk?: Maybe<User_Views_Log>;
  /** fetch data from the table: "warehouse" */
  warehouse: Array<Warehouse>;
  /** fetch data from the table: "warehouse" using primary key columns */
  warehouse_by_pk?: Maybe<Warehouse>;
  /** fetch data from the table: "weekday_window" */
  weekday_window: Array<Weekday_Window>;
  /** fetch data from the table: "weekday_window" using primary key columns */
  weekday_window_by_pk?: Maybe<Weekday_Window>;
  /** fetch data from the table: "weekday_window_district" */
  weekday_window_district: Array<Weekday_Window_District>;
  /** fetch data from the table: "weekday_window_district" using primary key columns */
  weekday_window_district_by_pk?: Maybe<Weekday_Window_District>;
  /** An array relationship */
  window_delivery_providers: Array<Window_Delivery_Providers>;
  /** An aggregate relationship */
  window_delivery_providers_aggregate: Window_Delivery_Providers_Aggregate;
  /** fetch data from the table: "window_delivery_providers" using primary key columns */
  window_delivery_providers_by_pk?: Maybe<Window_Delivery_Providers>;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootClientArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Query_RootClient_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootCountry_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Country_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Holiday_Order_By>>;
  where?: InputMaybe<Country_Holiday_Bool_Exp>;
};


export type Query_RootCountry_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDelivery_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Provider_Order_By>>;
  where?: InputMaybe<Delivery_Provider_Bool_Exp>;
};


export type Query_RootDelivery_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Provider_Order_By>>;
  where?: InputMaybe<Delivery_Provider_Bool_Exp>;
};


export type Query_RootDelivery_Provider_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Query_RootDepartment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDepartments_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Departments_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Districts_Order_By>>;
  where?: InputMaybe<Departments_Districts_Bool_Exp>;
};


export type Query_RootDepartments_Districts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDepartments_UsersArgs = {
  distinct_on?: InputMaybe<Array<Departments_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Users_Order_By>>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};


export type Query_RootDepartments_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDistrictArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Query_RootDistrict_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootDistrict_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


export type Query_RootDistrict_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


export type Query_RootDistrict_Delivery_Providers_By_PkArgs = {
  delivery_provider_id: Scalars['uuid']['input'];
  district_id: Scalars['String']['input'];
};


export type Query_RootDistrict_WorkloadArgs = {
  distinct_on?: InputMaybe<Array<District_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Workload_Order_By>>;
  where?: InputMaybe<District_Workload_Bool_Exp>;
};


export type Query_RootDistricts_CoordinatesArgs = {
  distinct_on?: InputMaybe<Array<Districts_Coordinates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Districts_Coordinates_Order_By>>;
  where?: InputMaybe<Districts_Coordinates_Bool_Exp>;
};


export type Query_RootDistricts_Coordinates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_DistrictArgs = {
  distinct_on?: InputMaybe<Array<Driver_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_District_Order_By>>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};


export type Query_RootDriver_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Driver_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Holiday_Order_By>>;
  where?: InputMaybe<Driver_Holiday_Bool_Exp>;
};


export type Query_RootDriver_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_Order_InteractionArgs = {
  distinct_on?: InputMaybe<Array<Driver_Order_Interaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Order_Interaction_Order_By>>;
  where?: InputMaybe<Driver_Order_Interaction_Bool_Exp>;
};


export type Query_RootDriver_Order_Interaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_WindowArgs = {
  distinct_on?: InputMaybe<Array<Driver_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Window_Order_By>>;
  where?: InputMaybe<Driver_Window_Bool_Exp>;
};


export type Query_RootDriver_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_WorkloadArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Query_RootDriver_Workload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Query_RootDriver_Workload_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDriver_Workload_ForArgs = {
  args: Driver_Workload_For_Args;
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Query_RootDriver_Workload_For_AggregateArgs = {
  args: Driver_Workload_For_Args;
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Query_RootFirebase_Message_TokenArgs = {
  distinct_on?: InputMaybe<Array<Firebase_Message_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firebase_Message_Token_Order_By>>;
  where?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
};


export type Query_RootFirebase_Message_Token_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGeo_EventArgs = {
  distinct_on?: InputMaybe<Array<Geo_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geo_Event_Order_By>>;
  where?: InputMaybe<Geo_Event_Bool_Exp>;
};


export type Query_RootGeo_Event_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootGetClientPhoneArgs = {
  clientId: Scalars['Int']['input'];
};


export type Query_RootLogin_LogArgs = {
  distinct_on?: InputMaybe<Array<Login_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Log_Order_By>>;
  where?: InputMaybe<Login_Log_Bool_Exp>;
};


export type Query_RootLogin_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrder_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


export type Query_RootOrder_Change_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


export type Query_RootOrder_Change_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootOrder_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Comments_Order_By>>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};


export type Query_RootOrder_Comments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrder_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Order_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photo_Order_By>>;
  where?: InputMaybe<Order_Photo_Bool_Exp>;
};


export type Query_RootOrder_Photo_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrder_PositionArgs = {
  distinct_on?: InputMaybe<Array<Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Position_Order_By>>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};


export type Query_RootOrder_Position_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPayment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Query_RootPayment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootProvinceArgs = {
  distinct_on?: InputMaybe<Array<Province_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Province_Order_By>>;
  where?: InputMaybe<Province_Bool_Exp>;
};


export type Query_RootProvince_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootRecalcOrderArgs = {
  orderID: Scalars['Int']['input'];
  orderItems: Array<OrderItemInput>;
  umbrellaID: Scalars['String']['input'];
};


export type Query_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Query_RootStatus_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootStatus_TransitionArgs = {
  distinct_on?: InputMaybe<Array<Status_Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Transition_Order_By>>;
  where?: InputMaybe<Status_Transition_Bool_Exp>;
};


export type Query_RootStatus_Transition_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTrack_PointArgs = {
  distinct_on?: InputMaybe<Array<Track_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Track_Point_Order_By>>;
  where?: InputMaybe<Track_Point_Bool_Exp>;
};


export type Query_RootTrack_Point_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootUser_Views_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Views_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Views_Log_Order_By>>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};


export type Query_RootUser_Views_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWarehouseArgs = {
  distinct_on?: InputMaybe<Array<Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warehouse_Order_By>>;
  where?: InputMaybe<Warehouse_Bool_Exp>;
};


export type Query_RootWarehouse_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWeekday_WindowArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_Order_By>>;
  where?: InputMaybe<Weekday_Window_Bool_Exp>;
};


export type Query_RootWeekday_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWeekday_Window_DistrictArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_District_Order_By>>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};


export type Query_RootWeekday_Window_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootWindow_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


export type Query_RootWindow_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


export type Query_RootWindow_Delivery_Providers_By_PkArgs = {
  provider_id: Scalars['uuid']['input'];
  window_id: Scalars['Int']['input'];
};

export type RescheduledOrdersCount_User_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']['input']>;
  date_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type ReturnedOrdersCount_User_Args = {
  date_from?: InputMaybe<Scalars['timestamptz']['input']>;
  date_to?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

/** columns and relationships of "status" */
export type Status = {
  __typename?: 'status';
  name: Scalars['String']['output'];
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  /** An array relationship */
  statusTransitionsByNext: Array<Status_Transition>;
  /** An array relationship */
  status_transitions: Array<Status_Transition>;
  task?: Maybe<Scalars['String']['output']>;
  taskIcon?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "status" */
export type StatusOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "status" */
export type StatusOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "status" */
export type StatusStatusTransitionsByNextArgs = {
  distinct_on?: InputMaybe<Array<Status_Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Transition_Order_By>>;
  where?: InputMaybe<Status_Transition_Bool_Exp>;
};


/** columns and relationships of "status" */
export type StatusStatus_TransitionsArgs = {
  distinct_on?: InputMaybe<Array<Status_Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Transition_Order_By>>;
  where?: InputMaybe<Status_Transition_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "status". All fields are combined with a logical 'AND'. */
export type Status_Bool_Exp = {
  _and?: InputMaybe<Array<Status_Bool_Exp>>;
  _not?: InputMaybe<Status_Bool_Exp>;
  _or?: InputMaybe<Array<Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  statusTransitionsByNext?: InputMaybe<Status_Transition_Bool_Exp>;
  status_transitions?: InputMaybe<Status_Transition_Bool_Exp>;
  task?: InputMaybe<String_Comparison_Exp>;
  taskIcon?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "status". */
export type Status_Order_By = {
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  statusTransitionsByNext_aggregate?: InputMaybe<Status_Transition_Aggregate_Order_By>;
  status_transitions_aggregate?: InputMaybe<Status_Transition_Aggregate_Order_By>;
  task?: InputMaybe<Order_By>;
  taskIcon?: InputMaybe<Order_By>;
};

/** select columns of table "status" */
export enum Status_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Task = 'task',
  /** column name */
  TaskIcon = 'taskIcon'
}

/** Streaming cursor of the table "status" */
export type Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Scalars['String']['input']>;
  taskIcon?: InputMaybe<Scalars['String']['input']>;
};

/** [DEPRICATED] role. Use roles instead  */
export type Status_Transition = {
  __typename?: 'status_transition';
  current: Scalars['String']['output'];
  /** An object relationship */
  currentStatus: Status;
  id: Scalars['Int']['output'];
  next: Scalars['String']['output'];
  /** An object relationship */
  nextStatus: Status;
  role?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Scalars['jsonb']['output']>;
};


/** [DEPRICATED] role. Use roles instead  */
export type Status_TransitionRolesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "status_transition" */
export type Status_Transition_Aggregate_Order_By = {
  avg?: InputMaybe<Status_Transition_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Status_Transition_Max_Order_By>;
  min?: InputMaybe<Status_Transition_Min_Order_By>;
  stddev?: InputMaybe<Status_Transition_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Status_Transition_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Status_Transition_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Status_Transition_Sum_Order_By>;
  var_pop?: InputMaybe<Status_Transition_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Status_Transition_Var_Samp_Order_By>;
  variance?: InputMaybe<Status_Transition_Variance_Order_By>;
};

/** order by avg() on columns of table "status_transition" */
export type Status_Transition_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "status_transition". All fields are combined with a logical 'AND'. */
export type Status_Transition_Bool_Exp = {
  _and?: InputMaybe<Array<Status_Transition_Bool_Exp>>;
  _not?: InputMaybe<Status_Transition_Bool_Exp>;
  _or?: InputMaybe<Array<Status_Transition_Bool_Exp>>;
  current?: InputMaybe<String_Comparison_Exp>;
  currentStatus?: InputMaybe<Status_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  next?: InputMaybe<String_Comparison_Exp>;
  nextStatus?: InputMaybe<Status_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roles?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** order by max() on columns of table "status_transition" */
export type Status_Transition_Max_Order_By = {
  current?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "status_transition" */
export type Status_Transition_Min_Order_By = {
  current?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "status_transition". */
export type Status_Transition_Order_By = {
  current?: InputMaybe<Order_By>;
  currentStatus?: InputMaybe<Status_Order_By>;
  id?: InputMaybe<Order_By>;
  next?: InputMaybe<Order_By>;
  nextStatus?: InputMaybe<Status_Order_By>;
  role?: InputMaybe<Order_By>;
  roles?: InputMaybe<Order_By>;
};

/** select columns of table "status_transition" */
export enum Status_Transition_Select_Column {
  /** column name */
  Current = 'current',
  /** column name */
  Id = 'id',
  /** column name */
  Next = 'next',
  /** column name */
  Role = 'role',
  /** column name */
  Roles = 'roles'
}

/** order by stddev() on columns of table "status_transition" */
export type Status_Transition_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "status_transition" */
export type Status_Transition_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "status_transition" */
export type Status_Transition_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "status_transition" */
export type Status_Transition_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Status_Transition_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Status_Transition_Stream_Cursor_Value_Input = {
  current?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by sum() on columns of table "status_transition" */
export type Status_Transition_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "status_transition" */
export type Status_Transition_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "status_transition" */
export type Status_Transition_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "status_transition" */
export type Status_Transition_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** An array relationship */
  client: Array<Client>;
  /** fetch data from the table: "client" using primary key columns */
  client_by_pk?: Maybe<Client>;
  /** fetch data from the table in a streaming manner: "client" */
  client_stream: Array<Client>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_holiday" */
  country_holiday: Array<Country_Holiday>;
  /** fetch data from the table: "country_holiday" using primary key columns */
  country_holiday_by_pk?: Maybe<Country_Holiday>;
  /** fetch data from the table in a streaming manner: "country_holiday" */
  country_holiday_stream: Array<Country_Holiday>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "delivery_provider" */
  delivery_provider: Array<Delivery_Provider>;
  /** fetch aggregated fields from the table: "delivery_provider" */
  delivery_provider_aggregate: Delivery_Provider_Aggregate;
  /** fetch data from the table: "delivery_provider" using primary key columns */
  delivery_provider_by_pk?: Maybe<Delivery_Provider>;
  /** fetch data from the table in a streaming manner: "delivery_provider" */
  delivery_provider_stream: Array<Delivery_Provider>;
  /** fetch data from the table: "department" */
  department: Array<Department>;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<Department>;
  /** fetch data from the table in a streaming manner: "department" */
  department_stream: Array<Department>;
  /** An array relationship */
  departments_districts: Array<Departments_Districts>;
  /** fetch data from the table: "departments_districts" using primary key columns */
  departments_districts_by_pk?: Maybe<Departments_Districts>;
  /** fetch data from the table in a streaming manner: "departments_districts" */
  departments_districts_stream: Array<Departments_Districts>;
  /** An array relationship */
  departments_users: Array<Departments_Users>;
  /** fetch data from the table: "departments_users" using primary key columns */
  departments_users_by_pk?: Maybe<Departments_Users>;
  /** fetch data from the table in a streaming manner: "departments_users" */
  departments_users_stream: Array<Departments_Users>;
  /** fetch data from the table: "district" */
  district: Array<District>;
  /** fetch data from the table: "district" using primary key columns */
  district_by_pk?: Maybe<District>;
  /** An array relationship */
  district_delivery_providers: Array<District_Delivery_Providers>;
  /** An aggregate relationship */
  district_delivery_providers_aggregate: District_Delivery_Providers_Aggregate;
  /** fetch data from the table: "district_delivery_providers" using primary key columns */
  district_delivery_providers_by_pk?: Maybe<District_Delivery_Providers>;
  /** fetch data from the table in a streaming manner: "district_delivery_providers" */
  district_delivery_providers_stream: Array<District_Delivery_Providers>;
  /** fetch data from the table in a streaming manner: "district" */
  district_stream: Array<District>;
  /** fetch data from the table: "district_workload" */
  district_workload: Array<District_Workload>;
  /** fetch data from the table in a streaming manner: "district_workload" */
  district_workload_stream: Array<District_Workload>;
  /** An array relationship */
  districts_coordinates: Array<Districts_Coordinates>;
  /** fetch data from the table: "districts_coordinates" using primary key columns */
  districts_coordinates_by_pk?: Maybe<Districts_Coordinates>;
  /** fetch data from the table in a streaming manner: "districts_coordinates" */
  districts_coordinates_stream: Array<Districts_Coordinates>;
  /** fetch data from the table: "driver_district" */
  driver_district: Array<Driver_District>;
  /** fetch data from the table: "driver_district" using primary key columns */
  driver_district_by_pk?: Maybe<Driver_District>;
  /** fetch data from the table in a streaming manner: "driver_district" */
  driver_district_stream: Array<Driver_District>;
  /** fetch data from the table: "driver_holiday" */
  driver_holiday: Array<Driver_Holiday>;
  /** fetch data from the table: "driver_holiday" using primary key columns */
  driver_holiday_by_pk?: Maybe<Driver_Holiday>;
  /** fetch data from the table in a streaming manner: "driver_holiday" */
  driver_holiday_stream: Array<Driver_Holiday>;
  /** fetch data from the table: "driver_order_interaction" */
  driver_order_interaction: Array<Driver_Order_Interaction>;
  /** fetch data from the table: "driver_order_interaction" using primary key columns */
  driver_order_interaction_by_pk?: Maybe<Driver_Order_Interaction>;
  /** fetch data from the table in a streaming manner: "driver_order_interaction" */
  driver_order_interaction_stream: Array<Driver_Order_Interaction>;
  /** fetch data from the table: "driver_window" */
  driver_window: Array<Driver_Window>;
  /** fetch data from the table: "driver_window" using primary key columns */
  driver_window_by_pk?: Maybe<Driver_Window>;
  /** fetch data from the table in a streaming manner: "driver_window" */
  driver_window_stream: Array<Driver_Window>;
  /** fetch data from the table: "driver_workload" */
  driver_workload: Array<Driver_Workload>;
  /** fetch aggregated fields from the table: "driver_workload" */
  driver_workload_aggregate: Driver_Workload_Aggregate;
  /** fetch data from the table: "driver_workload" using primary key columns */
  driver_workload_by_pk?: Maybe<Driver_Workload>;
  /** execute function "driver_workload_for" which returns "driver_workload" */
  driver_workload_for: Array<Driver_Workload>;
  /** execute function "driver_workload_for" and query aggregates on result of table type "driver_workload" */
  driver_workload_for_aggregate: Driver_Workload_Aggregate;
  /** fetch data from the table in a streaming manner: "driver_workload" */
  driver_workload_stream: Array<Driver_Workload>;
  /** fetch data from the table: "firebase_message_token" */
  firebase_message_token: Array<Firebase_Message_Token>;
  /** fetch data from the table: "firebase_message_token" using primary key columns */
  firebase_message_token_by_pk?: Maybe<Firebase_Message_Token>;
  /** fetch data from the table in a streaming manner: "firebase_message_token" */
  firebase_message_token_stream: Array<Firebase_Message_Token>;
  /** fetch data from the table: "geo_event" */
  geo_event: Array<Geo_Event>;
  /** fetch data from the table: "geo_event" using primary key columns */
  geo_event_by_pk?: Maybe<Geo_Event>;
  /** fetch data from the table in a streaming manner: "geo_event" */
  geo_event_stream: Array<Geo_Event>;
  /** fetch data from the table: "login_log" */
  login_log: Array<Login_Log>;
  /** fetch data from the table: "login_log" using primary key columns */
  login_log_by_pk?: Maybe<Login_Log>;
  /** fetch data from the table in a streaming manner: "login_log" */
  login_log_stream: Array<Login_Log>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_change" */
  order_change: Array<Order_Change>;
  /** fetch aggregated fields from the table: "order_change" */
  order_change_aggregate: Order_Change_Aggregate;
  /** fetch data from the table: "order_change" using primary key columns */
  order_change_by_pk?: Maybe<Order_Change>;
  /** fetch data from the table in a streaming manner: "order_change" */
  order_change_stream: Array<Order_Change>;
  /** An array relationship */
  order_comments: Array<Order_Comments>;
  /** fetch data from the table: "order_comments" using primary key columns */
  order_comments_by_pk?: Maybe<Order_Comments>;
  /** fetch data from the table in a streaming manner: "order_comments" */
  order_comments_stream: Array<Order_Comments>;
  /** fetch data from the table: "order_photo" */
  order_photo: Array<Order_Photo>;
  /** fetch data from the table: "order_photo" using primary key columns */
  order_photo_by_pk?: Maybe<Order_Photo>;
  /** fetch data from the table in a streaming manner: "order_photo" */
  order_photo_stream: Array<Order_Photo>;
  /** fetch data from the table: "order_position" */
  order_position: Array<Order_Position>;
  /** fetch data from the table: "order_position" using primary key columns */
  order_position_by_pk?: Maybe<Order_Position>;
  /** fetch data from the table in a streaming manner: "order_position" */
  order_position_stream: Array<Order_Position>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "payment_type" */
  payment_type: Array<Payment_Type>;
  /** fetch data from the table: "payment_type" using primary key columns */
  payment_type_by_pk?: Maybe<Payment_Type>;
  /** fetch data from the table in a streaming manner: "payment_type" */
  payment_type_stream: Array<Payment_Type>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "province" */
  province: Array<Province>;
  /** fetch data from the table: "province" using primary key columns */
  province_by_pk?: Maybe<Province>;
  /** fetch data from the table in a streaming manner: "province" */
  province_stream: Array<Province>;
  /** fetch data from the table: "status" */
  status: Array<Status>;
  /** fetch data from the table: "status" using primary key columns */
  status_by_pk?: Maybe<Status>;
  /** fetch data from the table in a streaming manner: "status" */
  status_stream: Array<Status>;
  /** fetch data from the table: "status_transition" */
  status_transition: Array<Status_Transition>;
  /** fetch data from the table: "status_transition" using primary key columns */
  status_transition_by_pk?: Maybe<Status_Transition>;
  /** fetch data from the table in a streaming manner: "status_transition" */
  status_transition_stream: Array<Status_Transition>;
  /** fetch data from the table: "track_point" */
  track_point: Array<Track_Point>;
  /** fetch data from the table: "track_point" using primary key columns */
  track_point_by_pk?: Maybe<Track_Point>;
  /** fetch data from the table in a streaming manner: "track_point" */
  track_point_stream: Array<Track_Point>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_views_log" */
  user_views_log: Array<User_Views_Log>;
  /** fetch data from the table: "user_views_log" using primary key columns */
  user_views_log_by_pk?: Maybe<User_Views_Log>;
  /** fetch data from the table in a streaming manner: "user_views_log" */
  user_views_log_stream: Array<User_Views_Log>;
  /** fetch data from the table: "warehouse" */
  warehouse: Array<Warehouse>;
  /** fetch data from the table: "warehouse" using primary key columns */
  warehouse_by_pk?: Maybe<Warehouse>;
  /** fetch data from the table in a streaming manner: "warehouse" */
  warehouse_stream: Array<Warehouse>;
  /** fetch data from the table: "weekday_window" */
  weekday_window: Array<Weekday_Window>;
  /** fetch data from the table: "weekday_window" using primary key columns */
  weekday_window_by_pk?: Maybe<Weekday_Window>;
  /** fetch data from the table: "weekday_window_district" */
  weekday_window_district: Array<Weekday_Window_District>;
  /** fetch data from the table: "weekday_window_district" using primary key columns */
  weekday_window_district_by_pk?: Maybe<Weekday_Window_District>;
  /** fetch data from the table in a streaming manner: "weekday_window_district" */
  weekday_window_district_stream: Array<Weekday_Window_District>;
  /** fetch data from the table in a streaming manner: "weekday_window" */
  weekday_window_stream: Array<Weekday_Window>;
  /** An array relationship */
  window_delivery_providers: Array<Window_Delivery_Providers>;
  /** An aggregate relationship */
  window_delivery_providers_aggregate: Window_Delivery_Providers_Aggregate;
  /** fetch data from the table: "window_delivery_providers" using primary key columns */
  window_delivery_providers_by_pk?: Maybe<Window_Delivery_Providers>;
  /** fetch data from the table in a streaming manner: "window_delivery_providers" */
  window_delivery_providers_stream: Array<Window_Delivery_Providers>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootClientArgs = {
  distinct_on?: InputMaybe<Array<Client_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Client_Order_By>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Subscription_RootClient_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootClient_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Client_Stream_Cursor_Input>>;
  where?: InputMaybe<Client_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootCountry_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Country_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Country_Holiday_Order_By>>;
  where?: InputMaybe<Country_Holiday_Bool_Exp>;
};


export type Subscription_RootCountry_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCountry_Holiday_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Holiday_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Holiday_Bool_Exp>;
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootDelivery_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Provider_Order_By>>;
  where?: InputMaybe<Delivery_Provider_Bool_Exp>;
};


export type Subscription_RootDelivery_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Delivery_Provider_Order_By>>;
  where?: InputMaybe<Delivery_Provider_Bool_Exp>;
};


export type Subscription_RootDelivery_Provider_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDelivery_Provider_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Delivery_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Provider_Bool_Exp>;
};


export type Subscription_RootDepartmentArgs = {
  distinct_on?: InputMaybe<Array<Department_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Department_Order_By>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDepartment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Department_Stream_Cursor_Input>>;
  where?: InputMaybe<Department_Bool_Exp>;
};


export type Subscription_RootDepartments_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Departments_Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Districts_Order_By>>;
  where?: InputMaybe<Departments_Districts_Bool_Exp>;
};


export type Subscription_RootDepartments_Districts_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDepartments_Districts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Departments_Districts_Stream_Cursor_Input>>;
  where?: InputMaybe<Departments_Districts_Bool_Exp>;
};


export type Subscription_RootDepartments_UsersArgs = {
  distinct_on?: InputMaybe<Array<Departments_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Users_Order_By>>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};


export type Subscription_RootDepartments_Users_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDepartments_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Departments_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};


export type Subscription_RootDistrictArgs = {
  distinct_on?: InputMaybe<Array<District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Order_By>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Subscription_RootDistrict_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootDistrict_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


export type Subscription_RootDistrict_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<District_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Delivery_Providers_Order_By>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


export type Subscription_RootDistrict_Delivery_Providers_By_PkArgs = {
  delivery_provider_id: Scalars['uuid']['input'];
  district_id: Scalars['String']['input'];
};


export type Subscription_RootDistrict_Delivery_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<District_Delivery_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<District_Delivery_Providers_Bool_Exp>;
};


export type Subscription_RootDistrict_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<District_Stream_Cursor_Input>>;
  where?: InputMaybe<District_Bool_Exp>;
};


export type Subscription_RootDistrict_WorkloadArgs = {
  distinct_on?: InputMaybe<Array<District_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<District_Workload_Order_By>>;
  where?: InputMaybe<District_Workload_Bool_Exp>;
};


export type Subscription_RootDistrict_Workload_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<District_Workload_Stream_Cursor_Input>>;
  where?: InputMaybe<District_Workload_Bool_Exp>;
};


export type Subscription_RootDistricts_CoordinatesArgs = {
  distinct_on?: InputMaybe<Array<Districts_Coordinates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Districts_Coordinates_Order_By>>;
  where?: InputMaybe<Districts_Coordinates_Bool_Exp>;
};


export type Subscription_RootDistricts_Coordinates_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDistricts_Coordinates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Districts_Coordinates_Stream_Cursor_Input>>;
  where?: InputMaybe<Districts_Coordinates_Bool_Exp>;
};


export type Subscription_RootDriver_DistrictArgs = {
  distinct_on?: InputMaybe<Array<Driver_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_District_Order_By>>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};


export type Subscription_RootDriver_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDriver_District_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_District_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};


export type Subscription_RootDriver_HolidayArgs = {
  distinct_on?: InputMaybe<Array<Driver_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Holiday_Order_By>>;
  where?: InputMaybe<Driver_Holiday_Bool_Exp>;
};


export type Subscription_RootDriver_Holiday_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDriver_Holiday_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Holiday_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Holiday_Bool_Exp>;
};


export type Subscription_RootDriver_Order_InteractionArgs = {
  distinct_on?: InputMaybe<Array<Driver_Order_Interaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Order_Interaction_Order_By>>;
  where?: InputMaybe<Driver_Order_Interaction_Bool_Exp>;
};


export type Subscription_RootDriver_Order_Interaction_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDriver_Order_Interaction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Order_Interaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Order_Interaction_Bool_Exp>;
};


export type Subscription_RootDriver_WindowArgs = {
  distinct_on?: InputMaybe<Array<Driver_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Window_Order_By>>;
  where?: InputMaybe<Driver_Window_Bool_Exp>;
};


export type Subscription_RootDriver_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDriver_Window_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Window_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Window_Bool_Exp>;
};


export type Subscription_RootDriver_WorkloadArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Subscription_RootDriver_Workload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Subscription_RootDriver_Workload_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDriver_Workload_ForArgs = {
  args: Driver_Workload_For_Args;
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Subscription_RootDriver_Workload_For_AggregateArgs = {
  args: Driver_Workload_For_Args;
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Subscription_RootDriver_Workload_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Driver_Workload_Stream_Cursor_Input>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


export type Subscription_RootFirebase_Message_TokenArgs = {
  distinct_on?: InputMaybe<Array<Firebase_Message_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firebase_Message_Token_Order_By>>;
  where?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
};


export type Subscription_RootFirebase_Message_Token_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFirebase_Message_Token_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Firebase_Message_Token_Stream_Cursor_Input>>;
  where?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
};


export type Subscription_RootGeo_EventArgs = {
  distinct_on?: InputMaybe<Array<Geo_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Geo_Event_Order_By>>;
  where?: InputMaybe<Geo_Event_Bool_Exp>;
};


export type Subscription_RootGeo_Event_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootGeo_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Geo_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Geo_Event_Bool_Exp>;
};


export type Subscription_RootLogin_LogArgs = {
  distinct_on?: InputMaybe<Array<Login_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Log_Order_By>>;
  where?: InputMaybe<Login_Log_Bool_Exp>;
};


export type Subscription_RootLogin_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLogin_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Login_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Login_Log_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrder_ChangeArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


export type Subscription_RootOrder_Change_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


export type Subscription_RootOrder_Change_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootOrder_Change_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Change_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


export type Subscription_RootOrder_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Comments_Order_By>>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};


export type Subscription_RootOrder_Comments_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrder_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};


export type Subscription_RootOrder_PhotoArgs = {
  distinct_on?: InputMaybe<Array<Order_Photo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Photo_Order_By>>;
  where?: InputMaybe<Order_Photo_Bool_Exp>;
};


export type Subscription_RootOrder_Photo_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrder_Photo_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Photo_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Photo_Bool_Exp>;
};


export type Subscription_RootOrder_PositionArgs = {
  distinct_on?: InputMaybe<Array<Order_Position_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Position_Order_By>>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};


export type Subscription_RootOrder_Position_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrder_Position_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Position_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Position_Bool_Exp>;
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootPayment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Payment_Type_Order_By>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Subscription_RootPayment_Type_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPayment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Payment_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Type_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProvinceArgs = {
  distinct_on?: InputMaybe<Array<Province_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Province_Order_By>>;
  where?: InputMaybe<Province_Bool_Exp>;
};


export type Subscription_RootProvince_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootProvince_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Province_Stream_Cursor_Input>>;
  where?: InputMaybe<Province_Bool_Exp>;
};


export type Subscription_RootStatusArgs = {
  distinct_on?: InputMaybe<Array<Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Order_By>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootStatus_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Status_Bool_Exp>;
};


export type Subscription_RootStatus_TransitionArgs = {
  distinct_on?: InputMaybe<Array<Status_Transition_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Status_Transition_Order_By>>;
  where?: InputMaybe<Status_Transition_Bool_Exp>;
};


export type Subscription_RootStatus_Transition_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootStatus_Transition_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Status_Transition_Stream_Cursor_Input>>;
  where?: InputMaybe<Status_Transition_Bool_Exp>;
};


export type Subscription_RootTrack_PointArgs = {
  distinct_on?: InputMaybe<Array<Track_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Track_Point_Order_By>>;
  where?: InputMaybe<Track_Point_Bool_Exp>;
};


export type Subscription_RootTrack_Point_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTrack_Point_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Track_Point_Stream_Cursor_Input>>;
  where?: InputMaybe<Track_Point_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_Views_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Views_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Views_Log_Order_By>>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};


export type Subscription_RootUser_Views_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Views_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Views_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};


export type Subscription_RootWarehouseArgs = {
  distinct_on?: InputMaybe<Array<Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warehouse_Order_By>>;
  where?: InputMaybe<Warehouse_Bool_Exp>;
};


export type Subscription_RootWarehouse_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWarehouse_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Warehouse_Stream_Cursor_Input>>;
  where?: InputMaybe<Warehouse_Bool_Exp>;
};


export type Subscription_RootWeekday_WindowArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_Order_By>>;
  where?: InputMaybe<Weekday_Window_Bool_Exp>;
};


export type Subscription_RootWeekday_Window_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWeekday_Window_DistrictArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_District_Order_By>>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};


export type Subscription_RootWeekday_Window_District_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWeekday_Window_District_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weekday_Window_District_Stream_Cursor_Input>>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};


export type Subscription_RootWeekday_Window_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Weekday_Window_Stream_Cursor_Input>>;
  where?: InputMaybe<Weekday_Window_Bool_Exp>;
};


export type Subscription_RootWindow_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


export type Subscription_RootWindow_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


export type Subscription_RootWindow_Delivery_Providers_By_PkArgs = {
  provider_id: Scalars['uuid']['input'];
  window_id: Scalars['Int']['input'];
};


export type Subscription_RootWindow_Delivery_Providers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Window_Delivery_Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "track_point" */
export type Track_Point = {
  __typename?: 'track_point';
  batteryLevel?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geography']['output']>;
  id: Scalars['Int']['output'];
  lat: Scalars['numeric']['output'];
  lng: Scalars['numeric']['output'];
  time: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: User;
  userID: Scalars['String']['output'];
};

/** order by aggregate values of table "track_point" */
export type Track_Point_Aggregate_Order_By = {
  avg?: InputMaybe<Track_Point_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Track_Point_Max_Order_By>;
  min?: InputMaybe<Track_Point_Min_Order_By>;
  stddev?: InputMaybe<Track_Point_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Track_Point_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Track_Point_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Track_Point_Sum_Order_By>;
  var_pop?: InputMaybe<Track_Point_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Track_Point_Var_Samp_Order_By>;
  variance?: InputMaybe<Track_Point_Variance_Order_By>;
};

/** order by avg() on columns of table "track_point" */
export type Track_Point_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "track_point". All fields are combined with a logical 'AND'. */
export type Track_Point_Bool_Exp = {
  _and?: InputMaybe<Array<Track_Point_Bool_Exp>>;
  _not?: InputMaybe<Track_Point_Bool_Exp>;
  _or?: InputMaybe<Array<Track_Point_Bool_Exp>>;
  batteryLevel?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  time?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userID?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "track_point" */
export type Track_Point_Max_Order_By = {
  batteryLevel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  userID?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "track_point" */
export type Track_Point_Min_Order_By = {
  batteryLevel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  userID?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "track_point". */
export type Track_Point_Order_By = {
  batteryLevel?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  time?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userID?: InputMaybe<Order_By>;
};

/** select columns of table "track_point" */
export enum Track_Point_Select_Column {
  /** column name */
  BatteryLevel = 'batteryLevel',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Time = 'time',
  /** column name */
  UserId = 'userID'
}

/** order by stddev() on columns of table "track_point" */
export type Track_Point_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "track_point" */
export type Track_Point_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "track_point" */
export type Track_Point_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "track_point" */
export type Track_Point_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Track_Point_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Track_Point_Stream_Cursor_Value_Input = {
  batteryLevel?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['numeric']['input']>;
  lng?: InputMaybe<Scalars['numeric']['input']>;
  time?: InputMaybe<Scalars['timestamptz']['input']>;
  userID?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "track_point" */
export type Track_Point_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "track_point" */
export type Track_Point_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "track_point" */
export type Track_Point_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "track_point" */
export type Track_Point_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  allowFinance: Scalars['Boolean']['output'];
  blocked: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  departments_users: Array<Departments_Users>;
  /** An array relationship */
  driver_districts: Array<Driver_District>;
  /** An array relationship */
  driver_holidays: Array<Driver_Holiday>;
  /** An array relationship */
  driver_windows: Array<Driver_Window>;
  /** An array relationship */
  driver_workloads: Array<Driver_Workload>;
  /** An aggregate relationship */
  driver_workloads_aggregate: Driver_Workload_Aggregate;
  email?: Maybe<Scalars['String']['output']>;
  firebaseMessagingToken?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  firebase_message_tokens: Array<Firebase_Message_Token>;
  id: Scalars['String']['output'];
  lastSeen: Scalars['timestamptz']['output'];
  /** An array relationship */
  login_logs: Array<Login_Log>;
  name: Scalars['String']['output'];
  /** An array relationship */
  order_changes: Array<Order_Change>;
  /** An aggregate relationship */
  order_changes_aggregate: Order_Change_Aggregate;
  /** An array relationship */
  order_comments: Array<Order_Comments>;
  /** An array relationship */
  orders: Array<Order>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
  role: Scalars['String']['output'];
  roles: Scalars['jsonb']['output'];
  telegramName?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  track_points: Array<Track_Point>;
  /** An array relationship */
  user_views_logs: Array<User_Views_Log>;
  /** An array relationship */
  warehouses: Array<Warehouse>;
};


/** columns and relationships of "user" */
export type UserDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** columns and relationships of "user" */
export type UserDepartments_UsersArgs = {
  distinct_on?: InputMaybe<Array<Departments_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Departments_Users_Order_By>>;
  where?: InputMaybe<Departments_Users_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Driver_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_District_Order_By>>;
  where?: InputMaybe<Driver_District_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_HolidaysArgs = {
  distinct_on?: InputMaybe<Array<Driver_Holiday_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Holiday_Order_By>>;
  where?: InputMaybe<Driver_Holiday_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_WindowsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Window_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Window_Order_By>>;
  where?: InputMaybe<Driver_Window_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_WorkloadsArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDriver_Workloads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Driver_Workload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Driver_Workload_Order_By>>;
  where?: InputMaybe<Driver_Workload_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFirebase_Message_TokensArgs = {
  distinct_on?: InputMaybe<Array<Firebase_Message_Token_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Firebase_Message_Token_Order_By>>;
  where?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserLogin_LogsArgs = {
  distinct_on?: InputMaybe<Array<Login_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Login_Log_Order_By>>;
  where?: InputMaybe<Login_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrder_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrder_Changes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Change_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Change_Order_By>>;
  where?: InputMaybe<Order_Change_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrder_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Order_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Comments_Order_By>>;
  where?: InputMaybe<Order_Comments_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** columns and relationships of "user" */
export type UserReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};


/** columns and relationships of "user" */
export type UserRolesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user" */
export type UserTrack_PointsArgs = {
  distinct_on?: InputMaybe<Array<Track_Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Track_Point_Order_By>>;
  where?: InputMaybe<Track_Point_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Views_LogsArgs = {
  distinct_on?: InputMaybe<Array<User_Views_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Views_Log_Order_By>>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserWarehousesArgs = {
  distinct_on?: InputMaybe<Array<Warehouse_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Warehouse_Order_By>>;
  where?: InputMaybe<Warehouse_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate avg on columns */
export type User_Avg_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate avg on columns */
export type User_Avg_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate avg on columns */
export type User_Avg_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  allowFinance?: InputMaybe<Boolean_Comparison_Exp>;
  blocked?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  departments_users?: InputMaybe<Departments_Users_Bool_Exp>;
  driver_districts?: InputMaybe<Driver_District_Bool_Exp>;
  driver_holidays?: InputMaybe<Driver_Holiday_Bool_Exp>;
  driver_windows?: InputMaybe<Driver_Window_Bool_Exp>;
  driver_workloads?: InputMaybe<Driver_Workload_Bool_Exp>;
  driver_workloads_aggregate?: InputMaybe<Driver_Workload_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  firebaseMessagingToken?: InputMaybe<String_Comparison_Exp>;
  firebase_message_tokens?: InputMaybe<Firebase_Message_Token_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp>;
  login_logs?: InputMaybe<Login_Log_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_changes?: InputMaybe<Order_Change_Bool_Exp>;
  order_changes_aggregate?: InputMaybe<Order_Change_Aggregate_Bool_Exp>;
  order_comments?: InputMaybe<Order_Comments_Bool_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  ordersCount?: InputMaybe<Int_Comparison_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  roles?: InputMaybe<Jsonb_Comparison_Exp>;
  telegramName?: InputMaybe<String_Comparison_Exp>;
  track_points?: InputMaybe<Track_Point_Bool_Exp>;
  user_views_logs?: InputMaybe<User_Views_Log_Bool_Exp>;
  warehouses?: InputMaybe<Warehouse_Bool_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  roles?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  roles?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebaseMessagingToken?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  telegramName?: Maybe<Scalars['String']['output']>;
};


/** aggregate max on columns */
export type User_Max_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate max on columns */
export type User_Max_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate max on columns */
export type User_Max_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebaseMessagingToken?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  telegramName?: Maybe<Scalars['String']['output']>;
};


/** aggregate min on columns */
export type User_Min_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate min on columns */
export type User_Min_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate min on columns */
export type User_Min_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  allowFinance?: InputMaybe<Order_By>;
  blocked?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  departments_users_aggregate?: InputMaybe<Departments_Users_Aggregate_Order_By>;
  driver_districts_aggregate?: InputMaybe<Driver_District_Aggregate_Order_By>;
  driver_holidays_aggregate?: InputMaybe<Driver_Holiday_Aggregate_Order_By>;
  driver_windows_aggregate?: InputMaybe<Driver_Window_Aggregate_Order_By>;
  driver_workloads_aggregate?: InputMaybe<Driver_Workload_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  firebaseMessagingToken?: InputMaybe<Order_By>;
  firebase_message_tokens_aggregate?: InputMaybe<Firebase_Message_Token_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  lastSeen?: InputMaybe<Order_By>;
  login_logs_aggregate?: InputMaybe<Login_Log_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  order_changes_aggregate?: InputMaybe<Order_Change_Aggregate_Order_By>;
  order_comments_aggregate?: InputMaybe<Order_Comments_Aggregate_Order_By>;
  ordersCount?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  role?: InputMaybe<Order_By>;
  roles?: InputMaybe<Order_By>;
  telegramName?: InputMaybe<Order_By>;
  track_points_aggregate?: InputMaybe<Track_Point_Aggregate_Order_By>;
  user_views_logs_aggregate?: InputMaybe<User_Views_Log_Aggregate_Order_By>;
  warehouses_aggregate?: InputMaybe<Warehouse_Aggregate_Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  roles?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  AllowFinance = 'allowFinance',
  /** column name */
  Blocked = 'blocked',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FirebaseMessagingToken = 'firebaseMessagingToken',
  /** column name */
  Id = 'id',
  /** column name */
  LastSeen = 'lastSeen',
  /** column name */
  Name = 'name',
  /** column name */
  Role = 'role',
  /** column name */
  Roles = 'roles',
  /** column name */
  TelegramName = 'telegramName'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
  telegramName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate stddev on columns */
export type User_Stddev_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate stddev on columns */
export type User_Stddev_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate stddev on columns */
export type User_Stddev_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  allowFinance?: InputMaybe<Scalars['Boolean']['input']>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseMessagingToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Scalars['jsonb']['input']>;
  telegramName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate sum on columns */
export type User_Sum_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate sum on columns */
export type User_Sum_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate sum on columns */
export type User_Sum_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate var_pop on columns */
export type User_Var_Pop_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate var_pop on columns */
export type User_Var_Pop_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate var_pop on columns */
export type User_Var_Pop_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate var_samp on columns */
export type User_Var_Samp_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate var_samp on columns */
export type User_Var_Samp_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate var_samp on columns */
export type User_Var_Samp_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  deliveredOrdersCount?: Maybe<Scalars['Int']['output']>;
  ordersCount?: Maybe<Scalars['Int']['output']>;
  rescheduledOrdersCount?: Maybe<Scalars['Int']['output']>;
  returnedOrdersCount?: Maybe<Scalars['Int']['output']>;
};


/** aggregate variance on columns */
export type User_Variance_FieldsDeliveredOrdersCountArgs = {
  args: DeliveredOrdersCount_User_Args;
};


/** aggregate variance on columns */
export type User_Variance_FieldsRescheduledOrdersCountArgs = {
  args: RescheduledOrdersCount_User_Args;
};


/** aggregate variance on columns */
export type User_Variance_FieldsReturnedOrdersCountArgs = {
  args: ReturnedOrdersCount_User_Args;
};

/** columns and relationships of "user_views_log" */
export type User_Views_Log = {
  __typename?: 'user_views_log';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user: User;
  userId: Scalars['String']['output'];
};

/** order by aggregate values of table "user_views_log" */
export type User_Views_Log_Aggregate_Order_By = {
  avg?: InputMaybe<User_Views_Log_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Views_Log_Max_Order_By>;
  min?: InputMaybe<User_Views_Log_Min_Order_By>;
  stddev?: InputMaybe<User_Views_Log_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Views_Log_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Views_Log_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Views_Log_Sum_Order_By>;
  var_pop?: InputMaybe<User_Views_Log_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Views_Log_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Views_Log_Variance_Order_By>;
};

/** order by avg() on columns of table "user_views_log" */
export type User_Views_Log_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_views_log". All fields are combined with a logical 'AND'. */
export type User_Views_Log_Bool_Exp = {
  _and?: InputMaybe<Array<User_Views_Log_Bool_Exp>>;
  _not?: InputMaybe<User_Views_Log_Bool_Exp>;
  _or?: InputMaybe<Array<User_Views_Log_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_views_log" */
export enum User_Views_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserViewsLogPkey = 'user_views_log_pkey'
}

/** input type for inserting data into table "user_views_log" */
export type User_Views_Log_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "user_views_log" */
export type User_Views_Log_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_views_log" */
export type User_Views_Log_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_views_log" */
export type User_Views_Log_Mutation_Response = {
  __typename?: 'user_views_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Views_Log>;
};

/** on_conflict condition type for table "user_views_log" */
export type User_Views_Log_On_Conflict = {
  constraint: User_Views_Log_Constraint;
  update_columns?: Array<User_Views_Log_Update_Column>;
  where?: InputMaybe<User_Views_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "user_views_log". */
export type User_Views_Log_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "user_views_log" */
export enum User_Views_Log_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "user_views_log" */
export type User_Views_Log_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_views_log" */
export type User_Views_Log_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_views_log" */
export type User_Views_Log_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_views_log" */
export type User_Views_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Views_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Views_Log_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "user_views_log" */
export type User_Views_Log_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "user_views_log" (current role has no relevant permissions) */
export enum User_Views_Log_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "user_views_log" */
export type User_Views_Log_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_views_log" */
export type User_Views_Log_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_views_log" */
export type User_Views_Log_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "warehouse" */
export type Warehouse = {
  __typename?: 'warehouse';
  /** An object relationship */
  department?: Maybe<Department>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  /** An object relationship */
  storekeeper?: Maybe<User>;
  storekeeperId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "warehouse" */
export type WarehouseOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "warehouse" */
export type WarehouseOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** order by aggregate values of table "warehouse" */
export type Warehouse_Aggregate_Order_By = {
  avg?: InputMaybe<Warehouse_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Warehouse_Max_Order_By>;
  min?: InputMaybe<Warehouse_Min_Order_By>;
  stddev?: InputMaybe<Warehouse_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Warehouse_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Warehouse_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Warehouse_Sum_Order_By>;
  var_pop?: InputMaybe<Warehouse_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Warehouse_Var_Samp_Order_By>;
  variance?: InputMaybe<Warehouse_Variance_Order_By>;
};

/** order by avg() on columns of table "warehouse" */
export type Warehouse_Avg_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "warehouse". All fields are combined with a logical 'AND'. */
export type Warehouse_Bool_Exp = {
  _and?: InputMaybe<Array<Warehouse_Bool_Exp>>;
  _not?: InputMaybe<Warehouse_Bool_Exp>;
  _or?: InputMaybe<Array<Warehouse_Bool_Exp>>;
  department?: InputMaybe<Department_Bool_Exp>;
  departmentId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  storekeeper?: InputMaybe<User_Bool_Exp>;
  storekeeperId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "warehouse" */
export type Warehouse_Max_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storekeeperId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "warehouse" */
export type Warehouse_Min_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  storekeeperId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "warehouse". */
export type Warehouse_Order_By = {
  department?: InputMaybe<Department_Order_By>;
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  storekeeper?: InputMaybe<User_Order_By>;
  storekeeperId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "warehouse" */
export enum Warehouse_Select_Column {
  /** column name */
  DepartmentId = 'departmentId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  StorekeeperId = 'storekeeperId',
  /** column name */
  Type = 'type'
}

/** order by stddev() on columns of table "warehouse" */
export type Warehouse_Stddev_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "warehouse" */
export type Warehouse_Stddev_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "warehouse" */
export type Warehouse_Stddev_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "warehouse" */
export type Warehouse_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Warehouse_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Warehouse_Stream_Cursor_Value_Input = {
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  storekeeperId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "warehouse" */
export type Warehouse_Sum_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "warehouse" */
export type Warehouse_Var_Pop_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "warehouse" */
export type Warehouse_Var_Samp_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "warehouse" */
export type Warehouse_Variance_Order_By = {
  departmentId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "weekday_window" */
export type Weekday_Window = {
  __typename?: 'weekday_window';
  driverWindowId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  driver_window?: Maybe<Driver_Window>;
  id: Scalars['Int']['output'];
  weekday?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  weekday_window_districts: Array<Weekday_Window_District>;
  weekend?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  window_delivery_providers: Array<Window_Delivery_Providers>;
  /** An aggregate relationship */
  window_delivery_providers_aggregate: Window_Delivery_Providers_Aggregate;
};


/** columns and relationships of "weekday_window" */
export type Weekday_WindowWeekday_Window_DistrictsArgs = {
  distinct_on?: InputMaybe<Array<Weekday_Window_District_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Weekday_Window_District_Order_By>>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};


/** columns and relationships of "weekday_window" */
export type Weekday_WindowWindow_Delivery_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};


/** columns and relationships of "weekday_window" */
export type Weekday_WindowWindow_Delivery_Providers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_Delivery_Providers_Order_By>>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};

/** order by aggregate values of table "weekday_window" */
export type Weekday_Window_Aggregate_Order_By = {
  avg?: InputMaybe<Weekday_Window_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Weekday_Window_Max_Order_By>;
  min?: InputMaybe<Weekday_Window_Min_Order_By>;
  stddev?: InputMaybe<Weekday_Window_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Weekday_Window_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Weekday_Window_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Weekday_Window_Sum_Order_By>;
  var_pop?: InputMaybe<Weekday_Window_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Weekday_Window_Var_Samp_Order_By>;
  variance?: InputMaybe<Weekday_Window_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "weekday_window" */
export type Weekday_Window_Arr_Rel_Insert_Input = {
  data: Array<Weekday_Window_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Weekday_Window_On_Conflict>;
};

/** order by avg() on columns of table "weekday_window" */
export type Weekday_Window_Avg_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "weekday_window". All fields are combined with a logical 'AND'. */
export type Weekday_Window_Bool_Exp = {
  _and?: InputMaybe<Array<Weekday_Window_Bool_Exp>>;
  _not?: InputMaybe<Weekday_Window_Bool_Exp>;
  _or?: InputMaybe<Array<Weekday_Window_Bool_Exp>>;
  driverWindowId?: InputMaybe<Int_Comparison_Exp>;
  driver_window?: InputMaybe<Driver_Window_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  weekday?: InputMaybe<Int_Comparison_Exp>;
  weekday_window_districts?: InputMaybe<Weekday_Window_District_Bool_Exp>;
  weekend?: InputMaybe<Boolean_Comparison_Exp>;
  window_delivery_providers?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
  window_delivery_providers_aggregate?: InputMaybe<Window_Delivery_Providers_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "weekday_window" */
export enum Weekday_Window_Constraint {
  /** unique or primary key constraint on columns "weekday", "driverWindowId" */
  WeekdayWindowDriverWindowIdWeekdayKey = 'weekday_window_driverWindowId_weekday_key',
  /** unique or primary key constraint on columns "id" */
  WeekdayWindowPkey = 'weekday_window_pkey'
}

/** columns and relationships of "weekday_window_district" */
export type Weekday_Window_District = {
  __typename?: 'weekday_window_district';
  /** An object relationship */
  district?: Maybe<District>;
  districtId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  tempDateFrom?: Maybe<Scalars['timestamptz']['output']>;
  tempDateTo?: Maybe<Scalars['timestamptz']['output']>;
  weekdayWindowId?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  weekday_window?: Maybe<Weekday_Window>;
};

/** order by aggregate values of table "weekday_window_district" */
export type Weekday_Window_District_Aggregate_Order_By = {
  avg?: InputMaybe<Weekday_Window_District_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Weekday_Window_District_Max_Order_By>;
  min?: InputMaybe<Weekday_Window_District_Min_Order_By>;
  stddev?: InputMaybe<Weekday_Window_District_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Weekday_Window_District_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Weekday_Window_District_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Weekday_Window_District_Sum_Order_By>;
  var_pop?: InputMaybe<Weekday_Window_District_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Weekday_Window_District_Var_Samp_Order_By>;
  variance?: InputMaybe<Weekday_Window_District_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "weekday_window_district" */
export type Weekday_Window_District_Arr_Rel_Insert_Input = {
  data: Array<Weekday_Window_District_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Weekday_Window_District_On_Conflict>;
};

/** order by avg() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "weekday_window_district". All fields are combined with a logical 'AND'. */
export type Weekday_Window_District_Bool_Exp = {
  _and?: InputMaybe<Array<Weekday_Window_District_Bool_Exp>>;
  _not?: InputMaybe<Weekday_Window_District_Bool_Exp>;
  _or?: InputMaybe<Array<Weekday_Window_District_Bool_Exp>>;
  district?: InputMaybe<District_Bool_Exp>;
  districtId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tempDateFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  tempDateTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  weekdayWindowId?: InputMaybe<Int_Comparison_Exp>;
  weekday_window?: InputMaybe<Weekday_Window_Bool_Exp>;
};

/** unique or primary key constraints on table "weekday_window_district" */
export enum Weekday_Window_District_Constraint {
  /** unique or primary key constraint on columns "id" */
  WeekdayWindowDistrictPkey = 'weekday_window_district_pkey',
  /** unique or primary key constraint on columns "districtId", "weekdayWindowId" */
  WeekdayWindowDistrictWeekdayWindowIdDistrictIdKey = 'weekday_window_district_weekdayWindowId_districtId_key'
}

/** input type for incrementing numeric columns in table "weekday_window_district" */
export type Weekday_Window_District_Inc_Input = {
  weekdayWindowId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "weekday_window_district" */
export type Weekday_Window_District_Insert_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tempDateFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  tempDateTo?: InputMaybe<Scalars['timestamptz']['input']>;
  weekdayWindowId?: InputMaybe<Scalars['Int']['input']>;
  weekday_window?: InputMaybe<Weekday_Window_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Max_Order_By = {
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tempDateFrom?: InputMaybe<Order_By>;
  tempDateTo?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Min_Order_By = {
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tempDateFrom?: InputMaybe<Order_By>;
  tempDateTo?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "weekday_window_district" */
export type Weekday_Window_District_Mutation_Response = {
  __typename?: 'weekday_window_district_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weekday_Window_District>;
};

/** on_conflict condition type for table "weekday_window_district" */
export type Weekday_Window_District_On_Conflict = {
  constraint: Weekday_Window_District_Constraint;
  update_columns?: Array<Weekday_Window_District_Update_Column>;
  where?: InputMaybe<Weekday_Window_District_Bool_Exp>;
};

/** Ordering options when selecting data from "weekday_window_district". */
export type Weekday_Window_District_Order_By = {
  district?: InputMaybe<District_Order_By>;
  districtId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tempDateFrom?: InputMaybe<Order_By>;
  tempDateTo?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
  weekday_window?: InputMaybe<Weekday_Window_Order_By>;
};

/** primary key columns input for table: weekday_window_district */
export type Weekday_Window_District_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "weekday_window_district" */
export enum Weekday_Window_District_Select_Column {
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  Id = 'id',
  /** column name */
  TempDateFrom = 'tempDateFrom',
  /** column name */
  TempDateTo = 'tempDateTo',
  /** column name */
  WeekdayWindowId = 'weekdayWindowId'
}

/** input type for updating data in table "weekday_window_district" */
export type Weekday_Window_District_Set_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  tempDateFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  tempDateTo?: InputMaybe<Scalars['timestamptz']['input']>;
  weekdayWindowId?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "weekday_window_district" */
export type Weekday_Window_District_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weekday_Window_District_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weekday_Window_District_Stream_Cursor_Value_Input = {
  districtId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  tempDateFrom?: InputMaybe<Scalars['timestamptz']['input']>;
  tempDateTo?: InputMaybe<Scalars['timestamptz']['input']>;
  weekdayWindowId?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** update columns of table "weekday_window_district" */
export enum Weekday_Window_District_Update_Column {
  /** column name */
  DistrictId = 'districtId',
  /** column name */
  TempDateFrom = 'tempDateFrom',
  /** column name */
  TempDateTo = 'tempDateTo',
  /** column name */
  WeekdayWindowId = 'weekdayWindowId'
}

export type Weekday_Window_District_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Weekday_Window_District_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weekday_Window_District_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weekday_Window_District_Bool_Exp;
};

/** order by var_pop() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "weekday_window_district" */
export type Weekday_Window_District_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  weekdayWindowId?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "weekday_window" */
export type Weekday_Window_Insert_Input = {
  driverWindowId?: InputMaybe<Scalars['Int']['input']>;
  driver_window?: InputMaybe<Driver_Window_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
  weekday_window_districts?: InputMaybe<Weekday_Window_District_Arr_Rel_Insert_Input>;
  weekend?: InputMaybe<Scalars['Boolean']['input']>;
  window_delivery_providers?: InputMaybe<Window_Delivery_Providers_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "weekday_window" */
export type Weekday_Window_Max_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "weekday_window" */
export type Weekday_Window_Min_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "weekday_window" */
export type Weekday_Window_Mutation_Response = {
  __typename?: 'weekday_window_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Weekday_Window>;
};

/** input type for inserting object relation for remote table "weekday_window" */
export type Weekday_Window_Obj_Rel_Insert_Input = {
  data: Weekday_Window_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Weekday_Window_On_Conflict>;
};

/** on_conflict condition type for table "weekday_window" */
export type Weekday_Window_On_Conflict = {
  constraint: Weekday_Window_Constraint;
  update_columns?: Array<Weekday_Window_Update_Column>;
  where?: InputMaybe<Weekday_Window_Bool_Exp>;
};

/** Ordering options when selecting data from "weekday_window". */
export type Weekday_Window_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  driver_window?: InputMaybe<Driver_Window_Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
  weekday_window_districts_aggregate?: InputMaybe<Weekday_Window_District_Aggregate_Order_By>;
  weekend?: InputMaybe<Order_By>;
  window_delivery_providers_aggregate?: InputMaybe<Window_Delivery_Providers_Aggregate_Order_By>;
};

/** primary key columns input for table: weekday_window */
export type Weekday_Window_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "weekday_window" */
export enum Weekday_Window_Select_Column {
  /** column name */
  DriverWindowId = 'driverWindowId',
  /** column name */
  Id = 'id',
  /** column name */
  Weekday = 'weekday',
  /** column name */
  Weekend = 'weekend'
}

/** input type for updating data in table "weekday_window" */
export type Weekday_Window_Set_Input = {
  weekend?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "weekday_window" */
export type Weekday_Window_Stddev_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "weekday_window" */
export type Weekday_Window_Stddev_Pop_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "weekday_window" */
export type Weekday_Window_Stddev_Samp_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "weekday_window" */
export type Weekday_Window_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Weekday_Window_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Weekday_Window_Stream_Cursor_Value_Input = {
  driverWindowId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  weekday?: InputMaybe<Scalars['Int']['input']>;
  weekend?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "weekday_window" */
export type Weekday_Window_Sum_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** update columns of table "weekday_window" */
export enum Weekday_Window_Update_Column {
  /** column name */
  Weekend = 'weekend'
}

export type Weekday_Window_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Weekday_Window_Set_Input>;
  /** filter the rows which have to be updated */
  where: Weekday_Window_Bool_Exp;
};

/** order by var_pop() on columns of table "weekday_window" */
export type Weekday_Window_Var_Pop_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "weekday_window" */
export type Weekday_Window_Var_Samp_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "weekday_window" */
export type Weekday_Window_Variance_Order_By = {
  driverWindowId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  weekday?: InputMaybe<Order_By>;
};

/** columns and relationships of "window_delivery_providers" */
export type Window_Delivery_Providers = {
  __typename?: 'window_delivery_providers';
  /** An object relationship */
  delivery_provider: Delivery_Provider;
  provider_id: Scalars['uuid']['output'];
  /** An object relationship */
  weekday_window: Weekday_Window;
  window_id: Scalars['Int']['output'];
};

/** aggregated selection of "window_delivery_providers" */
export type Window_Delivery_Providers_Aggregate = {
  __typename?: 'window_delivery_providers_aggregate';
  aggregate?: Maybe<Window_Delivery_Providers_Aggregate_Fields>;
  nodes: Array<Window_Delivery_Providers>;
};

export type Window_Delivery_Providers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Window_Delivery_Providers_Aggregate_Bool_Exp_Count>;
};

export type Window_Delivery_Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "window_delivery_providers" */
export type Window_Delivery_Providers_Aggregate_Fields = {
  __typename?: 'window_delivery_providers_aggregate_fields';
  avg?: Maybe<Window_Delivery_Providers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Window_Delivery_Providers_Max_Fields>;
  min?: Maybe<Window_Delivery_Providers_Min_Fields>;
  stddev?: Maybe<Window_Delivery_Providers_Stddev_Fields>;
  stddev_pop?: Maybe<Window_Delivery_Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Window_Delivery_Providers_Stddev_Samp_Fields>;
  sum?: Maybe<Window_Delivery_Providers_Sum_Fields>;
  var_pop?: Maybe<Window_Delivery_Providers_Var_Pop_Fields>;
  var_samp?: Maybe<Window_Delivery_Providers_Var_Samp_Fields>;
  variance?: Maybe<Window_Delivery_Providers_Variance_Fields>;
};


/** aggregate fields of "window_delivery_providers" */
export type Window_Delivery_Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Window_Delivery_Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "window_delivery_providers" */
export type Window_Delivery_Providers_Aggregate_Order_By = {
  avg?: InputMaybe<Window_Delivery_Providers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Window_Delivery_Providers_Max_Order_By>;
  min?: InputMaybe<Window_Delivery_Providers_Min_Order_By>;
  stddev?: InputMaybe<Window_Delivery_Providers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Window_Delivery_Providers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Window_Delivery_Providers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Window_Delivery_Providers_Sum_Order_By>;
  var_pop?: InputMaybe<Window_Delivery_Providers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Window_Delivery_Providers_Var_Samp_Order_By>;
  variance?: InputMaybe<Window_Delivery_Providers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "window_delivery_providers" */
export type Window_Delivery_Providers_Arr_Rel_Insert_Input = {
  data: Array<Window_Delivery_Providers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Window_Delivery_Providers_On_Conflict>;
};

/** aggregate avg on columns */
export type Window_Delivery_Providers_Avg_Fields = {
  __typename?: 'window_delivery_providers_avg_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Avg_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "window_delivery_providers". All fields are combined with a logical 'AND'. */
export type Window_Delivery_Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Window_Delivery_Providers_Bool_Exp>>;
  _not?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Window_Delivery_Providers_Bool_Exp>>;
  delivery_provider?: InputMaybe<Delivery_Provider_Bool_Exp>;
  provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  weekday_window?: InputMaybe<Weekday_Window_Bool_Exp>;
  window_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "window_delivery_providers" */
export enum Window_Delivery_Providers_Constraint {
  /** unique or primary key constraint on columns "window_id", "provider_id" */
  WindowDeliveryProvidersPkey = 'window_delivery_providers_pkey'
}

/** input type for inserting data into table "window_delivery_providers" */
export type Window_Delivery_Providers_Insert_Input = {
  provider_id?: InputMaybe<Scalars['uuid']['input']>;
  weekday_window?: InputMaybe<Weekday_Window_Obj_Rel_Insert_Input>;
  window_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Window_Delivery_Providers_Max_Fields = {
  __typename?: 'window_delivery_providers_max_fields';
  provider_id?: Maybe<Scalars['uuid']['output']>;
  window_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Max_Order_By = {
  provider_id?: InputMaybe<Order_By>;
  window_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Window_Delivery_Providers_Min_Fields = {
  __typename?: 'window_delivery_providers_min_fields';
  provider_id?: Maybe<Scalars['uuid']['output']>;
  window_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Min_Order_By = {
  provider_id?: InputMaybe<Order_By>;
  window_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "window_delivery_providers" */
export type Window_Delivery_Providers_Mutation_Response = {
  __typename?: 'window_delivery_providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Window_Delivery_Providers>;
};

/** on_conflict condition type for table "window_delivery_providers" */
export type Window_Delivery_Providers_On_Conflict = {
  constraint: Window_Delivery_Providers_Constraint;
  update_columns?: Array<Window_Delivery_Providers_Update_Column>;
  where?: InputMaybe<Window_Delivery_Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "window_delivery_providers". */
export type Window_Delivery_Providers_Order_By = {
  delivery_provider?: InputMaybe<Delivery_Provider_Order_By>;
  provider_id?: InputMaybe<Order_By>;
  weekday_window?: InputMaybe<Weekday_Window_Order_By>;
  window_id?: InputMaybe<Order_By>;
};

/** select columns of table "window_delivery_providers" */
export enum Window_Delivery_Providers_Select_Column {
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  WindowId = 'window_id'
}

/** aggregate stddev on columns */
export type Window_Delivery_Providers_Stddev_Fields = {
  __typename?: 'window_delivery_providers_stddev_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Stddev_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Window_Delivery_Providers_Stddev_Pop_Fields = {
  __typename?: 'window_delivery_providers_stddev_pop_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Stddev_Pop_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Window_Delivery_Providers_Stddev_Samp_Fields = {
  __typename?: 'window_delivery_providers_stddev_samp_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Stddev_Samp_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "window_delivery_providers" */
export type Window_Delivery_Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Window_Delivery_Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Window_Delivery_Providers_Stream_Cursor_Value_Input = {
  provider_id?: InputMaybe<Scalars['uuid']['input']>;
  window_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Window_Delivery_Providers_Sum_Fields = {
  __typename?: 'window_delivery_providers_sum_fields';
  window_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Sum_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "window_delivery_providers" (current role has no relevant permissions) */
export enum Window_Delivery_Providers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Window_Delivery_Providers_Var_Pop_Fields = {
  __typename?: 'window_delivery_providers_var_pop_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Var_Pop_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Window_Delivery_Providers_Var_Samp_Fields = {
  __typename?: 'window_delivery_providers_var_samp_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Var_Samp_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Window_Delivery_Providers_Variance_Fields = {
  __typename?: 'window_delivery_providers_variance_fields';
  window_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "window_delivery_providers" */
export type Window_Delivery_Providers_Variance_Order_By = {
  window_id?: InputMaybe<Order_By>;
};

export type ReplaceUserFcmTokenMutationVariables = Exact<{
  data: FcmInput;
}>;


export type ReplaceUserFcmTokenMutation = { __typename?: 'mutation_root', replaceUserFCMToken?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type RemoveUserFcmTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RemoveUserFcmTokenMutation = { __typename?: 'mutation_root', removeUserFcmToken?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type InsertOrderCommentMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  authorId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type InsertOrderCommentMutation = { __typename?: 'mutation_root', insert_order_comments_one?: { __typename?: 'order_comments', id: number, orderId: number } | null };

export type EditOrderMutationVariables = Exact<{
  orderID: Scalars['Int']['input'];
  umbrellaID: Scalars['String']['input'];
  orderItems: Array<OrderItemInput> | OrderItemInput;
}>;


export type EditOrderMutation = { __typename?: 'mutation_root', editOrder?: { __typename?: 'OrderItemOutput', orderItems?: any | null, deliveryPrice?: number | null } | null };

export type UpdateOrderViaActionMutationVariables = Exact<{
  orderId: Scalars['Int']['input'];
  order?: InputMaybe<OrderPatch>;
  client?: InputMaybe<ClientPatch>;
  address?: InputMaybe<AddressPatch>;
}>;


export type UpdateOrderViaActionMutation = { __typename?: 'mutation_root', updateOrder?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type CalcOrderPriceQueryVariables = Exact<{
  orderID: Scalars['Int']['input'];
  umbrellaID: Scalars['String']['input'];
  orderItems: Array<OrderItemInput> | OrderItemInput;
}>;


export type CalcOrderPriceQuery = { __typename?: 'query_root', recalcOrder?: { __typename?: 'OrderItemOutput', orderItems?: any | null, deliveryPrice?: number | null } | null };

export type InsertUserViewsLogMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertUserViewsLogMutation = { __typename?: 'mutation_root', insert_user_views_log?: { __typename?: 'user_views_log_mutation_response', affected_rows: number } | null };

export type GetOrderCommentsQueryVariables = Exact<{
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderCommentsQuery = { __typename?: 'query_root', order_comments: Array<{ __typename?: 'order_comments', id: number, authorId?: string | null, externalAuthor?: string | null, comment?: string | null, createdAt: any, source?: string | null, user?: { __typename?: 'user', name: string } | null }> };

export type GetOrderHistoryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderId: Scalars['Int']['input'];
}>;


export type GetOrderHistoryQuery = { __typename?: 'query_root', order_change: Array<{ __typename?: 'order_change', id: any, new: any, old: any, createdAt: any, editor?: { __typename?: 'user', id: string, name: string } | null }>, order_change_aggregate: { __typename?: 'order_change_aggregate', aggregate?: { __typename?: 'order_change_aggregate_fields', count: number } | null }, driver_order_interaction: Array<{ __typename?: 'driver_order_interaction', id: number, contact_type: any, createdAt: any, user?: { __typename?: 'user', name: string } | null }>, user_views_log: Array<{ __typename?: 'user_views_log', id: number, orderId?: number | null, userId: string, createdAt: any, user: { __typename?: 'user', name: string } }> };

export type GetOrdersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Order_Bool_Exp>;
  sorters: Array<Order_Order_By> | Order_Order_By;
}>;


export type GetOrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', totalCents: number, comment?: string | null, id: number, createdAt: any, updatedAt?: any | null, shortCode?: string | null, isSaved?: boolean | null, resale?: boolean | null, rescheduleCount?: number | null, paymentType?: Payment_Type_Enum | null, plannedDate?: any | null, plannedDateDuration?: number | null, deliveredDate?: any | null, status: { __typename?: 'status', name: string, status_transitions: Array<{ __typename?: 'status_transition', next: string }> }, driver?: { __typename?: 'user', name: string, id: string, blocked: boolean } | null, positions: Array<{ __typename?: 'order_position', product: { __typename?: 'product', id: string, name: string } }>, client: { __typename?: 'client', id: number, phone: string, fullname: string, districtId?: string | null, address?: { __typename?: 'address', city: string, comments?: string | null, country?: string | null, district?: string | null, id: number, lat?: any | null, lng?: any | null, street?: string | null, state?: string | null } | null }, delivery_provider?: { __typename?: 'delivery_provider', short_name: string, display_name: string } | null }>, order_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } };

export type GetMetaQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetMetaQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, name: string, blocked: boolean }>, product: Array<{ __typename?: 'product', id: string, name: string }> };

export type GetBlockedDriversQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetBlockedDriversQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, name: string, blocked: boolean }> };

export type GetStatusesQueryVariables = Exact<{
  ordersWhere: Order_Bool_Exp;
}>;


export type GetStatusesQuery = { __typename?: 'query_root', status: Array<{ __typename?: 'status', name: string, orders_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }>, DriverAssignedExpress: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null }, DriverConfirmedExpress: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null }, DriverOnTheWayExpress: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } };

export type GetOrderByIdWithDriversWarehousesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  departmentId: Scalars['Int']['input'];
}>;


export type GetOrderByIdWithDriversWarehousesQuery = { __typename?: 'query_root', order_by_pk?: { __typename?: 'order', id: number, comment?: string | null, paymentType?: Payment_Type_Enum | null, isSaved?: boolean | null, resale?: boolean | null, departmentId: number, umbrellaID?: string | null, vendorDatalinkId?: number | null, totalCents: number, reasonRefusal?: string | null, shortCode?: string | null, createdAt: any, plannedDate?: any | null, plannedDateDuration?: number | null, department: { __typename?: 'department', country?: { __typename?: 'country', id: string } | null }, order_photos: Array<{ __typename?: 'order_photo', downloadURL: string, id: number }>, status: { __typename?: 'status', name: string, status_transitions: Array<{ __typename?: 'status_transition', next: string }> }, positions: Array<{ __typename?: 'order_position', id: number, quantity: number, productID: string, totalPrice?: number | null, product: { __typename?: 'product', id: string, name: string } }>, order_changes: Array<{ __typename?: 'order_change', id: any }>, client: { __typename?: 'client', id: number, phone: string, fullname: string, districtId?: string | null, address?: { __typename?: 'address', id: number, city: string, comments?: string | null, country?: string | null, district?: string | null, state?: string | null, street?: string | null, lat?: any | null, lng?: any | null, client: Array<{ __typename?: 'client', district?: { __typename?: 'district', name?: string | null } | null }> } | null }, driver?: { __typename?: 'user', id: string, name: string, email?: string | null, blocked: boolean } | null, warehouse?: { __typename?: 'warehouse', name?: string | null, id: number } | null, delivery_provider?: { __typename?: 'delivery_provider', short_name: string, display_name: string } | null } | null, user: Array<{ __typename?: 'user', id: string, name: string, blocked: boolean }>, product: Array<{ __typename?: 'product', id: string, name: string }> };

export type GetOrderListByIdWithDriversWarehousesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  departmentId: Scalars['Int']['input'];
}>;


export type GetOrderListByIdWithDriversWarehousesQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, comment?: string | null, createdAt: any, totalCents: number, shortCode?: string | null, plannedDate?: any | null, plannedDateDuration?: number | null, status: { __typename?: 'status', name: string, status_transitions: Array<{ __typename?: 'status_transition', next: string }> }, client: { __typename?: 'client', id: number, phone: string, fullname: string, address?: { __typename?: 'address', id: number, city: string, comments?: string | null, country?: string | null, district?: string | null, state?: string | null, street?: string | null, lat?: any | null, lng?: any | null } | null }, driver?: { __typename?: 'user', id: string, name: string, email?: string | null, blocked: boolean } | null, positions: Array<{ __typename?: 'order_position', quantity: number, product: { __typename?: 'product', name: string, id: string } }> }>, user: Array<{ __typename?: 'user', id: string, name: string, blocked: boolean }> };

export type GetDistrictScheduleAndWorkloadQueryVariables = Exact<{
  districtId: Scalars['String']['input'];
  plannedDate: Scalars['timestamptz']['input'];
  nextDay: Scalars['timestamptz']['input'];
}>;


export type GetDistrictScheduleAndWorkloadQuery = { __typename?: 'query_root', district_by_pk?: { __typename?: 'district', id: string, loadFactor?: number | null, weekday_window_districts: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', weekday?: number | null, driver_window?: { __typename?: 'driver_window', timeDuration?: string | null } | null } | null }> } | null, district_workload: Array<{ __typename?: 'district_workload', districtId?: string | null, loadFactor?: number | null, timeperiod?: any | null, workload?: any | null }> };

export type GetDriversWorkloadQueryVariables = Exact<{
  districtId: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
  startOfWeek: Scalars['timestamptz']['input'];
  endOfWeek: Scalars['timestamptz']['input'];
}>;


export type GetDriversWorkloadQuery = { __typename?: 'query_root', driver_workload_for: Array<{ __typename?: 'driver_workload', workload?: any | null, timeperiod?: any | null, timeZone?: number | null, driverId: string }> };

export type GetPaymentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentTypesQuery = { __typename?: 'query_root', payment_type: Array<{ __typename?: 'payment_type', value: string }> };

export type ExpressNewOrdersMultiQueryQueryVariables = Exact<{
  departmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ExpressNewOrdersMultiQueryQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, statusName: string, createdAt: any, shortCode?: string | null, departmentId: number, department: { __typename?: 'department', id: number, name: string }, delivery_provider?: { __typename?: 'delivery_provider', short_name: string, display_name: string } | null }> };

export type NewReadyAndPickedOrdersMultiQueryQueryVariables = Exact<{
  departmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type NewReadyAndPickedOrdersMultiQueryQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: number, statusName: string, createdAt: any, shortCode?: string | null, departmentId: number, department: { __typename?: 'department', id: number, name: string } }> };

export type GetCountriesByDepartmentIdQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetCountriesByDepartmentIdQuery = { __typename?: 'query_root', country: Array<{ __typename?: 'country', id: string, name?: string | null }> };

export type GetUserDepartmentsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetUserDepartmentsQuery = { __typename?: 'query_root', department: Array<{ __typename?: 'department', id: number, name: string, countryId?: string | null, currency: string, language: string, timeZone: number, is_express_enabled: boolean, disabled_express_reason?: string | null }> };

export type GetCurrentUserDepartmentsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCurrentUserDepartmentsQuery = { __typename?: 'query_root', departments_users: Array<{ __typename?: 'departments_users', departmentId: number, department: { __typename?: 'department', id: number, name: string, countryId?: string | null, currency: string, language: string, timeZone: number, is_express_enabled: boolean, disabled_express_reason?: string | null } }> };

export type ToggleDepartmentExpressMutationVariables = Exact<{
  data: ToggleInput;
}>;


export type ToggleDepartmentExpressMutation = { __typename?: 'mutation_root', toggleDepartmentExpress: { __typename: 'ToggleResponse' } };

export type GetCountryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryListQuery = { __typename?: 'query_root', country: Array<{ __typename?: 'country', id: string, name?: string | null, country_holidays: Array<{ __typename?: 'country_holiday', date: any, id: number }> }> };

export type InsertCountryHolidayMutationVariables = Exact<{
  countryId: Scalars['String']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type InsertCountryHolidayMutation = { __typename?: 'mutation_root', insert_country_holiday_one?: { __typename?: 'country_holiday', id: number } | null };

export type DeleteCountryHolidayMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCountryHolidayMutation = { __typename?: 'mutation_root', delete_country_holiday_by_pk?: { __typename?: 'country_holiday', id: number } | null };

export type InsertDriverDistrictOldMutationVariables = Exact<{
  driverId: Scalars['String']['input'];
  districtId: Scalars['String']['input'];
}>;


export type InsertDriverDistrictOldMutation = { __typename?: 'mutation_root', insert_driver_district_one?: { __typename?: 'driver_district', id: number } | null };

export type DeleteDriverDistrictOldMutationVariables = Exact<{
  districtId: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
}>;


export type DeleteDriverDistrictOldMutation = { __typename?: 'mutation_root', delete_driver_district?: { __typename?: 'driver_district_mutation_response', affected_rows: number } | null };

export type GetDriversDistrictListByIdQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
}>;


export type GetDriversDistrictListByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', id: string, name: string, driver_districts: Array<{ __typename?: 'driver_district', id: number, district: { __typename?: 'district', id: string, name?: string | null } }> } | null };

export type GetDriversDistrictListQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetDriversDistrictListQuery = { __typename?: 'query_root', district: Array<{ __typename?: 'district', id: string, name?: string | null, isPolygone?: boolean | null, districts_coordinates: Array<{ __typename?: 'districts_coordinates', latitude?: any | null, longitude?: any | null }> }> };

export type GetWeekdayWindowForSlotQueryVariables = Exact<{
  driverWindowId: Scalars['Int']['input'];
}>;


export type GetWeekdayWindowForSlotQuery = { __typename?: 'query_root', weekday_window: Array<{ __typename?: 'weekday_window', id: number, weekday?: number | null, weekday_window_districts: Array<{ __typename?: 'weekday_window_district', district?: { __typename?: 'district', id: string, name?: string | null } | null }> }> };

export type GetWeekdayWindowsAllQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
}>;


export type GetWeekdayWindowsAllQuery = { __typename?: 'query_root', weekday_window: Array<{ __typename?: 'weekday_window', id: number, weekday?: number | null, weekday_window_districts: Array<{ __typename?: 'weekday_window_district', district?: { __typename?: 'district', id: string, name?: string | null } | null }> }> };

export type GetDriversListQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetDriversListQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, name: string }> };

export type GetDriverWindowSlotsQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
}>;


export type GetDriverWindowSlotsQuery = { __typename?: 'query_root', driver_window: Array<{ __typename?: 'driver_window', id: number, timeDuration?: string | null, weekday_windows: Array<{ __typename?: 'weekday_window', id: number, weekday?: number | null, weekend?: boolean | null, weekday_window_districts: Array<{ __typename?: 'weekday_window_district', id: number, tempDateFrom?: any | null, tempDateTo?: any | null, districtId?: string | null, district?: { __typename?: 'district', id: string, name?: string | null, enabled?: boolean | null, district_delivery_providers: Array<{ __typename?: 'district_delivery_providers', delivery_provider_id: any }> } | null }>, window_delivery_providers: Array<{ __typename?: 'window_delivery_providers', provider_id: any, delivery_provider: { __typename?: 'delivery_provider', id: any, short_name: string, display_name: string } }> }> }> };

export type InsertDriverWindowSlotMutationVariables = Exact<{
  driverId: Scalars['String']['input'];
  timeDuration: Scalars['String']['input'];
}>;


export type InsertDriverWindowSlotMutation = { __typename?: 'mutation_root', insert_driver_window_one?: { __typename?: 'driver_window', id: number, timeDuration?: string | null } | null };

export type InsertWeekdayWindowMutationVariables = Exact<{
  objects: Array<Weekday_Window_Insert_Input> | Weekday_Window_Insert_Input;
}>;


export type InsertWeekdayWindowMutation = { __typename?: 'mutation_root', insert_weekday_window?: { __typename?: 'weekday_window_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window', weekday?: number | null, id: number, driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null }> } | null };

export type InsertWeekdayWindowDistrictsMutationVariables = Exact<{
  objects: Array<Weekday_Window_District_Insert_Input> | Weekday_Window_District_Insert_Input;
}>;


export type InsertWeekdayWindowDistrictsMutation = { __typename?: 'mutation_root', insert_weekday_window_district?: { __typename?: 'weekday_window_district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null } | null }> } | null };

export type RemoveDriverWindowSlotMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveDriverWindowSlotMutation = { __typename?: 'mutation_root', delete_driver_window_by_pk?: { __typename?: 'driver_window', id: number, driverId?: string | null } | null };

export type RemoveWeekdayWindowDistrictsMutationVariables = Exact<{
  districtId: Scalars['String']['input'];
  weekdayWindowIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type RemoveWeekdayWindowDistrictsMutation = { __typename?: 'mutation_root', delete_weekday_window_district?: { __typename?: 'weekday_window_district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null } | null }> } | null };

export type RemoveWeekdayWindowDistrictsListMutationVariables = Exact<{
  districtIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  weekdayWindowId: Scalars['Int']['input'];
}>;


export type RemoveWeekdayWindowDistrictsListMutation = { __typename?: 'mutation_root', delete_weekday_window_district?: { __typename?: 'weekday_window_district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null } | null }> } | null };

export type RemoveWeekdayWindowDistrictsByWindowIdMutationVariables = Exact<{
  driverWindowId: Scalars['Int']['input'];
}>;


export type RemoveWeekdayWindowDistrictsByWindowIdMutation = { __typename?: 'mutation_root', delete_weekday_window_district?: { __typename?: 'weekday_window_district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null } | null }> } | null };

export type RemoveWeekdayWindowsMutationVariables = Exact<{
  driverWindowId: Scalars['Int']['input'];
}>;


export type RemoveWeekdayWindowsMutation = { __typename?: 'mutation_root', delete_weekday_window?: { __typename?: 'weekday_window_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null } | null }> } | null };

export type UpdateDriverWindowSlotMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  timeDuration: Scalars['String']['input'];
}>;


export type UpdateDriverWindowSlotMutation = { __typename?: 'mutation_root', update_driver_window_by_pk?: { __typename?: 'driver_window', id: number, timeDuration?: string | null, driverId?: string | null } | null };

export type GetCountryHolidaysByDepartmentIdQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
}>;


export type GetCountryHolidaysByDepartmentIdQuery = { __typename?: 'query_root', country_holiday: Array<{ __typename?: 'country_holiday', date: any, id: number }> };

export type InsertDriverWindowsMutationVariables = Exact<{
  objects: Array<Driver_Window_Insert_Input> | Driver_Window_Insert_Input;
}>;


export type InsertDriverWindowsMutation = { __typename?: 'mutation_root', insert_driver_window?: { __typename?: 'driver_window_mutation_response', affected_rows: number } | null };

export type InsertWindowDeliveryProvidersMutationVariables = Exact<{
  objects: Array<Window_Delivery_Providers_Insert_Input> | Window_Delivery_Providers_Insert_Input;
}>;


export type InsertWindowDeliveryProvidersMutation = { __typename?: 'mutation_root', insert_window_delivery_providers?: { __typename?: 'window_delivery_providers_mutation_response', affected_rows: number } | null };

export type DeleteWindowDeliveryProvidersMutationVariables = Exact<{
  windowId: Scalars['Int']['input'];
}>;


export type DeleteWindowDeliveryProvidersMutation = { __typename?: 'mutation_root', delete_window_delivery_providers?: { __typename?: 'window_delivery_providers_mutation_response', affected_rows: number } | null };

export type DeleteWindowDeliveryProvidersByDriverWindowMutationVariables = Exact<{
  driverWindowId: Scalars['Int']['input'];
}>;


export type DeleteWindowDeliveryProvidersByDriverWindowMutation = { __typename?: 'mutation_root', delete_window_delivery_providers?: { __typename?: 'window_delivery_providers_mutation_response', affected_rows: number } | null };

export type DeleteWindowDeliveryProvidersBatchMutationVariables = Exact<{
  windowIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type DeleteWindowDeliveryProvidersBatchMutation = { __typename?: 'mutation_root', delete_window_delivery_providers?: { __typename?: 'window_delivery_providers_mutation_response', affected_rows: number } | null };

export type UpdateDeliveryAreasFromGeoMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type UpdateDeliveryAreasFromGeoMutation = { __typename?: 'mutation_root', updateDeliveryAreasFromGeo?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type UpdateDistrictLoadFactorMutationVariables = Exact<{
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictLoadFactorMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'district', departments_districts: Array<{ __typename?: 'departments_districts', departmentId: number }> }> } | null };

export type UpdateDistrictDeliveryDaysMutationVariables = Exact<{
  deliveryDays?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictDeliveryDaysMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'district', departments_districts: Array<{ __typename?: 'departments_districts', departmentId: number }> }> } | null };

export type UpdateDistrictOffDaysMutationVariables = Exact<{
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictOffDaysMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'district', departments_districts: Array<{ __typename?: 'departments_districts', departmentId: number }> }> } | null };

export type GetDistrictsDriverListQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDistrictsDriverListQuery = { __typename?: 'query_root', district: Array<{ __typename?: 'district', loadFactor?: number | null, deliveryDays?: number | null, id: string, enabled?: boolean | null, name?: string | null, offDays?: any | null, cutoffHours?: number | null, isPolygone?: boolean | null, district_delivery_providers: Array<{ __typename?: 'district_delivery_providers', delivery_provider_id: any }>, weekday_window_districts: Array<{ __typename?: 'weekday_window_district', weekday_window?: { __typename?: 'weekday_window', driver_window?: { __typename?: 'driver_window', driverId?: string | null, id: number, user?: { __typename?: 'user', blocked: boolean, name: string } | null } | null } | null }> }> };

export type UpdateCutoffHoursMutationVariables = Exact<{
  districtId: Scalars['String']['input'];
  hours: Scalars['Int']['input'];
}>;


export type UpdateCutoffHoursMutation = { __typename?: 'mutation_root', update_district_by_pk?: { __typename?: 'district', id: string } | null };

export type GetAvailableProvidersQueryVariables = Exact<{
  countryId: Scalars['String']['input'];
}>;


export type GetAvailableProvidersQuery = { __typename?: 'query_root', delivery_provider: Array<{ __typename?: 'delivery_provider', id: any, short_name: string, display_name: string }> };

export type ChangeDistrictProvidersMutationVariables = Exact<{
  districtId: Scalars['String']['input'];
  providers: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ChangeDistrictProvidersMutation = { __typename?: 'mutation_root', changeDistrictProviders?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type GetDriverHolidaysQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetDriverHolidaysQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', driver_holidays: Array<{ __typename?: 'driver_holiday', forced?: boolean | null, date: any, id: number }> } | null };

export type InsertDriverHolidayMutationVariables = Exact<{
  forced: Scalars['Boolean']['input'];
  driverId: Scalars['String']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type InsertDriverHolidayMutation = { __typename?: 'mutation_root', insert_driver_holiday_one?: { __typename?: 'driver_holiday', id: number } | null };

export type DeleteDriverHolidayMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDriverHolidayMutation = { __typename?: 'mutation_root', delete_driver_holiday_by_pk?: { __typename?: 'driver_holiday', id: number, driverId: string } | null };

export type GetDriversWithDistrictsLegacyQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDriversWithDistrictsLegacyQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, name: string, driver_districts: Array<{ __typename?: 'driver_district', id: number, district: { __typename?: 'district', id: string, enabled?: boolean | null, name?: string | null } }> }>, district: Array<{ __typename?: 'district', id: string, name?: string | null, enabled?: boolean | null }> };

export type GetDistrictsWithDriversLegacyQueryVariables = Exact<{
  departmentId: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDistrictsWithDriversLegacyQuery = { __typename?: 'query_root', district: Array<{ __typename?: 'district', id: string, name?: string | null, enabled?: boolean | null, loadFactor?: number | null, deliveryDays?: number | null, offDays?: any | null, driver_districts: Array<{ __typename?: 'driver_district', driverId: string, driver: { __typename?: 'user', name: string } }> }> };

export type InsertDriverDistrictLegacyMutationVariables = Exact<{
  driverId: Scalars['String']['input'];
  districtId: Scalars['String']['input'];
}>;


export type InsertDriverDistrictLegacyMutation = { __typename?: 'mutation_root', insert_driver_district_one?: { __typename?: 'driver_district', id: number } | null };

export type DeleteDriverDistrictLegacyMutationVariables = Exact<{
  districtId: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
}>;


export type DeleteDriverDistrictLegacyMutation = { __typename?: 'mutation_root', delete_driver_district?: { __typename?: 'driver_district_mutation_response', affected_rows: number } | null };

export type UpdateDistrictLoadFactorLegacyMutationVariables = Exact<{
  loadFactor?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictLoadFactorLegacyMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number } | null };

export type UpdateDistrictDeliveryDaysLegacyMutationVariables = Exact<{
  deliveryDays?: InputMaybe<Scalars['Int']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictDeliveryDaysLegacyMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number } | null };

export type UpdateDistrictOffDaysLegacyMutationVariables = Exact<{
  offDays?: InputMaybe<Scalars['jsonb']['input']>;
  districtId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDistrictOffDaysLegacyMutation = { __typename?: 'mutation_root', update_district?: { __typename?: 'district_mutation_response', affected_rows: number } | null };

export type GetDriversWithLastTrackPointQueryVariables = Exact<{
  dateFrom: Scalars['timestamptz']['input'];
  dateTo: Scalars['timestamptz']['input'];
  departmentId: Scalars['Int']['input'];
  deliveredNew?: InputMaybe<Scalars['jsonb']['input']>;
  rescheduleNew?: InputMaybe<Scalars['jsonb']['input']>;
  returnNew?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type GetDriversWithLastTrackPointQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', name: string, id: string, email?: string | null, delivered: { __typename?: 'order_change_aggregate', aggregate?: { __typename?: 'order_change_aggregate_fields', count: number } | null }, rescheduled: { __typename?: 'order_change_aggregate', aggregate?: { __typename?: 'order_change_aggregate_fields', count: number } | null }, returned: { __typename?: 'order_change_aggregate', aggregate?: { __typename?: 'order_change_aggregate_fields', count: number } | null }, track_points: Array<{ __typename?: 'track_point', time: any, lng: any, lat: any, id: number, batteryLevel?: string | null }>, orders: Array<{ __typename?: 'order', id: number, plannedDate?: any | null, plannedDateDuration?: number | null, createdAt: any, statusName: string, delivery_provider?: { __typename?: 'delivery_provider', short_name: string, display_name: string } | null }> }> };

export type GetDriversWithAddressByDateQueryVariables = Exact<{
  id: Scalars['String']['input'];
  dateFrom: Scalars['timestamptz']['input'];
  dateTo: Scalars['timestamptz']['input'];
  departmentId: Scalars['Int']['input'];
}>;


export type GetDriversWithAddressByDateQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, name: string, email?: string | null, orders: Array<{ __typename?: 'order', id: number, shortCode?: string | null, plannedDate?: any | null, plannedDateDuration?: number | null, statusName: string, totalCents: number, createdAt: any, client: { __typename?: 'client', id: number, fullname: string, address?: { __typename?: 'address', city: string, comments?: string | null, country?: string | null, district?: string | null, lat?: any | null, lng?: any | null, street?: string | null, state?: string | null, id: number } | null }, positions: Array<{ __typename?: 'order_position', totalPrice?: number | null, quantity: number, product: { __typename?: 'product', name: string } }>, delivery_provider?: { __typename?: 'delivery_provider', short_name: string, display_name: string } | null }> }> };

export type GetClientPhoneQueryVariables = Exact<{
  clientId: Scalars['Int']['input'];
}>;


export type GetClientPhoneQuery = { __typename?: 'query_root', getClientPhone?: { __typename?: 'ClientPhoneResponse', phone: string } | null };

export type GetDriverTrackPointsQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
  dateFrom: Scalars['timestamptz']['input'];
  dateTo: Scalars['timestamptz']['input'];
}>;


export type GetDriverTrackPointsQuery = { __typename?: 'query_root', track_point: Array<{ __typename?: 'track_point', id: number, lat: any, lng: any, time: any }> };

export type GetDriverOrderChangesQueryVariables = Exact<{
  driverId: Scalars['String']['input'];
  dateFrom: Scalars['timestamptz']['input'];
  dateTo: Scalars['timestamptz']['input'];
}>;


export type GetDriverOrderChangesQuery = { __typename?: 'query_root', order_change: Array<{ __typename?: 'order_change', id: any, orderId?: number | null, old: any, new: any, createdAt: any, geo_event?: { __typename?: 'geo_event', id: number, lat: any, lng: any, createdAt: any } | null }> };

export type DeleteUserDepartmentsMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteUserDepartmentsMutation = { __typename?: 'mutation_root', delete_departments_users?: { __typename?: 'departments_users_mutation_response', affected_rows: number } | null };

export type InsertUserDepartmentsMutationVariables = Exact<{
  objects: Array<Departments_Users_Insert_Input> | Departments_Users_Insert_Input;
}>;


export type InsertUserDepartmentsMutation = { __typename?: 'mutation_root', insert_departments_users?: { __typename?: 'departments_users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'departments_users', id: number, departmentId: number, userId: string }> } | null };

export type GetUsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<User_Bool_Exp>;
  sorters: Array<User_Order_By> | User_Order_By;
}>;


export type GetUsersQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', blocked: boolean, createdAt: any, email?: string | null, id: string, name: string, roles: any, firebaseMessagingToken?: string | null, telegramName?: string | null, login_logs: Array<{ __typename?: 'login_log', device: string, appVersion: string }>, departments_users: Array<{ __typename?: 'departments_users', id: number, departmentId: number, department: { __typename?: 'department', id: number, name: string } }> }>, user_aggregate: { __typename?: 'user_aggregate', aggregate?: { __typename?: 'user_aggregate_fields', count: number } | null } };

export type GetUserMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserMetaQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', role: string }>, department: Array<{ __typename?: 'department', id: number, name: string }> };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
  departmentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  departmentId: Scalars['Int']['input'];
  metadata: Scalars['jsonb']['input'];
  telegramName: Scalars['String']['input'];
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', createUser?: { __typename?: 'DartAPIResponse', userKey: string } | null };

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type BlockUserMutation = { __typename?: 'mutation_root', blockUser?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type EditUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  user: UserEditInput;
}>;


export type EditUserMutation = { __typename?: 'mutation_root', editUser?: { __typename?: 'ApplyResponse', applied: boolean } | null };

export type UpdateUserTelegramMutationVariables = Exact<{
  id: Scalars['String']['input'];
  telegramName: Scalars['String']['input'];
}>;


export type UpdateUserTelegramMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: string, telegramName?: string | null } | null };


export const ReplaceUserFcmTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplaceUserFCMToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FCMInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replaceUserFCMToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<ReplaceUserFcmTokenMutation, ReplaceUserFcmTokenMutationVariables>;
export const RemoveUserFcmTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserFcmToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFcmToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<RemoveUserFcmTokenMutation, RemoveUserFcmTokenMutationVariables>;
export const InsertOrderCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOrderComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_order_comments_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"StringValue","value":"dtk_admin","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"authorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"authorId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}}]} as unknown as DocumentNode<InsertOrderCommentMutation, InsertOrderCommentMutationVariables>;
export const EditOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"umbrellaID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}},{"kind":"Argument","name":{"kind":"Name","value":"umbrellaID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"umbrellaID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderItems"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPrice"}}]}}]}}]} as unknown as DocumentNode<EditOrderMutation, EditOrderMutationVariables>;
export const UpdateOrderViaActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderViaAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderPatch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ClientPatch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressPatch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderViaActionMutation, UpdateOrderViaActionMutationVariables>;
export const CalcOrderPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalcOrderPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"umbrellaID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItemInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recalcOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}},{"kind":"Argument","name":{"kind":"Name","value":"umbrellaID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"umbrellaID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderItems"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItems"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderItems"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryPrice"}}]}}]}}]} as unknown as DocumentNode<CalcOrderPriceQuery, CalcOrderPriceQueryVariables>;
export const InsertUserViewsLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserViewsLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_views_log"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertUserViewsLogMutation, InsertUserViewsLogMutationVariables>;
export const GetOrderCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorId"}},{"kind":"Field","name":{"kind":"Name","value":"externalAuthor"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderCommentsQuery, GetOrderCommentsQueryVariables>;
export const GetOrderHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_change"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"editor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"old"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_change_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"driver_order_interaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contact_type"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_views_log"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrderHistoryQuery, GetOrderHistoryQueryVariables>;
export const GetOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"order_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorters"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"order_order_by"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"isSaved"}},{"kind":"Field","name":{"kind":"Name","value":"resale"}},{"kind":"Field","name":{"kind":"Name","value":"rescheduleCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status_transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDateDuration"}},{"kind":"Field","name":{"kind":"Name","value":"deliveredDate"}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"fullname"}},{"kind":"Field","name":{"kind":"Name","value":"districtId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMeta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetMetaQuery, GetMetaQueryVariables>;
export const GetBlockedDriversDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBlockedDrivers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}}]}}]} as unknown as DocumentNode<GetBlockedDriversQuery, GetBlockedDriversQueryVariables>;
export const GetStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ordersWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"order_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orders_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ordersWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"DriverAssignedExpress"},"name":{"kind":"Name","value":"order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"ordersWhere"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DriverAssigned","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"delivery_provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"short_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DTK_EXPRESS","block":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"DriverConfirmedExpress"},"name":{"kind":"Name","value":"order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"ordersWhere"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DriverConfirmed","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"delivery_provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"short_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DTK_EXPRESS","block":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"DriverOnTheWayExpress"},"name":{"kind":"Name","value":"order_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"ordersWhere"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DriverOnTheWay","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"delivery_provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"short_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DTK_EXPRESS","block":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetStatusesQuery, GetStatusesQueryVariables>;
export const GetOrderByIdWithDriversWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderByIdWithDriversWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"isSaved"}},{"kind":"Field","name":{"kind":"Name","value":"resale"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"umbrellaID"}},{"kind":"Field","name":{"kind":"Name","value":"vendorDatalinkId"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"reasonRefusal"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order_photos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadURL"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status_transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDateDuration"}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"productID"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_changes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"fullname"}},{"kind":"Field","name":{"kind":"Name","value":"districtId"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetOrderByIdWithDriversWarehousesQuery, GetOrderByIdWithDriversWarehousesQueryVariables>;
export const GetOrderListByIdWithDriversWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderListByIdWithDriversWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status_transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"next"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"plannedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDateDuration"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"fullname"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}}]}}]} as unknown as DocumentNode<GetOrderListByIdWithDriversWarehousesQuery, GetOrderListByIdWithDriversWarehousesQueryVariables>;
export const GetDistrictScheduleAndWorkloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistrictScheduleAndWorkload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plannedDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nextDay"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loadFactor"}},{"kind":"Field","name":{"kind":"Name","value":"weekday_window_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeDuration"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"district_workload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeperiod"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plannedDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nextDay"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeperiod"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districtId"}},{"kind":"Field","name":{"kind":"Name","value":"loadFactor"}},{"kind":"Field","name":{"kind":"Name","value":"timeperiod"}},{"kind":"Field","name":{"kind":"Name","value":"workload"}}]}}]}}]} as unknown as DocumentNode<GetDistrictScheduleAndWorkloadQuery, GetDistrictScheduleAndWorkloadQueryVariables>;
export const GetDriversWorkloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriversWorkload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startOfWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endOfWeek"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_workload_for"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"district_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeperiod"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startOfWeek"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endOfWeek"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeperiod"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workload"}},{"kind":"Field","name":{"kind":"Name","value":"timeperiod"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]} as unknown as DocumentNode<GetDriversWorkloadQuery, GetDriversWorkloadQueryVariables>;
export const GetPaymentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetPaymentTypesQuery, GetPaymentTypesQueryVariables>;
export const ExpressNewOrdersMultiQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpressNewOrdersMultiQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"New","block":false},{"kind":"StringValue","value":"DriverAssigned","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"delivery_provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"short_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"DTK_EXPRESS","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]} as unknown as DocumentNode<ExpressNewOrdersMultiQueryQuery, ExpressNewOrdersMultiQueryQueryVariables>;
export const NewReadyAndPickedOrdersMultiQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewReadyAndPickedOrdersMultiQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statusName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ReadyPicking","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<NewReadyAndPickedOrdersMultiQueryQuery, NewReadyAndPickedOrdersMultiQueryQueryVariables>;
export const GetCountriesByDepartmentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountriesByDepartmentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCountriesByDepartmentIdQuery, GetCountriesByDepartmentIdQueryVariables>;
export const GetUserDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"department"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"is_express_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"disabled_express_reason"}}]}}]}}]} as unknown as DocumentNode<GetUserDepartmentsQuery, GetUserDepartmentsQueryVariables>;
export const GetCurrentUserDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryId"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"is_express_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"disabled_express_reason"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserDepartmentsQuery, GetCurrentUserDepartmentsQueryVariables>;
export const ToggleDepartmentExpressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleDepartmentExpress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToggleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleDepartmentExpress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ToggleDepartmentExpressMutation, ToggleDepartmentExpressMutationVariables>;
export const GetCountryListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountryList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country_holidays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCountryListQuery, GetCountryListQueryVariables>;
export const InsertCountryHolidayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCountryHoliday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_country_holiday_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"countryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertCountryHolidayMutation, InsertCountryHolidayMutationVariables>;
export const DeleteCountryHolidayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCountryHoliday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_country_holiday_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCountryHolidayMutation, DeleteCountryHolidayMutationVariables>;
export const InsertDriverDistrictOldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDriverDistrictOld"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_driver_district_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertDriverDistrictOldMutation, InsertDriverDistrictOldMutationVariables>;
export const DeleteDriverDistrictOldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDriverDistrictOld"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_driver_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDriverDistrictOldMutation, DeleteDriverDistrictOldMutationVariables>;
export const GetDriversDistrictListByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriversDistrictListById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"driver_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDriversDistrictListByIdQuery, GetDriversDistrictListByIdQueryVariables>;
export const GetDriversDistrictListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriversDistrictList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments_districts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isPolygone"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"district_delivery_providers"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPolygone"}},{"kind":"Field","name":{"kind":"Name","value":"districts_coordinates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}}]} as unknown as DocumentNode<GetDriversDistrictListQuery, GetDriversDistrictListQueryVariables>;
export const GetWeekdayWindowForSlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWeekdayWindowForSlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"weekday_window_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWeekdayWindowForSlotQuery, GetWeekdayWindowForSlotQueryVariables>;
export const GetWeekdayWindowsAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWeekdayWindowsAll"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driver_window"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"weekday_window_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWeekdayWindowsAllQuery, GetWeekdayWindowsAllQueryVariables>;
export const GetDriversListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDriversList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDriversListQuery, GetDriversListQueryVariables>;
export const GetDriverWindowSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriverWindowSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeDuration"}},{"kind":"Field","name":{"kind":"Name","value":"weekday_windows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"weekend"}},{"kind":"Field","name":{"kind":"Name","value":"weekday_window_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tempDateFrom"}},{"kind":"Field","name":{"kind":"Name","value":"tempDateTo"}},{"kind":"Field","name":{"kind":"Name","value":"districtId"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"district_delivery_providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery_provider_id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"window_delivery_providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider_id"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDriverWindowSlotsQuery, GetDriverWindowSlotsQueryVariables>;
export const InsertDriverWindowSlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDriverWindowSlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeDuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_driver_window_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"timeDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeDuration"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeDuration"}}]}}]}}]} as unknown as DocumentNode<InsertDriverWindowSlotMutation, InsertDriverWindowSlotMutationVariables>;
export const InsertWeekdayWindowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertWeekdayWindow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"weekday_window_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_weekday_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertWeekdayWindowMutation, InsertWeekdayWindowMutationVariables>;
export const InsertWeekdayWindowDistrictsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertWeekdayWindowDistricts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"weekday_window_district_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_weekday_window_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"weekday_window_district_weekdayWindowId_districtId_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"tempDateFrom"},{"kind":"EnumValue","value":"tempDateTo"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertWeekdayWindowDistrictsMutation, InsertWeekdayWindowDistrictsMutationVariables>;
export const RemoveDriverWindowSlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDriverWindowSlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_driver_window_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]} as unknown as DocumentNode<RemoveDriverWindowSlotMutation, RemoveDriverWindowSlotMutationVariables>;
export const RemoveWeekdayWindowDistrictsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveWeekdayWindowDistricts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekdayWindowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_weekday_window_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"weekdayWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekdayWindowIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveWeekdayWindowDistrictsMutation, RemoveWeekdayWindowDistrictsMutationVariables>;
export const RemoveWeekdayWindowDistrictsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveWeekdayWindowDistrictsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weekdayWindowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_weekday_window_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"weekdayWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weekdayWindowId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveWeekdayWindowDistrictsListMutation, RemoveWeekdayWindowDistrictsListMutationVariables>;
export const RemoveWeekdayWindowDistrictsByWindowIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveWeekdayWindowDistrictsByWindowId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_weekday_window_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weekday_window"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveWeekdayWindowDistrictsByWindowIdMutation, RemoveWeekdayWindowDistrictsByWindowIdMutationVariables>;
export const RemoveWeekdayWindowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveWeekdayWindows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_weekday_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveWeekdayWindowsMutation, RemoveWeekdayWindowsMutationVariables>;
export const UpdateDriverWindowSlotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDriverWindowSlot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeDuration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_driver_window_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timeDuration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeDuration"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timeDuration"}},{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]} as unknown as DocumentNode<UpdateDriverWindowSlotMutation, UpdateDriverWindowSlotMutationVariables>;
export const GetCountryHolidaysByDepartmentIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCountryHolidaysByDepartmentId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_holiday"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetCountryHolidaysByDepartmentIdQuery, GetCountryHolidaysByDepartmentIdQueryVariables>;
export const InsertDriverWindowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDriverWindows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"driver_window_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_driver_window"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertDriverWindowsMutation, InsertDriverWindowsMutationVariables>;
export const InsertWindowDeliveryProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertWindowDeliveryProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"window_delivery_providers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_window_delivery_providers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"window_delivery_providers_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertWindowDeliveryProvidersMutation, InsertWindowDeliveryProvidersMutationVariables>;
export const DeleteWindowDeliveryProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWindowDeliveryProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"windowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_window_delivery_providers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"window_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteWindowDeliveryProvidersMutation, DeleteWindowDeliveryProvidersMutationVariables>;
export const DeleteWindowDeliveryProvidersByDriverWindowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWindowDeliveryProvidersByDriverWindow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_window_delivery_providers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weekday_window"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverWindowId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverWindowId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteWindowDeliveryProvidersByDriverWindowMutation, DeleteWindowDeliveryProvidersByDriverWindowMutationVariables>;
export const DeleteWindowDeliveryProvidersBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWindowDeliveryProvidersBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"windowIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_window_delivery_providers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"window_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteWindowDeliveryProvidersBatchMutation, DeleteWindowDeliveryProvidersBatchMutationVariables>;
export const UpdateDeliveryAreasFromGeoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeliveryAreasFromGeo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeliveryAreasFromGeo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<UpdateDeliveryAreasFromGeoMutation, UpdateDeliveryAreasFromGeoMutationVariables>;
export const UpdateDistrictLoadFactorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictLoadFactor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loadFactor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loadFactor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loadFactor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictLoadFactorMutation, UpdateDistrictLoadFactorMutationVariables>;
export const UpdateDistrictDeliveryDaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictDeliveryDays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deliveryDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryDays"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictDeliveryDaysMutation, UpdateDistrictDeliveryDaysMutationVariables>;
export const UpdateDistrictOffDaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictOffDays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offDays"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departments_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"departmentId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictOffDaysMutation, UpdateDistrictOffDaysMutationVariables>;
export const GetDistrictsDriverListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistrictsDriverList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments_districts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadFactor"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"offDays"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffHours"}},{"kind":"Field","name":{"kind":"Name","value":"isPolygone"}},{"kind":"Field","name":{"kind":"Name","value":"district_delivery_providers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery_provider_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weekday_window_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"weekday_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDistrictsDriverListQuery, GetDistrictsDriverListQueryVariables>;
export const UpdateCutoffHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCutoffHours"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cutoffHours"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hours"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCutoffHoursMutation, UpdateCutoffHoursMutationVariables>;
export const GetAvailableProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_external"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]} as unknown as DocumentNode<GetAvailableProvidersQuery, GetAvailableProvidersQueryVariables>;
export const ChangeDistrictProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeDistrictProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeDistrictProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"districtId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}},{"kind":"Argument","name":{"kind":"Name","value":"providers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<ChangeDistrictProvidersMutation, ChangeDistrictProvidersMutationVariables>;
export const GetDriverHolidaysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriverHolidays"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driver_holidays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forced"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDriverHolidaysQuery, GetDriverHolidaysQueryVariables>;
export const InsertDriverHolidayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDriverHoliday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forced"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_driver_holiday_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"forced"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forced"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertDriverHolidayMutation, InsertDriverHolidayMutationVariables>;
export const DeleteDriverHolidayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDriverHoliday"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_driver_holiday_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"driverId"}}]}}]}}]} as unknown as DocumentNode<DeleteDriverHolidayMutation, DeleteDriverHolidayMutationVariables>;
export const GetDriversWithDistrictsLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriversWithDistrictsLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blocked"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"driver_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments_districts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"district_delivery_providers"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<GetDriversWithDistrictsLegacyQuery, GetDriversWithDistrictsLegacyQueryVariables>;
export const GetDistrictsWithDriversLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistrictsWithDriversLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departments_districts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"loadFactor"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryDays"}},{"kind":"Field","name":{"kind":"Name","value":"offDays"}},{"kind":"Field","name":{"kind":"Name","value":"driver_districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"driverId"}},{"kind":"Field","name":{"kind":"Name","value":"driver"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDistrictsWithDriversLegacyQuery, GetDistrictsWithDriversLegacyQueryVariables>;
export const InsertDriverDistrictLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDriverDistrictLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_driver_district_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertDriverDistrictLegacyMutation, InsertDriverDistrictLegacyMutationVariables>;
export const DeleteDriverDistrictLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDriverDistrictLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_driver_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"driverId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"districtId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteDriverDistrictLegacyMutation, DeleteDriverDistrictLegacyMutationVariables>;
export const UpdateDistrictLoadFactorLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictLoadFactorLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loadFactor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"loadFactor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loadFactor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictLoadFactorLegacyMutation, UpdateDistrictLoadFactorLegacyMutationVariables>;
export const UpdateDistrictDeliveryDaysLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictDeliveryDaysLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveryDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deliveryDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveryDays"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictDeliveryDaysLegacyMutation, UpdateDistrictDeliveryDaysLegacyMutationVariables>;
export const UpdateDistrictOffDaysLegacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDistrictOffDaysLegacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_district"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"districtId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offDays"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateDistrictOffDaysLegacyMutation, UpdateDistrictOffDaysLegacyMutationVariables>;
export const GetDriversWithLastTrackPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriversWithLastTrackPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliveredNew"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rescheduleNew"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnNew"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"orders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannedDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delivered"},"name":{"kind":"Name","value":"order_changes_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"new"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliveredNew"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rescheduled"},"name":{"kind":"Name","value":"order_changes_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"new"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rescheduleNew"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"returned"},"name":{"kind":"Name","value":"order_changes_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"new"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnNew"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"track_points"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"time"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"time"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannedDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannedDate"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDateDuration"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDriversWithLastTrackPointQuery, GetDriversWithLastTrackPointQueryVariables>;
export const GetDriversWithAddressByDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriversWithAddressByDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"StringValue","value":"driver","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"departments_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannedDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"plannedDate"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortCode"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDate"}},{"kind":"Field","name":{"kind":"Name","value":"plannedDateDuration"}},{"kind":"Field","name":{"kind":"Name","value":"statusName"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullname"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"district"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery_provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"short_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDriversWithAddressByDateQuery, GetDriversWithAddressByDateQueryVariables>;
export const GetClientPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClientPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClientPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode<GetClientPhoneQuery, GetClientPhoneQueryVariables>;
export const GetDriverTrackPointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriverTrackPoints"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"track_point"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userID"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"time"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"time"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]} as unknown as DocumentNode<GetDriverTrackPointsQuery, GetDriverTrackPointsQueryVariables>;
export const GetDriverOrderChangesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDriverOrderChanges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_change"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"editorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"driverId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"new"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_has_key"},"value":{"kind":"StringValue","value":"statusName","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"old"}},{"kind":"Field","name":{"kind":"Name","value":"new"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"geo_event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetDriverOrderChangesQuery, GetDriverOrderChangesQueryVariables>;
export const DeleteUserDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_departments_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteUserDepartmentsMutation, DeleteUserDepartmentsMutationVariables>;
export const InsertUserDepartmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserDepartments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"departments_users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_departments_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUserDepartmentsMutation, InsertUserDepartmentsMutationVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sorters"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_order_by"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sorters"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocked"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"firebaseMessagingToken"}},{"kind":"Field","name":{"kind":"Name","value":"telegramName"}},{"kind":"Field","name":{"kind":"Name","value":"login_logs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastSeenAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"}},{"kind":"Field","name":{"kind":"Name","value":"appVersion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"departments_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"departmentId"}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserMetaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"role"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUserMetaQuery, GetUserMetaQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"roles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"telegramName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"roles"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"departmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"departmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"telegramName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"telegramName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userKey"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const BlockUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BlockUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<BlockUserMutation, BlockUserMutationVariables>;
export const EditUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applied"}}]}}]}}]} as unknown as DocumentNode<EditUserMutation, EditUserMutationVariables>;
export const UpdateUserTelegramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserTelegram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"telegramName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"telegramName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"telegramName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"telegramName"}}]}}]}}]} as unknown as DocumentNode<UpdateUserTelegramMutation, UpdateUserTelegramMutationVariables>;